<template>
<div>
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <onaydialog ref="onaydialog"></onaydialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <tahsilatdialog1 ref="tahsilatdialog1" @kurHesapla="tutarEkle($event)" v-model="BiletAyrintiliOdeme"></tahsilatdialog1>
    <snackbarcomp v-bind:mesaj="text1" ref="showMessage" v-model="snackbar"></snackbarcomp>

    <v-form>
        <v-card flat="">
            <v-layout row wrap>
                <v-flex xs12 sm12>
                    <v-toolbar size="120px" dark color="info">
                        <v-toolbar-title>{{ $t('Ticket-Sales') }} </v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-tooltip bottom>
                            <v-btn :disabled="!sayfayetki.Save" v-if="kaydetbuton" slot="activator"  @click="checkCounter()" flat>
                                <span class="hidden-sm-and-down"> {{$t("save_button")}}
                                </span>
                                <v-icon right dark>add_box</v-icon>
                            </v-btn>
                            <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                            <span v-if="sayfayetki.Save">{{$t("save_button")}}</span>
                        </v-tooltip>

                        <v-tooltip bottom>
                            <v-btn v-if="guncellebtngorunum" :disabled="!sayfayetki.Update && !guncellebuton" slot="activator" @click="checkCounter()" flat>
                                <span class="hidden-sm-and-down"> {{ $t('Update') }}</span>

                                <v-icon right dark>create</v-icon>
                            </v-btn>
                            <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                            <span v-if="sayfayetki.Update">{{ $t('Update') }}</span>
                        </v-tooltip>

                        <v-btn v-if="voidiptalbtn" @click="voidiptal()" class="white--text" flat> <span class="hidden-sm-and-down">
                               {{$t('Cancel-Void')}} </span>
                            <v-icon right dark>clear</v-icon>
                        </v-btn>
                        <v-btn @click="biletyazdir()" v-if="faturanovarise" icon>
                            <v-icon>print</v-icon>
                        </v-btn>
                        <v-menu offset-y>
                            <v-btn slot="activator" dark icon>
                                <v-icon>more_vert</v-icon>
                            </v-btn>
                            <v-list>

                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" v-if="voidbtn" :disabled="!sayfayetki.Update" @click="voidyap()">
                                        <v-list-tile-title> {{ $t('Make-it-Void') }} </v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update"> {{ $t('Make-it-Void') }} </span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" v-if="guncellebtngorunum" :disabled="!sayfayetki.Delete" @click="biletsilsor()">
                                        <v-list-tile-title>{{$t('Delete-Ticket')}}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Delete">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Delete">{{$t('Delete-Ticket')}}</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" v-if="!faturabtn && faturalansinmi==true" :disabled="!sayfayetki.Update" @click="faturadialogac()">
                                        <v-list-tile-title>{{$t('Bill')}}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{$t('Bill')}}</span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" v-if="faturanovarise" @click="faturaEBDuzenle()">
                                        <v-list-tile-title>Fatura Edilmiş Bilet Değişiklik</v-list-tile-title>
                                    </v-list-tile>
                                    <span>Fatura Edilmiş Bilet Değişiklik</span>

                                </v-tooltip>

                                <!--
                  <v-list-tile :disabled="faturabtn" @click="faturadialogac()">
                    <v-list-tile-title>{{$t('Bill')}}</v-list-tile-title>
                  </v-list-tile> -->

                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" v-if="iadebtn" :disabled="!sayfayetki.Update" @click="yeniiadeekle()">
                                        <v-list-tile-title>{{ $t('Add-v2', { value: $t('Refund')}) }}    </v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{ $t('Add-v2', { value: $t('Refund')}) }} </span>
                                </v-tooltip>

                                <v-tooltip bottom>
                                    <v-list-tile slot="activator" v-if="guncellebtngorunum" :disabled="!sayfayetki.Update" @click="hykoddegistir()">
                                        <v-list-tile-title>{{$t('Change-Airline-Code')}}</v-list-tile-title>
                                    </v-list-tile>
                                    <span v-if="!sayfayetki.Update">{{ $t('Limited-Authorization') }}</span>
                                    <span v-if="sayfayetki.Update">{{$t('Change-Airline-Code')}}</span>
                                </v-tooltip>

                            </v-list>
                        </v-menu>
                    </v-toolbar>
                </v-flex>
                <v-layout>
                    <v-flex sm12 md12>
                        <v-card>
                            <v-list two-line>
                                <v-layout row wrap>

                                    <v-flex sm12 md1 sm1>
                                        <v-card flat="">
                                            <v-list-tile>
                                                <v-img :src="getImgUrl(Bilet.GenelBilgileri.HavaYoluKodu)" height="100%" width="100%" contain>
                                                </v-img>
                                            </v-list-tile>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 sm3 md3>
                                        <v-layout align-center justify-start row fill-height>
                                            <v-card flat="">
                                                <v-list-tile>
                                                    <v-list-tile-content>
                                                        <v-layout row align-start wrap justify-start>
                                                            <v-flex xs12 sm12 md12>
                                                                <div class="font-weight-bold grey--text subheading ">
                                                                    <v-chip v-if="Bilet.GenelBilgileri.UcusTipi=='I'" small color="green" text-color="white"> {{ $t('Domestic-Line') }}
                                                                    </v-chip>
                                                                    <v-chip v-if="Bilet.GenelBilgileri.UcusTipi=='D'" small color="info" text-color="white">{{ $t('International-Line') }} </v-chip>
                                                                       
                                                                    <v-chip v-if="Bilet.GenelBilgileri.UcusTipi=='B'" small color="orange" text-color="white">BSP </v-chip>
                                                                    -{{Bilet.GenelBilgileri.Formno}}-{{Bilet.GenelBilgileri.BiletNo}}-{{Bilet.GenelBilgileri.HavaYoluKodu}}
                                                                </div>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12>
                                                                <div class="font-weight-   grey--text body-1 ">
                                                                   {{$t('Invoice-Series-No')}}: {{Bilet.FaturaBilgileri.FaturaSeri}}
                                                                    {{Bilet.FaturaBilgileri.FaturaNo}}
                                                                </div>
                                                                <div class="font-weight- grey--text body-1 ">
                                                                   {{$t('Invoice-Date')}}: {{Bilet.FaturaBilgileri.FaturaTarihi | dateformat}}

                                                                </div>
                                                            </v-flex>
                                                        </v-layout>

                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-card>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm6 md6>
                                        <v-layout align-center justify-start row fill-height>
                                            <v-card flat="">
                                                <v-list-tile>
                                                    <v-list-tile-content>
                                                        <v-layout row align-start wrap justify-start>
                                                            <v-flex v-if="faturanovarise" xs12 sm12 md12>

                                                                <v-chip small color="green" outlined>
                                                                    <v-icon color="white" left>check_circle</v-icon>
                                                                    <div class=" white--text  ">Fatura edilmiştir </div>
                                                                </v-chip>
                                                            </v-flex>

                                                            <v-flex v-if="faturanovarise==false && faturalansinmi==false" xs12 sm12 md12>
                                                                <v-chip small color="red" outlined>
                                                                    <v-icon color="white" left>not_interested</v-icon>
                                                                    <div class=" white--text  ">{{$t('This-ticket-will-not-be-billed')}}</div>
                                                                </v-chip>
                                                            </v-flex>

                                                            <v-flex v-if="Bilet.GenelBilgileri.OpenBilet" xs12 sm12 md12>
                                                                <v-chip small color="orange" outlined>
                                                                    <v-icon color="white" left>check_circle</v-icon>
                                                                    <div class=" white--text  ">Açık bilet</div>
                                                                </v-chip>
                                                            </v-flex>
                                                            <v-flex xs12 sm12 md12>
                                                                <div class="font-weight-bold red--text subheading ">{{baslik_mesaji}} </div>
                                                            </v-flex>

                                                        </v-layout>

                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </v-card>
                                        </v-layout>
                                    </v-flex>

                                    <v-flex xs12 sm2 md2>
                                        <v-layout justify-center="" align-center="" fill-height="">
                                            <v-layout justify-center="" column="" fill-height="">
                                                <v-flex xs12 sm12 md12>
                                                    <v-layout justify-center="">
                                                        <v-card flat="" class="white--text">
                                                            <v-card-actions class="pa-3">
                                                                <v-layout row wrap justify-center="">
                                                                    <v-flex xs12 sm12 md12>
                                                                        <v-layout justify-center="">
                                                                            <span class="headline red--text font-weight-">
                                                                                {{Bilet.TutarBilgileri.NetTutar.NetTutar | moneyformat}}{{getparabirimi()}}
                                                                                <v-icon medum @click="dialogtahsilatdag()" v-if="Bilet.GenelBilgileri.Status=='S' || Bilet.GenelBilgileri.Status==null" color="green">exposure</v-icon>
                                                                            </span>

                                                                           
                                                                        </v-layout>
                                                                          <v-layout v-if="Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz>0"  row wrap justify-center="">
                                                                                        <div class="font-weight red--text caption ">
                                                                                            {{Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz }}
                                                                                            {{Bilet.TutarBilgileri.Doviz.DovizKod}}
                                                                                        </div>
                                                                                    </v-layout>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm12 md12>
                                                                        <v-divider></v-divider>
                                                                    </v-flex>
                                                                    <v-flex pt-1 xs12 sm12 md12>
                                                                        <v-layout align-start fill-height justify-center="">

                                                                            <span class="subheading grey--text ">
                                                                                {{$t('totalamount')}}
                                                                            </span>

                                                                        </v-layout>
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-spacer></v-spacer>
                                                            </v-card-actions>
                                                        </v-card>
                                                    </v-layout>
                                                </v-flex>
                                            </v-layout>
                                        </v-layout>
                                    </v-flex>

                                </v-layout>
                            </v-list>
                        </v-card>
                    </v-flex>

                </v-layout>
                <v-tabs v-if="bekletme" style="width:100%; height:100%" dark="" v-model="active" color="info" slot="extension" slider->
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href='#0'>
                        {{$t("tab_general")}}
                    </v-tab>

                    <v-tab-item :id="'0'">
                        <v-layout v-if="tabviewgenel" row="" style="padding-top:10px;" wrap="">
                            <v-flex xs12 sm12 md4 style="padding-right:10px;">
                                <v-layout column>
                                    <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                                        <v-card class="white--text">
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <caricomp ref="cariAnaComp" v-bind:statecariyedek="caricompitems" v-bind:zorunlumu="true" @sendCurrentInfo="getCurrentInfo($event)" v-model="Bilet.GenelBilgileri.MusteriKodu.Kod"></caricomp>

                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 sm6 md12 style=" padding-bottom:10px;">
                                        <v-card class="white--text">
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>
                                                        <v-flex xs12 sm12 md12>
                                                            <musteribilgipart :yolcuadi="yolcudisabled" v-model="Bilet.GenelBilgileri">
                                                            </musteribilgipart>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 sm6 md12 style=" padding-bottom:10px;">
                                        <v-card class="white--text">
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>

                                                        <v-flex xs12 sm6 md6>
                                                            <v-autocomplete :items="itemsKayitTipi" tabindex="12" hide-details="" v-model="Bilet.GenelBilgileri.RecordTypeInfo.RecordTypeID" item-text="Aciklama" item-value="Kod" :label="$t('Record-Type')"></v-autocomplete>
                                                        </v-flex>

                                                        <v-flex xs12 sm6 md6>
                                                            <v-text-field hide-details="" :tabindex="'18'" v-model="Bilet.GenelBilgileri.HesKodu" :label="$t('HES-Code')"></v-text-field>
                                                        </v-flex>

                                                        <v-flex xs12 sm6 md6>
                                                            <v-layout justify-space-between column>
                                                                <v-layout>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <parkurcomp :tabindex="7" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur1">
                                                                        </parkurcomp>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <v-autocomplete :items="classitems" tabindex="12" hide-details="" clearable v-model="Bilet.GenelBilgileri.Classlar.Class1" item-text="ClassAdi" item-value="ClassAdi" :label="$t('Class')"></v-autocomplete>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-layout>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <parkurcomp :tabindex="'8'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur2">
                                                                        </parkurcomp>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <v-autocomplete :items="classitems" tabindex="13" hide-details="" v-model="Bilet.GenelBilgileri.Classlar.Class2" item-text="ClassAdi" item-value="ClassAdi" clearable :label="$t('Class')"></v-autocomplete>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-layout>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <parkurcomp :tabindex="'9'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur3">
                                                                        </parkurcomp>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <v-autocomplete :items="classitems" hide-details="" v-model="Bilet.GenelBilgileri.Classlar.Class3" item-text="ClassAdi" item-value="ClassAdi" tabindex="14" clearable :label="$t('Class')"></v-autocomplete>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-layout>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <parkurcomp :tabindex="'10'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur4">
                                                                        </parkurcomp>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <v-autocomplete :items="classitems" hide-details="" v-model="Bilet.GenelBilgileri.Classlar.Class4" item-text="ClassAdi" item-value="ClassAdi" tabindex="15" clearable :label="$t('Class')"></v-autocomplete>
                                                                    </v-flex>
                                                                </v-layout>

                                                                <v-layout>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <parkurcomp :tabindex="'11'" v-model="Bilet.GenelBilgileri.Parkurlar.Parkur5">
                                                                        </parkurcomp>
                                                                    </v-flex>
                                                                    <v-flex xs12 sm6 md6>
                                                                        <v-autocomplete :items="classitems" hide-details="" v-model="Bilet.GenelBilgileri.Classlar.Class5" item-text="ClassAdi" item-value="ClassAdi" tabindex="16" clearable :label="$t('Class')"></v-autocomplete>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-layout>
                                                        </v-flex>
                                                        <v-flex xs12 sm6 md6>
                                                            <v-layout justify-space-between column>
                                                                <tarihim :etiket="$t('Date-of-Departure')" :tabindex="'17'" v-bind:value="Bilet.UcusBilgileri.UcusTarihi" v-model="Bilet.UcusBilgileri.UcusTarihi"></tarihim>

                                                                <v-layout>
                                                                    <v-text-field hide-details="" :tabindex="'18'" maxlength="3" v-model="Bilet.UcusBilgileri.UcusNo1" :label="$t('Departure-Airline-Code')"></v-text-field>
                                                                    <v-text-field hide-details="" tabindex="19" maxlength="4" v-model="Bilet.UcusBilgileri.UcusNo2" :label="$t('Departure-Flight-No')"></v-text-field>
                                                                </v-layout>
                                                                <tarihim :etiket="$t('Date-of-Return')" :tabindex="'20'" v-bind:value="Bilet.UcusBilgileri.UcusDonusTarihi" v-model="Bilet.UcusBilgileri.UcusDonusTarihi"></tarihim>
                                                                <v-layout>
                                                                    <v-text-field hide-details="" tabindex="'21'" maxlength="3" v-model="Bilet.UcusBilgileri.UcusDonusNo1" :label="$t('Return-Airline-Code')"></v-text-field>
                                                                    <v-text-field hide-details="" tabindex="22" maxlength="4" v-model="Bilet.UcusBilgileri.UcusDonusNo2" :label="$t('Return-Flight-No')"></v-text-field>
                                                                </v-layout>
                                                                <tarihim :etiket="$t('Reservation-Date')" :tabindex="'23'" v-bind:value="Bilet.NotlarBilgileri.DateofRes" v-model="Bilet.NotlarBilgileri.DateofRes"></tarihim>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>

                                </v-layout>
                            </v-flex>

                            <v-flex xs12 sm6 md2 style=" padding-bottom:10px; padding-right:10px;">
                                <v-card class="white--text">
                                    <v-layout>
                                        <v-card flat="">
                                            <v-card-actions>
                                                <v-layout row wrap>
                                                    <v-flex xs12 sm12 md12>
                                                        <tarihim @odakkaybi="odakSatisTarihi" :etiket="$t('Sales-Date')" :tabindex="'24'" v-bind:defaultvalue="'ok'" v-bind:value="Bilet.TarihBilgileri.SatisTarihi" v-model="Bilet.TarihBilgileri.SatisTarihi"></tarihim>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>

                                                        <tarihim :etiket="$t('Date-of-Ticket-Issue')" :tabindex="'25'" v-bind:defaultvalue="'ok'" v-bind:value="Bilet.TarihBilgileri.KesimTarihi" v-model="Bilet.TarihBilgileri.KesimTarihi"></tarihim>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>

                                                        <kesenkisi v-bind:etiket="$t('Ticket-Agent')" v-model="Bilet.GenelBilgileri.KesenKisi">
                                                        </kesenkisi>
                                                    </v-flex>

                                                    <v-text-field hide-details="" tabindex="27" v-model="Bilet.GenelBilgileri.PnrNo" label="PNR"></v-text-field>
                                                    <v-text-field hide-details="" tabindex="28" v-model="Bilet.DigerBilgileri.PinKodu" label="PIN Code"></v-text-field>
                                                    <v-select hide-details="" :items="biletyon" tabindex="29" v-model="Bilet.GenelBilgileri.BiletYon" clearable item-text="text" item-value="value" :label="$t('Direction')"></v-select>
                                                    <v-select hide-details="" :items="classtip" tabindex="30" v-model="Bilet.GenelBilgileri.ClassTip" clearable item-text="text" item-value="value" :label="$t('Classt-Type')"></v-select>
                                                    <v-text-field hide-details="" type="number" tabindex="31" v-model="Bilet.GenelBilgileri.YolcuAdet" :label="$t('Passenger-Count')"></v-text-field>
                                                    <v-select :items="fiyatturu" tabindex="32" hide-details="" clearable item-text="text" item-value="value" v-model="Bilet.GenelBilgileri.FiyatTur" :label="$t('Price-Type')"></v-select>
                                                    <v-text-field hide-details="" tabindex="33" v-model="Bilet.GenelBilgileri.DepartmanKod" label="Dep.Code"></v-text-field>
                                                    <v-select :items="crskodu" hide-details="" tabindex="34" v-model="Bilet.GenelBilgileri.Crs" clearable item-text="text" item-value="value" label="CRS"></v-select>
                                                    <v-text-field tabindex="35" mask="##########" v-model="Bilet.GenelBilgileri.ExBiletNo" hide-details="" :label="$t('ECH-Ticket-Number')"></v-text-field>
                                                    <v-flex xs12 sm12 md12>
                                                        <masrafmerkezicomp :tabdeger="'36'" v-model="Bilet.GenelBilgileri.Masraf.Code">
                                                        </masrafmerkezicomp>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <referansmerkezicomp :coper="false" :tabdeger="'37'" v-model="Bilet.GenelBilgileri.Referans.Kod">
                                                        </referansmerkezicomp>
                                                    </v-flex>
                                                    <v-flex xs12 sm12 md12>
                                                        <bolumcomp :tabdeger="'38'" v-model="Bilet.TanimBilgileri.Bolum"></bolumcomp>
                                                    </v-flex>
                                                    <!-- <v-textarea :label="$t('Warningnote_label')" tabindex="22" v-model="Bilet.GenelBilgileri.MusteriKodu.Uyari"
                        hide-details=""></v-textarea> -->
                                                    <v-textarea :label="$t('Notes')" tabindex="39" v-model="Bilet.NotlarBilgileri.Aciklama2" hide-details=""></v-textarea>
                                                </v-layout>
                                            </v-card-actions>
                                        </v-card>
                                    </v-layout>
                                </v-card>
                            </v-flex>

                            <v-flex xs12 sm6 md4 style=" padding-right:10px;">

                                <v-flex xs12 sm12 md12 style=" padding-bottom:10px;">
                                    <v-card class="white--text">
                                        <v-layout>
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>

                                                        <v-flex xs12 sm6 md6>
                                                            <v-layout row wrap>
                                                                <parainput    :isPositive="true" :simge="getparabirimi()" :etiket="$t('Ticket-Amount')" :tabdeger="40" v-model="Bilet.TutarBilgileri.Tutar.Tutar" :autocomplete="'autocomplete'">
                                                                </parainput>
                                                                <v-flex v-if="dishatmi" xs12 sm12 md12>
                                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Tax'" :tabdeger="41" v-model="Bilet.TutarBilgileri.TaxTutar.TaxTutar" :autocomplete="'autocomplete'">
                                                                    </parainput>
                                                                </v-flex>
                                                                <v-flex v-if="ichatmi" xs12 sm12 md12>
                                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'YFF'" :tabdeger="42" v-model="Bilet.TutarBilgileri.YFFTutar.YFFTutar" :autocomplete="'autocomplete'">
                                                                    </parainput>
                                                                </v-flex>
                                                                <v-flex v-if="ichatmi" xs12 sm12 md12>
                                                                    <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Landing-Tax')" :tabdeger="43" v-model="Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar" :autocomplete="'autocomplete'"></parainput>
                                                                </v-flex>
                                                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Penalty')" :tabdeger="44" v-model="Bilet.TutarBilgileri.CezaTutar.CezaTutar" :autocomplete="'autocomplete'">
                                                                </parainput>
                                                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('MCO-PTA')" :tabdeger="45" v-model="Bilet.TutarBilgileri.PtaTutar.PtaTutar" :autocomplete="'autocomplete'">
                                                                </parainput>

                                                            </v-layout>
                                                        </v-flex>

                                                        <v-flex xs12 sm6 md6>
                                                            <v-layout row wrap>
                                                                
                                                                <v-text-field :label="$t('Service-Code')" @blur="serviscodeControl()" :placeholder="kodmesajı" append-icon="search" @click:append="servisgetir()" tabindex="47" maxlength="2" v-model="Bilet.TanimBilgileri.ServisKod" hide-details=""></v-text-field>
                                                               
                                                                <parainput :isPositive="true" @odakkaybi="odakkaybiServis" :simge="getparabirimi()" @input="ServisYuzdeAnalizKod()" :etiket="$t('Service')" :tabdeger="48" v-model="Bilet.TutarBilgileri.ServisTutar.ServisTutar" :autocomplete="'autocomplete'"></parainput>
                                                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Discount')" :tabdeger="49" v-model="Bilet.TutarBilgileri.IskontoTutar.IskontoTutar" :autocomplete="'autocomplete'"></parainput>
                                                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="RezTutarEtiket" :tabdeger="50" v-model="Bilet.TutarBilgileri.ReserveTutar.ReserveTutar" :autocomplete="'autocomplete'"></parainput>
                                                                <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Buying-Service-Amount')" :tabdeger="51" v-model="Bilet.OdemeBilgileri.AlisServisTutar.AlisServisTutar" :autocomplete="'autocomplete'"></parainput>

                                                            </v-layout>
                                                        </v-flex>

                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-layout>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 pb-2 sm12 md12 v-if="PB=='TRY'">
                                    <v-card class="white--text">
                                        <v-layout>
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>
                                                        <fatura :durum="faturanovarise" v-model="Bilet"></fatura>
                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-layout>
                                    </v-card>
                                </v-flex>

                                <v-flex xs12 pb-2 sm12 md12 v-if="!dishatmi && PB=='TRY'">
                                    <v-card class="white--text">
                                        <v-layout>
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <tevkifat  :isUpdate="guncellebtngorunum" v-model="Bilet"></tevkifat>
                                                </v-card-actions>
                                            </v-card>
                                        </v-layout>
                                    </v-card>
                                </v-flex>
                            </v-flex>

                            <v-flex xs12 sm12 md2>

                                <v-layout row wrap>

                                    <v-flex xs12 sm12 md12 pb-2>
                                        <v-card class="white--text">
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout pb-2 row wrap column>

                                                        <v-flex xs12 sm12 md12>
                                                            <v-switch :label="faturalansinmilabel" :disabled="faturanovarise" hide-details="" v-model="faturalansinmi">
                                                            </v-switch>
                                                        </v-flex>

                                                        <v-flex v-if="Bilet.GenelBilgileri.Status=='S' && guncellebtngorunum" xs12 pb-1 sm12 md12>
                                                            <v-switch :label="$t('Change-to-open-ticket')" v-model="Bilet.GenelBilgileri.OpenBilet" hide-details="">
                                                            </v-switch>
                                                        </v-flex>

                                                        <v-flex v-if="Bilet.GenelBilgileri.OpenBilet" xs12 sm12 md12>
                                                            <tarihim :etiket="this.$t('Ticket-Validity-Date')" v-bind:defaultvalue="'no'" v-bind:value="Bilet.TarihBilgileri.OpenTarihi" v-model="Bilet.TarihBilgileri.OpenTarihi"></tarihim>

                                                        </v-flex>

                                                        <v-flex xs12 sm12 md12>
                                                              <v-switch :label="$t('Linked-Ticket')" hide-details="" v-model="Bilet.GenelBilgileri.Baglantili">
                                                            </v-switch> 
                                                        </v-flex>

                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>

                                    <v-flex xs12 sm12 md12>
                                        <v-card class="white--text">
                                            <v-card flat="">
                                                <v-card-actions>
                                                    <v-layout row wrap>
                                                        <v-select hide-details="" @change="satissekliChange()" tabindex="62" v-model="Bilet.OdemeBilgileri.SatisSekli" :items="satissekliitem" item-text="text" item-value="value" clearable :label="$t('Sales-Method')"></v-select>
                                                        <tarihim :etiket="$t('Payment-Date')" v-bind:aktifmi="Bilet.OdemeBilgileri.SatisSekli=='C'" v-bind:defaultvalue="'ok'" :tabindex="'63'" v-bind:value="Bilet.TarihBilgileri.OdemeTarihi" v-model="Bilet.TarihBilgileri.OdemeTarihi"></tarihim>
                                                        <v-layout row wrap v-show="bankaposshow">
                                                            <v-flex xs12 sm12 md6>
                                                                <v-autocomplete :items="bankapositems" tabindex="64" hide-details="" v-model="Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu" @change="taksitgetir(Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu)" item-text="Title" item-value="PosKodu" clearable :label="$t('Pos-Code')"></v-autocomplete>
                                                            </v-flex>

                                                            <v-flex xs12 sm12 md6>
                                                                <v-autocomplete :items="taksitsayi" hide-details="" tabindex="65" v-model="postaksitsayi.id" @change="getTaksitLabel()" item-text="TaksitAciklama" item-value="TaksitID" clearable :label="$t('Instalment')"></v-autocomplete>
                                                            </v-flex>

                                                        </v-layout>
                                                        <v-flex v-if="bankaposshow" xs12 sm12 md12>

                                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Score-Amount')" :tabdeger="'66'" v-model="Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar" :autocomplete="'autocomplete'">
                                                            </parainput>
                                                        </v-flex>
                                                        <v-layout row wrap v-show="servisposshow">
                                                            <v-flex xs12 sm12 md6>

                                                                <v-autocomplete :items="bankapositems" tabindex="67" hide-details="" @change="taksitgetirservis(Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu)" v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu" item-text="Title" item-value="PosKodu" clearable :label="$t('Service-POS-Code')">
                                                                </v-autocomplete>

                                                            </v-flex>
                                                            <v-flex xs12 sm12 md6>
                                                                <v-autocomplete :items="taksitsayiservis" hide-details="" tabindex="68" v-model="servispostaksitsayi.id" @change="getServisTaksitLabel()" item-text="TaksitAciklama" item-value="TaksitID" clearable :label="$t('Instalment')">
                                                                </v-autocomplete>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-flex v-if="servisposshow" xs12 sm12 md12>

                                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Service-Pos-Amount')" :tabdeger="69" v-model="Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar" :autocomplete="'autocomplete'"></parainput>
                                                        </v-flex>

                                                        <v-text-field v-show="makbuznoshow" tabindex="70" v-model="Bilet.OdemeBilgileri.MakbuzNo" hide-details="" :label="$t('Receipt-No')"></v-text-field>
                                                        <v-text-field v-show="slipnoshow" :label="$t('Slip-No')" tabindex="71" v-model="Bilet.OdemeBilgileri.Slipkod" hide-details=""></v-text-field>

                                                        <v-flex xs12 v-show="kredikartishow" sm12 md12>
                                                            <kredikartcomp :tabdeger="'72'" v-model="Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo">
                                                            </kredikartcomp>
                                                        </v-flex>

                                                        <v-layout>
                                                            <yuzdeinput :isPositive="true" :etiket="'H.Y. %'" :tabdeger="73" v-model="Bilet.OdemeBilgileri.HYOran" :autocomplete="'autocomplete'"></yuzdeinput>
                                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'H.Y. Tutar'" :tabdeger="74" v-model="Bilet.OdemeBilgileri.HavaYoluTutar" :autocomplete="'autocomplete'">
                                                            </parainput>
                                                        </v-layout>

                                                        <v-flex xs12 sm12 md12>
                                                            <analizcompyeni :hd="true" @analizKod="analizKontrolYuzde($event)" v-if="analizCompShow" v-bind:searchValue="Bilet.TanimBilgileri.AnalizTutar" :servisTutari="Bilet.TutarBilgileri.ServisTutar.ServisTutar" :tabdeger="'75'" :etiket="$t('Analysis') + ' 1'" v-model="Bilet.TanimBilgileri"></analizcompyeni>
                                                        </v-flex>

                                                        <v-layout>
                                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="$t('Analysis-Amount')" :tabdeger="76" v-model="Bilet.TanimBilgileri.AnalizTutar" :autocomplete="'autocomplete'"></parainput>

                                                            <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Amount')" :tabdeger="77" v-model="Bilet.TanimBilgileri.AnalizDoviz" :autocomplete="'autocomplete'">
                                                            </doviztutarcomp>

                                                        </v-layout>

                                                        <v-flex xs12 sm12 md12>
                                                            <analizcompyeni1 :hd="true" :tabdeger="'78'" :etiket="$t('Analysis') + ' 2'" v-model="Bilet.TanimBilgileri"></analizcompyeni1>
                                                        </v-flex>

                                                        <v-layout>

                                                            <parainput :isPositive="true" :simge="getparabirimi()" :etiket="'Analiz2 Tutar'" :tabdeger="79" v-model="Bilet.TanimBilgileri.AnalizTutar1" :autocomplete="'autocomplete'">
                                                            </parainput>
                                                            <doviztutarcomp :etiket="$t('Currency-Amount')" :tabdeger="80" v-model="Bilet.TanimBilgileri.AnalizDoviz1" :autocomplete="'autocomplete'">
                                                            </doviztutarcomp>

                                                        </v-layout>
                                                    </v-layout>
                                                </v-card-actions>
                                            </v-card>
                                        </v-card>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>

                    </v-tab-item>
                    <v-tab href='#1' ripple>
                        {{$t('Flight-Details')}}
                    </v-tab>
                    <v-tab-item :id="'1'">

                        <v-layout v-show="tabviewucusdetay">
                            <ucusdetay v-bind:ucus1="true" v-bind:ucus2="true" v-bind:ucus3="true" v-bind:ucus4="true" v-bind:ucus5="true" v-model="this.UcusListesi"></ucusdetay>
                        </v-layout>
                    </v-tab-item>

                    <v-tab href='#2' ripple>
                        {{$t('Amount-Details')}}
                    </v-tab>
                    <v-tab-item :id="'2'">
                        <v-container fluid="" v-if="tabviewtutardetay">
                            <tutarbilgileri :ichatmi="ichatmi" :dishatmi="dishatmi" v-model="Bilet"></tutarbilgileri>
                        </v-container>
                    </v-tab-item>

                    <v-tab href='#3' ripple>
                        {{$t('COLLECTION')}}
                    </v-tab>
                    <v-tab-item :id="'3'">

                        <v-container v-if="tabviewtahsilat" fluid="">
                            <v-layout row="" wrap="">
                                <v-flex v-if="tahsilatbtn" xs12 sm4>
                                    <v-btn flat color="info" @click="tahsilatekle()"> {{$t('Add-New-Record')}}
                                        <v-icon right dark>add_box</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex v-if="tahsilatbtn" xs12 sm8>
                                    <v-layout justify-end="" fill-height="" align-center="">
                                        <div class="font-weight-regular red--text subheading">
                                            {{$t('Collection-Balance')}}: {{tahsilatBakiye | moneyformat}}{{getparabirimi()}}
                                        </div>
                                    </v-layout>
                                </v-flex>
                                <v-flex v-if="tahsilatbtn" xs12 sm12>
                                    <v-divider></v-divider>
                                </v-flex>
                                <div class="flex md12">

                                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="tahsilatitems" :search="search3">
                                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                                        <template slot="items" slot-scope="props">
                                            <tr item>
                                                <td class="text-xs-left">{{ props.item.Tarih | dateformat }}</td>
                                                <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                                                <td class="text-xs-left">{{ props.item.Evrakno }}</td>
                                                <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                                                <td class="text-xs-right">{{ props.item.Tutar | moneyformat }}</td>
                                                <td class="text-xs-center">{{ props.item.DovizCinsi }}</td>
                                                <td class="text-xs-right">{{ props.item.DovizTutar | moneyformat }}</td>
                                                <td class="text-xs-center">{{ props.item.PosKod }}</td>
                                                <td class="justify-center layout px-0">
                                                    <v-btn v-if="props.item.TanimID!=0" icon class="mx-0" @click="tahsilatgetir(props.item)">
                                                        <v-icon color="teal">edit</v-icon>
                                                    </v-btn>
                                                    <v-btn v-if="props.item.TanimID!=0" icon class="mx-0" @click="tahsilatsil(props.item)">
                                                        <v-icon color="pink">delete</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                            {{ $t('No-records-searched-for', { value: search3}) }}
                                        </v-alert>
                                    </v-data-table>
                                </div>
                            </v-layout>
                        </v-container>
                    </v-tab-item>

                    <!-- <v-tab href='#4' ripple>
              Ödeme
            </v-tab>
            <v-tab-item :id="'4'">
              <v-container v-if="tabviewodeme" fluid="">
                <v-layout row="" wrap="">
                  <v-flex xs12 sm4>

                  </v-flex>
                  <div class="flex md12">

                    <v-data-table :headers="headers" :rows-per-page-items=[50,100] :loading="progress" :items="odemeitems"
                      :search="search3">
                      <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                      <template slot="items" slot-scope="props">
                        <tr item>
                          <td class="text-xs-left">{{ props.item.Tarih }}</td>
                          <td class="text-xs-left">{{ props.item.Evrak.Evrakkod }}</td>
                          <td class="text-xs-left">{{ props.item.Evrakno }}</td>
                          <td class="text-xs-left">{{ props.item.Aciklama}}</td>
                          <td class="text-xs-left">{{ props.item.Tutar }}</td>
                          <td class="text-xs-left">{{ props.item.DovizCinsi }}</td>
                          <td class="text-xs-left">{{ props.item.DovizTutar }}</td>
                          <td class="text-xs-left">{{ props.item.PosKod }}</td>
                          <td class="justify-center layout px-0">
                            <v-btn icon class="mx-0" @click="satirduzenle(props.item)">
                              <v-icon color="teal">edit</v-icon>
                            </v-btn>
                            <v-btn icon class="mx-0" @click="satirsil(props.item)">
                              <v-icon color="pink">delete</v-icon>
                            </v-btn>
                          </td>
                        </tr>
                      </template>
                      <v-alert slot="no-results" :value="true" color="error" icon="warning">
                         {{ $t('No-records-searched-for', { value: search3}) }}
                      </v-alert>
                    </v-data-table>
                  </div>

                </v-layout>
              </v-container>

            </v-tab-item> -->

                    <v-tab href='#5' ripple>
                        {{$t('Notes')}}
                    </v-tab>
                    <v-tab-item :id="'5'">
                        <notlar v-if="tabviewnotlar" v-model="Bilet"></notlar>
                    </v-tab-item>

                    <v-tab href='#6' ripple>
                        {{$t('Private-Information')}}
                    </v-tab>
                    <v-tab-item :id="'6'">
                        <ozelbilgiler v-if="tabviewozel" v-model="Bilet"></ozelbilgiler>
                    </v-tab-item>

                    <v-tab v-show="iadetab" href='#7' ripple>
                        {{$t('Refund')}}
                    </v-tab>
                    <v-tab-item :id="'7'">
                        <v-container v-if="tabviewiade" fluid="">
                            <v-layout row="" wrap="">

                                <div class="flex md12">
                                    <v-card-title>
                                        <v-spacer></v-spacer>
                                    </v-card-title>
                                    <v-data-table :headers="headeriade" :loading="progress" :items="iadeitems" :search="search3">
                                        <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                                        <template slot="items" slot-scope="props">
                                            <tr item>
                                                <td class="text-xs-left">{{ props.item.TarihBilgileri.IadeTarihi | dateformat }}</td>
                                                <td class="text-xs-left">{{ props.item.GenelBilgileri.BiletNo}}</td>
                                                <td class="text-xs-left">{{ props.item.GenelBilgileri.HavaYoluKodu }}</td>
                                                <td class="text-xs-left">{{ props.item.TutarBilgileri.NetTutar.NetTutar}}</td>
                                                <td class="text-xs-left">{{ props.item.GenelBilgileri.Formno}}</td>
                                                <td class="text-xs-left">{{ props.item.GenelBilgileri.Sirano }}</td>
                                                <td class="justify-center layout px-0">
                                                    <v-btn icon class="mx-0" @click="iadeduzenle(props.item)">
                                                        <v-icon color="teal">edit</v-icon>
                                                    </v-btn>
                                                    <v-btn icon class="mx-0" @click="iadeiptal(props.item)">
                                                        <v-icon color="pink">delete</v-icon>
                                                    </v-btn>
                                                </td>
                                            </tr>
                                        </template>
                                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                             {{ $t('No-records-searched-for', { value: search3}) }}
                                        </v-alert>
                                    </v-data-table>
                                </div>
                            </v-layout>
                        </v-container>
                    </v-tab-item>
                    <v-tab href='#8' ripple>
                        Profİle
                    </v-tab>
                    <v-tab-item :id="'8'">
                        <v-layout row wrap>
                            <v-container fluid>
                                <v-layout row wrap>
                                    <v-flex xs12 sm4 md2>
                                        <v-select :items="itemssablon" clearable item-value="ID" @change="sablondetaygetir()" item-text="SablonAdi" :label="$t('Select-Template')" v-model="Sablon.TemplateID" hide-details="">
                                        </v-select>
                                    </v-flex>
                                    <v-flex xs12 sm4 md2>
                                        <v-select :items="itemsprofil" clearable item-value="ID" @change="Getirdeger(Sablon.ProfilID)" item-text="ID" :label="$t('Select-Profile-Code')" v-model="Sablon.ProfilID" hide-details=""></v-select>
                                    </v-flex>
                                    <v-flex xs12 sm2 md2>
                                        <v-layout>
                                            <v-btn @click="profilKaydet()" color="info">{{$t('Save-Profile')}}</v-btn>

                                            <v-btn @click="yeniProfilekle()" color="info">{{$t('Add-New-Profile')}}</v-btn>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-container>

                            <v-container fluid="">
                                <v-layout row="" wrap="">

                                    <v-flex v-if="item.type != 'I' && item.type != 'SI'" v-for="item in sablonobjeler" :key="item.id" xs12 sm4 md2>
                                        <duzyaziinput v-if="item.type == 'S'" :ref="item.vmodelname" :name="item.vmodelname" :etiket="item.labeller" :id="item.vmodelname" v-model="item.value"></duzyaziinput>
                                        <!-- <tarihinput v-else-if="item.type == 'D'" :etiket="item.labeller" :name="item.vmodelname" v-bind:value="item.value" :id="item.vmodelname" v-model="item.value"></tarihinput> -->
                                        <tarihim v-else-if="item.type == 'D'" :etiket="item.labeller" :tabindex="'17'"
                                        v-bind:value="item.value" v-model="item.value" :name="item.vmodelname" :id="item.vmodelname">
                              </tarihim>
                                        <sayiinput v-else-if="item.type == 'B'" v-model="item.value" :name="item.vmodelname" :autocomplete="'autocomplete'" :id="item.vmodelname" :etiket="item.labeller"></sayiinput>
                                        <sayiinput v-else-if="item.type == 'M'" v-model="item.value" :name="item.vmodelname" :autocomplete="'autocomplete'" :id="item.vmodelname" :etiket="item.labeller"></sayiinput>
                                    </v-flex>

                                </v-layout>
                            </v-container>
                        </v-layout>
                    </v-tab-item>

                    <!-- <v-tab href='#8' ripple>
              FATURA BİLGİLERİ
            </v-tab>
            <v-tab-item :id="'8'">
              <v-container fluid="">
                <v-layout row="" wrap="">

                  <div class="flex md3">
                    <v-btn color="info" :disabled="faturabtn" block @click="faturadialogac()">Fatura</v-btn>
                    <fatura :durum="faturanovarise" v-model="Bilet"></fatura>
                  </div>
                </v-layout>
              </v-container>
            </v-tab-item> -->
                </v-tabs>
            </v-layout>
        </v-card>
    </v-form>

    <v-dialog v-model="cokluyolcudialog" persistent max-width="300px">
        <v-card color="grey lighten-2">
            <v-flex xs12 sm12>
                <v-toolbar color="info" size="120px" dark>
                    <v-toolbar-title>{{$t('Multiple-Passenger-Entry')}}</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-container fluid="">
                    <v-layout row="" wrap="">
                        <v-flex xs12 sm12 md12>
                            <div v-for="item in objeler" :key="item.BiletNo">
                                <template>
                                    <v-text-field hide-details="" :ref="item.vmodelname" :label="item.Label" :id="item.vmodelname">
                                    </v-text-field>
                                </template>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div v-show="m === true">
                    <v-btn id="bguncelle" color="blue darken-1" flat @click="sablondetaysil()">{{ $t('Delete') }} </v-btn>
                    <v-btn id="bguncelle" color="blue darken-1" flat @click="detayguncelle()">{{ $t('Update') }}</v-btn>
                </div>
                <v-btn color="blue darken-1" flat @click.native="cokluyolcudialog=false">{{$t('Cancel')}}</v-btn>
                <v-btn id="bkaydet" color="blue darken-1" flat @click="coklubiletkayit()">{{ $t('Continue') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogtahsilatdagit" persistent max-width="300px">
        <v-card color="grey lighten-4">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title>{{$t('Collection-Distribution-Screen')}}</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-layout wrap>
                    <v-flex xs12 sm12 md6>
                        <parainput :isPositive="true" :etiket="$t('Amount-with-Credit')" :simge="getparabirimi()" v-model="miniTutar.Kredili" :autocomplete="'autocomplete'">
                        </parainput>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <doviztutarcomp :isPositive="true" @odakkaybi="odakminikredili" :etiket="$t('Currency-Amount')" v-model="miniTutar.KrediliDoviz" :autocomplete="'autocomplete'">
                        </doviztutarcomp>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                        <parainput :isPositive="true" :etiket="$t('Amount-Paid-in-Advance')" :simge="getparabirimi()" v-model="miniTutar.Pesin" :autocomplete="'autocomplete'"></parainput>
                    </v-flex>
                    <v-flex xs12 sm12 md6>
                        <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Amount')" @odakkaybi="odakminipesin" v-model="miniTutar.PesinDoviz" :autocomplete="'autocomplete'">
                        </doviztutarcomp>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                        <parainput :isPositive="true" :etiket="$t('Amount-with-Credit-Card')" :simge="getparabirimi()" v-model="miniTutar.KrediKartli" :autocomplete="'autocomplete'">
                        </parainput>
                    </v-flex>

                    <v-flex xs12 sm12 md6>
                        <doviztutarcomp :isPositive="true" :etiket="$t('Currency-Amount')" @odakkaybi="odakminikredikartli" v-model="miniTutar.KrediKartliDoviz" :autocomplete="'autocomplete'">
                        </doviztutarcomp>
                    </v-flex>

                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn id="bkaydet" color="blue darken-1" flat @click.native="dialogtahsilatdagit=false">{{$t('Close')}}</v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialoghydegistir" persistent max-width="400px">
        <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title>Havayolu Kodu Değiştir</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-layout wrap>
                    <div class="flex md12">
                        <hykoddegistircomp v-model="vmodelhyKod"></hykoddegistircomp>
                    </div>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn id="bkaydet" color="blue darken-1" flat @click.native="dialoghydegistir=false">{{$t('Cancel')}}</v-btn>
                <v-btn id="bkaydet" color="blue darken-1" flat @click="havayoluKoddegistir()">Değiştir</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog ref="yenidialog" v-model="yenidialog" persistent max-width="400px">
        <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title> {{$t('New-Record')}} </v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-layout wrap>
                    <div class="flex md12">
                        <yenibiletno v-model="Bilet"></yenibiletno>
                    </div>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <a target="_self" v-bind:href="'#/bilet/index'">
                    <v-btn color="blue darken-1" flat>{{$t('Cancel')}}</v-btn>
                </a>

                <v-tooltip bottom>
                    <v-btn color="info" :disabled="!sayfayetki.Save" slot="activator" @click="biletislemsorgula()" flat> <span class="hidden-sm-and-down"> {{ $t('Continue') }}
                        </span>
                    </v-btn>
                    <span v-if="!sayfayetki.Save">{{ $t('Limited-Authorization') }}</span>
                    <span v-if="sayfayetki.Save">{{ $t('Continue') }}</span>
                </v-tooltip>

            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogkisamesaj" width="500">

        <v-card>
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont">{{ $t('Warning') }}!</v-toolbar-title>
                </v-toolbar>
            </v-flex>

            <v-card-text>
                {{this.kisamesaj}}
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="dialogkisamesaj = false">
                    {{$t("cancel_button")}}
                </v-btn>
                <v-btn v-if="btnsilsor" color="primary" flat @click="biletsil()">
                    {{ $t('OK') }}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog persistent="" v-model="voiddialog" width="300">
        <v-card color="grey-lighteen-5">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont"> {{ $t('Make-it-Void') }} </v-toolbar-title>
                </v-toolbar>
            </v-flex>

            <v-card-text>
                <v-form ref="formvoid" v-model="validvoid">
                    <v-layout row wrap>
                        <v-flex xs12 sm12>

                            <tarihim :rules="[v => !!v || $t('Please-select-a-date')]" :etiket="$t('Void-Date')" v-bind:defaultvalue="'ok'" v-bind:value="voidTarihi" :detaygizle="false" v-model="voidTarihi">
                            </tarihim>
                        </v-flex>

                    </v-layout>
                </v-form>

            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="voiddialog = false">
                    {{$t("cancel_button")}}
                </v-btn>
                <v-btn color="primary" flat @click="voidislem()">
                    {{ $t('Make-it-Void') }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="tcdialog" persistent max-width="500px">
        <v-card color="grey lighten-2">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont">T.C. Kimlik Bilgileri Ekle</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-container grid-list-xs>
                    <v-layout wrap>

                        <div class="flex md12">
                            <v-text-field hide-details="" :label="$t('Identitynumber_label')"></v-text-field>

                            <v-text-field hide-details="" :label="$t('Name_label')"></v-text-field>

                            <v-text-field hide-details="" :label="$t('Surname_label')"></v-text-field>
                            <v-textarea :label="$t('Address_label')"></v-textarea>
                            <v-layout>
                                <v-text-field hide-details="" mask="NNNNNNNNNNNNNNN" label="Tel"></v-text-field>
                                <v-text-field hide-details="" mask="NNNNNNNNNNNNNNN" label="Fax"></v-text-field>
                            </v-layout>
                            <v-text-field hide-details="" :label="$t('Email_label')"></v-text-field>

                            <v-text-field hide-details="" :label="$t('Mother-Name')"></v-text-field>

                            <v-text-field hide-details="" :label="$t('Father-Name')"></v-text-field>
                            <v-text-field hide-details="" label="Anne Kızlık Soyadı"></v-text-field>
                        </div>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div v-show="m === true">
                    <v-btn id="bguncelle" color="blue darken-1" flat @click="sablondetaysil()"> {{$t('Delete') }} </v-btn>
                    <v-btn id="bguncelle" color="blue darken-1" flat @click="detayguncelle()">{{ $t('Update') }}</v-btn>
                </div>
                <v-btn color="blue darken-1" flat @click.native="tcdialog=false">{{$t('Cancel')}}</v-btn>
                <div>
                    <v-btn id="bkaydet" color="blue darken-1" flat @click="detaykaydet()">{{$t("save_button")}}</v-btn>
                </div>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="faturadialog" persistent max-width="1000px">
        <v-card color="grey lighten-5">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont"> {{$t('Invoice-Entry')}}  </v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-container grid-list-xs>
                    <v-layout wrap>
                        <div class="flex md4">
                            <div class="card card--tile ">
                                <div class="card__text grey darken-1 white--text">
                                    <h3>{{$t('General-Information') }}</h3>
                                </div>
                            </div>

                            <tarihim :etiket="'Fatura Tarihi'" v-bind:defaultvalue="'ok'" v-bind:value="Fatura.FaturaTarih" v-model="Fatura.FaturaTarih"></tarihim>

                            <v-layout>
                                <v-text-field hide-details="" v-model="Fatura.FaturaSeri" :label="$t('Invoice-Serial')"></v-text-field>

                                <v-text-field hide-details="" :label="$t('Invoice-No')" v-model="Fatura.FaturaNo"></v-text-field>
                            </v-layout>
                            <v-select :items="gibseri" tabindex="26" v-model="Fatura.GibSeri" hide-details="" clearable item-text="Seri" item-value="Seri" :label="$t('Turkish-Revenue-Administration-Serial-No')"></v-select>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Title_label') + '1'" v-model="Fatura.EFaturaBilgi.Unvani"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Title_label') + '2'" v-model="Fatura.EFaturaBilgi.Unvani2"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Address_label') + '1'" v-model="Fatura.EFaturaBilgi.Adres1"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Address_label') + '2'" v-model="Fatura.EFaturaBilgi.Adres2"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Province_label')" v-model="Fatura.EFaturaBilgi.IlceSehir"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Invoice-E-mail')" v-model="Fatura.EFaturaBilgi.Email"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Taxcenter_label')" v-model="Fatura.EFaturaBilgi.VergiDairesi">
                            </v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Taxnumber_label')" v-model="Fatura.EFaturaBilgi.VergiNo"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" :label="$t('Identity-Number')" v-model="Fatura.EFaturaBilgi.TcKimlikNo">
                            </v-text-field>
                            <div v-show="edoviztipishow">
                                <v-select hide-details="" :items="doviztipi" @change="kurgetirfatura(BiletAyrintiliOdeme.Tarih,BiletAyrintiliOdeme.Doviz)" v-model="Fatura.DovizBilgi.EDovizTipi" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>
                                <v-text-field v-model="Fatura.DovizBilgi.EKur" hide-details="" :label="$t('Exchange-Rate-v2')"></v-text-field>
                            </div>
                            <div v-show="ddoviztipishow">
                                <v-select hide-details="" :items="doviztipi" @change="kurgetirfatura(BiletAyrintiliOdeme.Tarih,BiletAyrintiliOdeme.Doviz)" v-model="Fatura.DovizBilgi.DDovizTipi" clearable item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>
                                <v-text-field v-model="Fatura.DovizBilgi.DKur" hide-details="" :label="$t('Exchange-Rate-v2')"></v-text-field>
                            </div>
                        </div>

                        <div class="flex md4">
                            <div class="card card--tile ">
                                <div class="card__text grey darken-1 white--text">
                                    <h3>{{$t('Foridentity_header')}}</h3>
                                </div>
                            </div>

                            <v-text-field hide-details="" :disabled="changeTitleInfo" maxlength="50" v-model="Fatura.EFaturaBilgi.Adi" :label="$t('Name_label')"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" maxlength="50" v-model="Fatura.EFaturaBilgi.Soyadi" :label="$t('Surname_label')"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" maxlength="50" v-model="Fatura.EFaturaBilgi.TUnvani" :label="$t('Title_label')"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" maxlength="50" v-model="Fatura.EFaturaBilgi.DigerAdi" :label="$t('Othername_label')"></v-text-field>
                            <v-text-field hide-details="" :disabled="changeTitleInfo" maxlength="50" v-model="Fatura.EFaturaBilgi.OnAdiEki" :label="$t('Suffixname_label')"></v-text-field>
                            <div class="card card--tile ">
                                <div class="card__text grey darken-1 white--text">
                                    <h3>Dizayn Seçenekler</h3>
                                </div>
                            </div>
              
                            <v-checkbox @change="dizayngetir()" :label="$t('Print-Invoice-with-Currency')" v-model="Fatura.Opsiyonlar.DovizliFatura" hide-details></v-checkbox>
                            <v-select :items="dizaynsec" @change="xsltsec(Fatura.FaturaBilgi.FaturaID)" v-model="Fatura.FaturaBilgi.FaturaID" tabindex="26" hide-details="" clearable item-text="FaturaAciklama" item-value="FaturaId" :label="$t('Select-Design')"></v-select>
                            <reportbrosablon v-show="false" ref="reportbrosablon" v-model="Fatura.FaturaBilgi.FaturaPdfID" dizayngrupadi="Fatura" objectname="Controllers.ReportBro.Invoice.InvoicePrint"></reportbrosablon>
                        </div>

                        <div class="flex md4">
                            <div class="card card--tile ">
                                <div class="card__text grey darken-1 white--text">
                                    <h3>{{ $t('Options-v2') }}</h3>
                                </div>
                            </div>
                            <v-checkbox :label="$t('Do-Not-Print-Passenger-Name')" v-model="Fatura.Opsiyonlar.YolcuGosterme" hide-details>
                            </v-checkbox>
                            <v-checkbox :label="$t('Do-Not-Print-Payment-Term')" v-model="Fatura.Opsiyonlar.OdemeVade" hide-details></v-checkbox>
                            <v-checkbox :label="$t('Print-Invoice-Details')" v-model="Fatura.Opsiyonlar.FaturaDetayBas" hide-details>
                            </v-checkbox>
                        </div>
                        <div class="flex md12">
                            <v-text-field hide-details="" v-model="Fatura.FaturaBilgi.FaturaDipAciklama" :label="$t('E-invoice-Footer-Disclosure')"></v-text-field>
                        </div>
                    </v-layout>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div v-show="m === true">
                    <!-- <v-btn id="bguncelle" color="blue darken-1" flat @click="sablondetaysil()"> {{ $t('Delete') }} </v-btn>
            <v-btn id="bguncelle" color="blue darken-1" flat @click="detayguncelle()">{{ $t('Update') }}</v-btn> -->
                </div>
                <v-btn color="blue darken-1" flat @click.native="faturadialog=false">{{$t('Cancel')}}</v-btn>
                <div>
                    <v-btn id="bkaydet" color="blue darken-1" flat @click="faturakaydet()">{{$t('Invoice')}}</v-btn>
                </div>

            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-if="loadingdialog" v-model="loadingdialog" hide-overlay persistent width="400">
        <v-card color="primary" dark>
            <v-card-text>
                {{$t('Processing-please-wait')}} ...
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>

    <v-dialog v-model="servisdialog" max-width="500px">
        <v-card color="grey lighten-2">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont">{{$t('Service-Code-Selection')}}</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-layout row wrap>
                    <div class="flex md12">
                        <v-data-table :headers="headersservis" :loading="progress" :items="servisitems" hide-actions class="elevation-1">
                            <template slot="items" slot-scope="props">
                                <tr @click="servissec(props.item)" item>
                                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                                    <td class="text-xs-left">{{ props.item.Aciklama }}</td>
                                    <td class="text-xs-left">{{ props.item.Tutar }}</td>
                                    <td class="text-xs-left">{{ props.item.DovizKod}}</td>
                                    <td class="justify-center layout px-0">
                                    </td>
                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-layout>
            </v-card-text>
        </v-card>
    </v-dialog>
    
    <v-dialog v-model="odemeDialog" max-width="400px">
       <v-card color="white">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont">{{$t('Payment-Date-Change')}}</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-layout row wrap>
                    <div class="flex md12">
                     <v-alert :value="true">
                        {{$t('YOUR-CUSTOMER-HAS-A-DEFINED-DATE-THE-PAYMENT-DATE-OF-THE-TICKET')}} {{ odemeDialogTarih | dateformat }} {{$t('DO YOU WANT IT TO CHANGE TO?')}}
                     </v-alert>
                    </div>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="odemeDialog=false">{{$t('Cancel')}}</v-btn>
                <div>
                    <v-btn id="bkaydet" color="blue darken-1" flat @click="odemeTarihDegistir()">{{$t('Change')}}</v-btn>
                </div>

            </v-card-actions>
        </v-card>

    </v-dialog>

      <v-dialog v-model="groupTicketDialog" persistent  max-width="500px">
       <v-card color="white">
            <v-flex xs12 sm12>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont">Grup Bilet Sonuç</v-toolbar-title>
                </v-toolbar>
            </v-flex>
            <v-card-text>
                <v-layout row wrap>
                    <div class="flex md12">
                        <v-data-table :headers="headersGroupTicket" :rows-per-page-items=[50,100] :loading="progress" :items="groupTicketResultItems" :search="search3">
                            <template slot="items" slot-scope="props">
                                <tr item>
                                    <td class="text-xs-left">{{ props.item.TicketNo }}</td>
                                    <td class="text-xs-left">{{ props.item.ResponseMessage }}</td>
                                    <td class="text-xs-center" v-if="props.item.Status"> <v-icon color="green">check</v-icon></td>
                                     <td class="text-xs-center" v-if="!props.item.Status"> <v-icon color="red">clear</v-icon> </td>

                                </tr>
                            </template>
                        </v-data-table>
                    </div>
                </v-layout>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click="sayfakapat()">{{$t('OK')}}</v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>


    <v-dialog v-model="groupTicketProgressDialog" persistent  max-width="500px">
       <v-card color="white">
            <v-card-text>
                <v-layout row wrap justify-center>
                    <v-progress-circular 
                    :rotate="-90"
                    :size="100"
                    :width="15"
                    :value="(100 / toplubilet.length)  * sentTicketNumber"
                    color="primary"
                    >
                    {{ Math.round((100 / toplubilet.length)  * sentTicketNumber) }}
                    </v-progress-circular>
                </v-layout>
            </v-card-text>
        </v-card>

    </v-dialog>

   
</div>
</template>

<script>
import auth from '../../../api/auth'
import parainput from '../customcomp/parainput'
import yuzdeinput from '../customcomp/yuzdeinput'
import dovizinput from '../customcomp/dovizinput'
import kesenkisi from '../customcomp/kesenkisi'
import tarihim from '../customcomp/tarihim'
import ucusdetay from "@/components/app/bilet/partpage/ucusdetay.vue"
import notlar from "@/components/app/bilet/partpage/notlar.vue"
import ozelbilgiler from "@/components/app/bilet/partpage/ozelbilgiler.vue"
import tutarbilgileri from "@/components/app/bilet/partpage/tutarbilgileri.vue"
import fatura from "@/components/app/bilet/partpage/fatura.vue"
import tahsilatdialog1 from "@/components/app/bilet/partpage/tahsilatdialog1.vue"
import yenibiletno from "@/components/app/bilet/partpage/yenibiletdialog1.vue"
import hykoddegistircomp from "@/components/app/bilet/partpage/hykod.vue"
import doviztutarcomp from '@/components/app/customcomp/doviztutarcomp.vue'

import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"
import kredikartcomp from "@/components/app/bilet/partpage/kredikartcomp.vue"
import analizcomp from "@/components/app/bilet/partpage/analizcomp.vue"
import analizcompyeni from "@/components/app/bilet/partpage/analizcompyeni.vue"
import analizcompyeni1 from "@/components/app/bilet/partpage/analizcompyeni1.vue"
import musteribilgipart from "@/components/app/bilet/partpage/musteribilgipart.vue"
import logoo from '../../../assets/control'
import reportbrosablon from "@/components/app/coper/comp/reportbrosablon.vue";
import helpers from "@/components/app/customcomp/helpers.js"

import duzyaziinput from '@/components/app/customcomp/duzyaziinput.vue';
import moneyinput from '@/components/app/customcomp/moneyinput.vue';
import sayiinput from '@/components/app/customcomp/sayiinput.vue';
import tarihinput from '@/components/app/customcomp/tarihim.vue';
import caricomp from '@/components/app/customcomp/caricomp.vue'
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
import onaydialog from "@/components/app/customcomp/onaydialog.vue"
import loadingcomp from "@/components/app/customcomp/loadingcomp"
import tevkifat from "@/components/app/bilet/partpage/tevkifat.vue"
import Vue from 'vue';
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";

export default {
    data() {
        return {
            sablonobjeler:[],
            PB:"TRY",
            costcentertitle:"",
            sentTicketNumber:0,
            groupTicketResultItems:[],
            headersGroupTicket:[{
                text:'Ticket No'
            },{
                text:'Sonuç'
            },
            {
                text:'Durum'
            }
            ],
            groupTicketDialog:false,
            groupTicketProgressDialog:false,
            biletislemCounter:0,
            odemeDialog:false,
            odemeDialogTarih:null,
            AnalizOran: 0,
            analizCompShow: false,
            counter: 0,
            loadingvmodel: false,
            validvoid: true,
            voidTarihi: null,
            analizkontrol: false,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0,
            },

            ilkgiriskontrol: true,
            ilkgirissatistarihkontrol: true,
            faturalansinmi: true,
            faturalansinmilabel: this.$t('ticket-can-invoiced'),
            dialogtahsilatdagit: false,
            miniTutar: {
                Kredili: 0,
                Pesin: 0,
                KrediKartli: 0,
                KrediliDoviz: 0,
                PesinDoviz: 0,
                KrediKartliDoviz: 0
            },
            tahsilatBakiye: 0,
            ucussayi: null,
            caricompitems: null,
            yenibbiletMetin: 'Yeni Bilet',
            btnsilsor: false,
            tabviewozel: false,
            tabviewgenel: true,
            tabviewiade: false,
            tabviewucusdetay: false,
            tabviewtutardetay: false,
            tabviewtahsilat: false,
            tabviewodeme: false,
            tabviewnotlar: false,
            bekletme: false,
            ReserveTutarLabel: null,
            objeler: [],
            biletcoklumu: false,
            yolcudisabled: false,
            toplubilet: [],
            cokluyolcudialog: false,
            eFaturaBilgi: null,
            vmodelhyKod: {
                HavaYoluKodu: null,
                Formno: null,
                AcenteKodu: null,
                Acente: null,
                UcusTipi: null
            },
            havayoluislemtip: true,
            KrediLimiti: 0,
            RezTutarEtiket: null,
            itemsKayitTipi: helpers.getBiletKayitTipi,
            Bilet: {
                GenelBilgileri: {
                    HesKodu: null,
                    RecordTypeInfo: {
                        RecordTypeID: 0,
                        RecordTypeExp: null
                    },
                    ArkmanUsers: '',
                    SirketKodu: '',
                    BiletNo: '',
                    Formno: '',
                    HavaYoluKodu: null,
                    UcusTipi: '',
                    SiparisNo: 0,
                    MusteriKodu: {
                        Kod: '',
                        Uyari: '',
                        BilgiNotu: ''
                    },
                    KesenKisi: '',
                    YolcuAdi: '',
                    Parkurlar: {
                        Parkur1: '',
                        Parkur2: '',
                        Parkur3: '',
                        Parkur4: '',
                        Parkur5: '',
                    },
                    Classlar: {
                        Class1: '',
                        Class2: '',
                        Class3: '',
                        Class4: '',
                        Class5: '',
                    },
                    FiyatTur: 'AD', //enum deger
                    Referans: {
                        Kod: ''
                    },
                    YolcuAdet: 1,
                    Baglantili: false,
                    PnrNo: '',
                    RezervasyonVeren: '',
                    RezervasyonAlan: '',
                    Status: null, //enum
                    Acente: '',
                    AcenteKodu: '',
                    ExBiletNo: '',
                    ExBiletHY: '',
                    ClassTip: 'E', //enum
                    BiletYon: 'T', //enum
                    DepartmanKod: '',
                    Crs: 'Manuel', //enum
                    Masraf: {
                        Code: ''
                    },
                    Email: '',
                    BiletTel: '',
                    OpenBilet: false,
                },
                TarihBilgileri: {
                    KesimTarihi: null,
                    SatisTarihi: null,
                    IptalTarihi: null,
                    IadeTarihi: null,
                    OdemeTarihi: null,
                    OpenTarihi: null,
                },
                UcusBilgileri: {
                    UcusTarihi: null,
                    UcusNo1: null,
                    UcusNo2: null,
                    UcusDonusTarihi: null,
                    UcusDonusNo1: null,
                    UcusDonusNo2: null,
                    UcusListesi: []
                },
                FaturaBilgileri: {
                    FaturaTarihi: null,
                    FaturaSeri: null,
                    FaturaNo: 0,
                    EfaturaBilgileri: {
                        FaturaNo: null,
                        Guid: null,
                        FaturaDurumu: null,
                        SanalFaturaNo: null,
                        GercekFaturaNo: null,
                        BasimTarihi: null,
                        Kullanici: null,
                        GonderimSekli: 0,
                        InternetSatis: 0,
                        WebAdresi: null,
                        OdemeSekli: 0,
                        OdemeSekliAciklama: null,
                        OdemeAraci: null,
                        OdemeTarihi: null
                    },
                    AlisFaturaNo: null,
                    ProformaSeri: null,
                    ProformaNo: 0,
                    ProformaTarihi: null,
                    SatisFaturaID: null,
                    MaliyetFaturaID: null,
                    AlisFaturaTarihi: null,
                    AlisFatNo: null,
                    FaturaOtomatik: 0,
                    IstinaKod: null,
                    KdvKod: null,
                },
                TutarBilgileri: {
                    Doviz: {
                        DovizKod: ''
                    },
                    Kur: 1,
                    NetTutar: {
                        NetTutar: 0,
                        NetTutarSatisDoviz: 0,
                        NetTutarAlisDoviz: 0,
                        NetTutarKdv: 0,
                    },
                    Tutar: {
                        Tutar: 0,
                        TutarSatisDoviz: 0,
                        TutarAlisDoviz: 0,
                        TutarKdv: 0,
                    },
                    PtaTutar: {
                        PtaTutar: 0,
                        PtaSatisDoviz: 0,
                        PtaAlisDoviz: 0,
                        PtaKdv: 0
                    },
                    AlanVergiTutar: {
                        AlanVergiTutar: 0,
                        AlanVergiSatisDoviz: 0,
                        AlanVergiAlisDoviz: 0,
                        AlanVergiKdv: 0,
                    },
                    CharterTutar: {
                        CharterTutar: 0,
                        CharterSatisDoviz: 0,
                        CharterAlisDoviz: 0,
                        CharterKdv: 0
                    },
                    YFFTutar: {
                        YFFTutar: 0,
                        YFFDoviz: 0,
                        YFFKdv: 0
                    },
                    ServisTutar: {
                        ServisTutar: 0,
                        ServisDoviz: 0,
                        ServisKdv: 0
                    },
                    DigerServisTutar: {
                        DigerServisTutar: 0,
                        DigerServisDoviz: 0,
                        DigerServisKdv: 0
                    },
                    IskontoTutar: {
                        IskontoYuzde: 0,
                        IskontoTutar: 0,
                        IskontoDoviz: 0,
                        IskontoKdv: 0
                    },
                    TaxTutar: {
                        TaxTutar: 0,
                        TaxSatisDoviz: 0,
                        TaxAlisDoviz: 0,
                        TaxKdv: 0
                    },
                    CezaTutar: {
                        CezaTutar: 0,
                        CezaSatisTutar: 0,
                        CezaAlisTutar: 0,
                        CezaKdv: 0
                    },
                    KaTutar: {
                        KaTutar: 0,
                        KaDoviz: 0,
                        KaKdv: 0
                    },
                    ReserveTutar: {
                        ReserveYuzde: 0,
                        ReserveTutar: 0,
                        ReserveDoviz: 0,
                        ReserveKdv: 0
                    },
                    TevkifatTutar:{
                        TevkifatKodu:null,
                        TevkifatOran:0,
                        TevkifatTutar:0
                    }
                },
                OdemeBilgileri: {
                    SatisSekli: 'K', //enum
                    KomisyonTip: '', //enum
                    HYOran: 0,
                    GSAOran: 0,
                    KrediliTutar: 0,
                    KrediliDoviz: 0,
                    PesinTutar: 0,
                    PesinDoviz: 0,
                    KrediKartTutar: 0,
                    KrediKartDoviz: 0,
                    KrediKartBilgi: {
                        KrediKartNo: '',
                        KrediKartAy: '',
                        KrediKartYil: '',
                        KrediKartCins: '',
                        KrediKartTip: ''
                    },
                    AlisServisTutar: {
                        AlisServisTutar: 0,
                        AlisServisDoviz: 0,
                        AlisServisKdv: 0
                    },
                    HavaYoluTutar: 0,
                    HavaYoluKdv: 0,
                    Csc: false,
                    BankaBilgileri: {
                        PosKod: {
                            BankaPosID: 0,
                            SirketKodu: 0,
                            PosKodu: '',
                            Aciklama: '',
                            MuhasebeKodlar: {
                                MuhasebeKodu: '',
                                CMuhasebeKodu: '',
                                FDisAktarimCariKodu: '',
                                FDisAktarimMuhKodu: '',
                                CDisAktarimCariKodu: '',
                                CDisAktarimMuhKodu: '',
                                ServisMuhasebeKodu: '',
                                ServisDisAktarimCariKodu: '',
                                ServisDisAktarimMuhKodu: ''
                            },
                            Parametreler: {
                                ID: 0,
                                Banka: {
                                    BankaID: 0,
                                    SirketKodu: 0,
                                    BankaKod: '',
                                    BankaAdi: '',
                                    Cari: {
                                        Kod: ''
                                    },
                                    BankaKisaKod: '',
                                    Tip: 0
                                },
                                PosMuhKodu: '',
                                PuanCariKodu: '',
                                SozlesmeBaslangic: null,
                                SozlesmeBitis: null,
                                Aktif: '',
                                VadeTip: '',
                                UyelikTutar: 0,
                                UyelikOran: 0,
                                Kota: 0,
                                KotaGun: 0,
                                KotaCezaTutar: 0,
                                KotaCezaOran: 0,
                                VadeSabitGun: 0,
                                VadeFarkSabit: 0,
                                KotaKod: '',
                                TerminalID: '',
                                UyeIsYeriID: '',
                                UserName: '',
                                UserPass: '',
                                PosType: 0,
                                StoreKey: '',
                            }
                            //public List<BankaPosTaksit> Taksitler { get; set; }
                        },
                        ServisPosKod: {
                            BankaPosID: 0,
                            SirketKodu: 0,
                            PosKodu: '',
                            Aciklama: '',
                            MuhasebeKodlar: {
                                MuhasebeKodu: '',
                                CMuhasebeKodu: '',
                                FDisAktarimCariKodu: '',
                                FDisAktarimMuhKodu: '',
                                CDisAktarimCariKodu: '',
                                CDisAktarimMuhKodu: '',
                                ServisMuhasebeKodu: '',
                                ServisDisAktarimCariKodu: '',
                                ServisDisAktarimMuhKodu: ''
                            },
                            Parametreler: {
                                ID: 0,
                                Banka: {
                                    BankaID: 0,
                                    SirketKodu: 0,
                                    BankaKod: '',
                                    BankaAdi: '',
                                    Cari: {
                                        Kod: ''
                                    },
                                    BankaKisaKod: '',
                                    Tip: 0
                                },
                                PosMuhKodu: '',
                                PuanCariKodu: '',
                                SozlesmeBaslangic: null,
                                SozlesmeBitis: null,
                                Aktif: '',
                                VadeTip: '',
                                UyelikTutar: 0,
                                UyelikOran: 0,
                                Kota: 0,
                                KotaGun: 0,
                                KotaCezaTutar: 0,
                                KotaCezaOran: 0,
                                VadeSabitGun: 0,
                                VadeFarkSabit: 0,
                                KotaKod: '',
                                TerminalID: '',
                                UyeIsYeriID: '',
                                UserName: '',
                                UserPass: '',
                                PosType: 0,
                                StoreKey: '',
                            },
                            Taksitler: []
                        },

                        ServisPosTutar: 0,
                        TaksitKod: null,
                        ServisTaksitKod: null,
                        TaksitKodLabel: null,
                        ServisTaksitKodLabel: null,
                        PuanTutar: 0
                    },
                    Slipkod: '',
                    MakbuzNo: '',
                },
                DigerBilgileri: {
                    SaveTime: null,
                    Entegre: false,
                    BiletTanim: '',
                    eservedTutar1: 0,
                    ExIcDis: '',
                    EntegreTablo: '',
                    GrossTutar: 0,
                    ExIcDis: '',
                    CharterPtaKodu: '',
                    pArkmanEntegre: '',
                    PinKodu: '',
                    RezervasyonID: '',
                    SiparisID: '',
                    CKLogID: 0,
                    ExIcDis: '',
                    ParkurTip: '',
                    DServisKod1: '',
                    DServisKod2: '',
                    KKEnt: '',
                    SatisSapEntegre: '',
                    MaliyetSapEntegre: '',
                    KisiID: 0,
                    ExIcDis: '',
                    // EntegrasyonID: guid değişkeni
                    UserID: 0,
                    ExIcDis: ''
                },
                TanimBilgileri: {
                    ServisKod: '',
                    AnalizKod: {
                        SirketKodu: 0,
                        AnalizKod: '',
                        AnalizAdi: '',
                        AnalizTutar: 0,
                        AnalizOran: 0,
                    },
                    AnalizTutar: 0,
                    AnalizDoviz: 0,
                    AnalizKod1: {
                        SirketKodu: 0,
                        AnalizKod: '',
                        AnalizAdi: '',
                        AnalizTutar: 0,
                        AnalizOran: 0,
                    },
                    AnalizTutar1: 0,
                    AnalizDoviz1: 0,
                    TcKimlikNolar: {
                        TcNo1: '',
                        TcNo2: '',
                        TcNo3: '',
                        TcNo4: '',
                        TcNo5: ''
                    },
                    Aciklamalar: {
                        Aciklama1: '',
                        Aciklama2: '',
                        Aciklama3: '',
                        Aciklama4: '',
                        Aciklama5: '',
                        Aciklama6: '',
                        Aciklama7: '',
                    },
                    MilKodu: {
                        MilKoduOde: '',
                        MilKoduYolcu: '',
                        MilAdet: 0,
                        MilTutar: 0
                    },
                    MusteriPersonel: {
                        PersonelUcan: {
                            ID: 0,
                            SirketKodu: 0,
                            SirketAdi: '',
                            MasrafYeri: '',
                            SicilNo: '',
                            Adi: '',
                            Soyadi: '',
                            CalismaYeri: '',
                            Bolum: '',
                            IcSeyahat: '',
                            DisSeyahat: '',
                            IsAlani: '',
                            Siparis: '',
                            Cari: {
                                Kod: ''
                            },
                            KapatAc: false,
                            Email: '',
                            Tel: ''
                        },
                        PersonelSponsor: {
                            ID: 0,
                            SirketKodu: 0,
                            SirketAdi: '',
                            MasrafYeri: '',
                            SicilNo: '',
                            Adi: '',
                            Soyadi: '',
                            CalismaYeri: '',
                            Bolum: '',
                            IcSeyahat: '',
                            DisSeyahat: '',
                            IsAlani: '',
                            Siparis: '',
                            Cari: {
                                Kod: ''
                            },
                            KapatAc: false,
                            Email: '',
                            Tel: ''
                        }
                    },
                    YolcuCrm: {
                        CrmYolcu: {
                            Ref: 0,
                            Adi: '',
                            Soyadi: '',
                            Tel: '',
                            Gsm: '',
                            Email: '',
                            TCKimlikNo: '',
                            ID: 0
                        },
                        CrmRezervasyon: {
                            Ref: 0,
                            Adi: '',
                            Soyadi: '',
                            Tel: '',
                            Gsm: '',
                            Email: '',
                            TCKimlikNo: '',
                            ID: 0
                        }
                    },
                    ProfilID: 0,
                    SablonID: 0,
                    Bolum: '',
                    EventID: '',
                    ExAciklamalar: {
                        ID: 0,
                        SirketKodu: 0,
                        Biletno: '',
                        HavayoluKod: '',
                        EmployeeId: '',
                        DepartmentId: '',
                        CostCenter: '',
                        ClientId: '',
                        DkNumber: '',
                        WwId: '',
                        BusinessUnit: '',
                        CompanyCode: '',
                        SiteCode: '',
                        PurposeOt: '',
                        PcNumber: '',
                        NoHotelBc: '',
                        TripApprover: ''
                    }
                },
                AyrintiOdemeBilgileri: [],
                NotlarBilgileri: {
                    SirketKodu: 0,
                    BiletNo: '',
                    FormNo: '',
                    Aciklama1: '',
                    Aciklama2: '',
                    Segment1: '',
                    Segment2: '',
                    Segment3: '',
                    Segment4: '',
                    Segment5: '',
                    RefFare: 0,
                    LowFare: 0,
                    RealCode: '',
                    DateofRes: null,
                    MarketCode: '',
                    TicketSuffix: '',
                    VendorNumber: '',
                    ReasonCode: '',
                    CRSGDS: '',
                    SubPruductCode: '',
                    TicketTypeInd: false,
                    TourCode: '',
                    AlternatifTutar1: 0,
                    AlternatifTutar2: 0,
                    AlternatifTutar3: 0,
                    Anlasmali: false,
                    Esnek: false,
                    KarbonSalinimi: 0,
                    Mil1: 0,
                    Mil2: 0,
                    Mil3: 0,
                    Mil4: 0,
                    AirlineFile: '',
                },

                TaksitBilgileri: {
                    ID: 0,
                    SirketKodu: 0,
                    BiletNo: '',
                    HavaYoluKodu: '',
                    MakbuzNo: '',
                    CCNo1: '',
                    Tip1: '',
                    Ay1: 0,
                    Yil1: 0,
                    Tutar1: 0,
                    Iade1: 0,
                    Taksit1: 0,
                    TVade1: null,
                    PosKodu1: '',
                    CCNo2: '',
                    Tip2: '',
                    Ay2: 0,
                    Yil2: 0,
                    Tutar2: 0,
                    Iade2: 0,
                    Taksit2: 0,
                    TVade2: null,
                    PosKodu2: '',
                    CCNo3: '',
                    Tip3: '',
                    Ay3: 0,
                    Yil3: 0,
                    Tutar3: 0,
                    Iade3: 0,
                    Taksit3: 0,
                    TVade3: null,
                    PosKodu3: '',
                    CCNo4: '',
                    Tip4: '',
                    Ay4: 0,
                    Yil4: 0,
                    Tutar4: 0,
                    Iade4: 0,
                    Taksit4: 0,
                    TVade4: null,
                    PosKodu4: '',
                    PesinSatisTutari: 0,
                    PesinIadeTutari: 0,
                    SlipKod1: '',
                    SlipKod2: '',
                    SlipKod3: '',
                    SlipKod4: '',
                    OdemeFaturaId: '',
                    OdemeSapEntegre: '',
                }
            },
            faturanodisabled: false,
            UcusList: [],
            UcusListesi: {
                Ucus1: {
                    Aktarma: false,
                    BiletNo: '',
                    FareBases: 0,
                    Formno: '',
                    ID: '',
                    Parkur: '',
                    ParkurNo: '',
                    SirketKodu: '',
                    UcusClass: '',
                    UcusClassTip: null,
                    UcusHY: '',
                    UcusNo: '',
                    UcusSaat: '',
                    UcusTarihi: null,
                    VarisSaat: '',
                    VarisTarihi: null
                },
                Ucus2: {
                    Aktarma: false,
                    BiletNo: '',
                    FareBases: 0,
                    Formno: '',
                    ID: '',
                    Parkur: '',
                    ParkurNo: '',
                    SirketKodu: '',
                    UcusClass: '',
                    UcusClassTip: null,

                    UcusHY: '',
                    UcusNo: '',
                    UcusSaat: '',
                    UcusTarihi: null,
                    VarisSaat: '',
                    VarisTarihi: null
                },
                Ucus3: {
                    Aktarma: false,
                    BiletNo: '',
                    FareBases: 0,
                    Formno: '',
                    ID: '',
                    Parkur: '',
                    ParkurNo: '',
                    SirketKodu: '',
                    UcusClass: '',
                    UcusClassTip: null,

                    UcusHY: '',
                    UcusNo: '',
                    UcusSaat: '',
                    UcusTarihi: null,
                    VarisSaat: '',
                    VarisTarihi: null
                },
                Ucus4: {
                    Aktarma: false,
                    BiletNo: '',
                    FareBases: 0,
                    Formno: '',
                    ID: '',
                    Parkur: '',
                    ParkurNo: '',
                    SirketKodu: '',
                    UcusClass: '',
                    UcusClassTip: null,

                    UcusHY: '',
                    UcusNo: '',
                    UcusSaat: '',
                    UcusTarihi: null,
                    VarisSaat: '',
                    VarisTarihi: null
                },
                Ucus5: {
                    Aktarma: false,
                    BiletNo: '',
                    FareBases: 0,
                    Formno: '',
                    ID: '',
                    Parkur: '',
                    ParkurNo: '',
                    SirketKodu: '',
                    UcusClass: '',
                    UcusClassTip: null,

                    UcusHY: '',
                    UcusNo: '',
                    UcusSaat: '',
                    UcusTarihi: null,
                    VarisSaat: '',
                    VarisTarihi: null
                }
            },
            servisclass: {
                SirketKodu: '',
                Cari: {
                    Kod: null
                },
                Parkurlar: {
                    Parkur1: '',
                    Parkur2: '',
                    Parkur3: '',
                    Parkur4: '',
                    Parkur5: '',
                },
                Hat: '',
                DefaultKontrol: false
            },
            BiletAyrintiliOdeme: {
                SirketKodu: null,
                ID: 0,
                Tarih: getDateNow(),
                EvrakCinsi: null,
                Doviz: null,
                Kur: 0,
                Tutar: 0,
                DovizTutar: 0,
                PosKod: null,
                OdemeKod: 0,
                Nereden: null,
                EvrakNo: null,
                KrediKartNo: null,
                Aciklama: null,
                TaksitKod: null,
                TaksitKodLabel: null,
                PuanTutar: 0,
                BankaKod: null,
                KarsiCari: ' ',
                TanimID: 0,
                BiletNo: null,
                FormNo: null,
                CariKod: null,
                Referans: null,
                Masraf: null,
                Faturano: null,
                FaturaTarih: null,
                FaturaSeri: null
            },
            BiletIade: {
                GenelBilgileri: {
                    SirketKodu: '',
                    BiletNo: '',
                    Formno: '',
                    HavaYoluKodu: '',
                    Sirano: '',
                    UcusTip: '',
                    Cari: {
                        Kod: ''
                    },
                    Parkurlar: {
                        Parkur1: '',
                        Parkur2: '',
                        Parkur3: '',
                        Parkur4: '',
                        Parkur5: ''
                    },
                    IadeUcusTip: '', //enum
                    KesenKisi: '',
                    Masraf: {
                        Code: ''
                    },
                    Referans: {
                        Kod: ''
                    },
                    Crs: '', // enum
                    Notlar: '',
                },
                TarihBilgileri: {
                    IadeTarihi: null,
                    VadeTarihi: null,
                    IadeFaturaTarihi: null
                },
                FaturaBilgileri: {
                    IadeFaturaNo: null,
                    DekontNo: null,
                    ServisFaturaNo: null,
                    IadeFaturaGelenBelgeNo: null
                },
                TutarBilgileri: {
                    Doviz: {
                        DovizKod: null
                    },
                    Kur: 0,
                    NetTutar: {
                        NetTutar: 0,
                        NetTutarSatisDoviz: 0,
                        NetTutarAlisDoviz: 0,
                        NetTutarKdv: 0,
                    },
                    Tutar: {
                        Tutar: 0,
                        TutarSatisDoviz: 0,
                        TutarAlisDoviz: 0,
                        TutarKdv: 0,
                    },
                    AlanVergiTutar: {
                        AlanVergiTutar: 0,
                        AlanVergiSatisDoviz: 0,
                        AlanVergiAlisDoviz: 0,
                        AlanVergiKdv: 0
                    },
                    TaxTutar: {
                        TaxTutar: 0,
                        TaxSatisDoviz: 0,
                        TaxAlisDoviz: 0,
                        TaxKdv: 0
                    },
                    YffTutar: {
                        YFFTutar: 0,
                        YFFDoviz: 0,
                        YFFKdv: 0
                    },
                    IskontoTutar: {
                        IskontoYuzde: 0,
                        IskontoTutar: 0,
                        IskontoDoviz: 0,
                        IskontoKdv: 0
                    },
                    CezaTutar: {
                        CezaTutar: 0,
                        CezaSatisTutar: 0,
                        CezaAlisTutar: 0,
                        CezaKdv: 0,
                    },
                    KaTutar: {
                        KaTutar: 0,
                        KaDoviz: 0,
                        KaKdv: 0
                    },
                    ServisTutar: {
                        ServisTutar: 0,
                        ServisDoviz: 0,
                        ServisKdv: 0
                    },
                    IadeServisTutar: {
                        IadeServisTutar: 0,
                        IadeServisDoviz: 0,
                        IadeServisKdv: 0
                    },
                    DigerServisTutar: {
                        DigerServisTutar: 0,
                        DigerServisDoviz: 0,
                        DigerServisKdv: 0
                    },
                    ReserveTutar: {
                        ReserveYuzde: 0,
                        ReserveTutar: 0,
                        ReserveDoviz: 0,
                        ReserveKdv: 0
                    }
                },
                OdemeBilgileri: {
                    Odeme: false,
                    KrediliTutar: 0,
                    KrediliDvzTutar: 0,
                    PesinTutar: 0,
                    PesinDvzTutar: 0,
                    KrediKartTutar: 0,
                    KrediKartDvzTutar: 0,
                    HY: 0,
                    GSA: 0,
                    HavayoluTutar: 0,
                    Analiz: {
                        AnalizKod: ''
                    },
                    AnalizTutar: 0,
                    AnalizDvzTutar: 0,
                    Analiz1: {
                        AnalizKod: ''
                    },
                    AnalizTutar1: 0,
                    AnalizDvzTutar1: 0,
                },
                DigerBilgileri: {
                    IadeTanim: null,
                    Entegre: null,
                    ExIcDis: null,
                    CkLogId: null,
                    ParkurTip: null,
                    KKEnt: null,
                    IadeDekontID: null,
                    IadeMaliyetDekontID: null,
                    IadeSapEntegre: null,
                    IadeMaliyetSapEntegre: null,
                    // public Guid EntegrasyonID { get; set; }
                    ServisFark: false,
                    DekontPusula: '', //enum
                    AlisEntegre: null,
                }
                //  public LoginInfo LoginBilgileri { get; set; }
            },
            //----------------------------------------------------------------------------------------
            Fatura: {
                SirketKodu: null,
                FaturaTarih: null,
                FaturaSeri: null,
                FaturaNo: null,
                GibSeri: null,
                BiletBilgi: {
                    SirketKodu: null,
                    BiletNo: null,
                    FormNo: null,
                    OdemeTarihi: null,
                    CariKod: [],
                    NetTutar: 0

                },
                EFaturaBilgi: {
                    Unvani: null,
                    Unvani2: null,
                    Adres1: null,
                    Adres2: null,
                    IlceSehir: null,
                    Email: null,
                    VergiDairesi: null,
                    VergiNo: null,
                    TcKimlikNo: null,
                    Adi: null,
                    Soyadi: null,
                    TUnvani: null,
                    DigerAdi: null,
                    OnAdiEki: null,
                },
                FaturaBilgi: {
                    FaturaTip: 'O',
                    FaturaID: 2,
                    FaturaXSLTID: null,
                    FaturaPdfID: 0,
                    FaturaDipAciklama: null
                },
                Opsiyonlar: {
                    YolcuGosterme: false,
                    DovizliFatura: false,
                    FaturaDetayBas: false,
                    OdemeVade: false,
                    UnvanAdres: false,
                    FaturaTekSatir: false,
                    OdemeSekliGrup: false
                },
                EArsivBilgi: {
                    GonderimSekli: null,
                    InternetSatis: null,
                    WebAdresi: null,
                    OdemeSekli: null,
                    OdemeSekliAciklama: null,
                    OdemeAraci: null,
                    OdemeTarihi: null,
                },
                DovizBilgi: {
                    EDovizTipi: null,
                    EKur: 0,
                    DDovizTipi: null,
                    DKur: 0
                }
            },
            yenidialog: false,
            tabcontroltahsilat: 0,
            tabcontrolodeme: 0,
            tabcontroliade: 0,
            tabcontroltutar: 0,
            tabcontrolsablon: 0,
            search3: '',
            searchcari: '',
            itemsairlinelist: [],
            odemeitems: [],
            tahsilatitems: [],
            analizitems: [],
            itemsparkur: [],
            bankapositems: [],
            classitems: [],
            Referans: [],
            satiritems: [],
            taksitsayi: [],
            odemesekilleri: [],
            dizaynsec: [],
            getControl:0,
            yedeksablonobjeler: [],
            kredikartiitems: [],
            xsltitems: [],
            itemsevraktipi: [],
            defaultvalue: null,
            tahsilatbtn: false,
            iadetab: false,
            postaksitsayi: {
                id: null,
                label: null
            },
            servispostaksitsayi: {
                id: null,
                label: null
            },
            servistaksitsayi: '',
            acentabiletimi: false,
            baslik_mesaji: '',
            ucus1: false,
            ucus2: false,
            ucus3: false,
            ucus4: false,
            ucus5: false,
            loadingdialog: false,
            servisdialog: false,
            tahsilatdialog: false,
            voiddialog: false,
            dialog_baslik: '',
            tcdialog: false,
            m: false,
            k: false,
            progress: false,
            drawer: null,
            baslik: '',
            e1: 0,
            Code: '',
            e2: true,
            yok: false,
            statecari: [],
            statecaritahsilat: [],
            servisitems: [],
            search: '',
            search1: '',
            earsivseridurum: null,
            loading: false,
            Uyelik: {
                MusteriInfo: {
                    MusteriID: null,
                    MusteriKod: null,
                },
                ProgramTip: [],
                UyelikTip: 0,
                UyelikBitis: null,
                KalanKontor: 0,
                UyelikStatus: false
            },
            cmkodu: [
                'C', 'M'
            ],
            doviztipi: [],
            ichattipi: [
                'D', 'D-', 'D+', 'K', 'K-', 'K+', 'U', 'U-', 'U+', 'L', 'L-', 'L+'
            ],
            kodmesajı: null,
            edoviztipishow: false,
            ddoviztipishow: false,
            anasatisislem: '',
            faturadialog: false,
            tahsilatguncellebuton: false,
            kisamesaj: '',
            dialogkisamesaj: false,
            servisposshow: true,
            bankaposshow: true,
            kredikartishow: true,
            slipnoshow: true,
            makbuznoshow: true,
            biletnodisabled: false,
            guncellebuton: false,
            guncellebtngorunum: false,
            voiddurum: false,
            voidiptalbtn: false,
            voidbtn: false,
            iadebtn: true,
            iadeitems: [],
            taksitsayiservis: [],
            taksitsayitahsilat: [],
            itemsbanka: [],
            bolumler: [],
            uyeliktipi: null,
            kalankontor: 0,
            dialoghydegistir: false,
            dictionary: {
                custom: {
                    faturaseri: {
                        required: () => 'zorunlu alan'
                    },
                    faturano: {
                        required: () => 'zorunlu alan'
                    },
                    faturatarih: {
                        required: () => this.$t('Please-select-a-date')
                    },
                    faturatagib: {
                        required: () => this.$t('Please-select-a-date')
                    },
                }
            },
            faturabtn: true,
            ichatmi: false,
            dishatmi: false,
            gibseri: [],
            faturanovarise: false,
            vadegunsayisi: 0,
            artieksi: null,
            StartDate: null,
            EndDate: null,
            kaydetbuton: false,
            datesatistarihi: null,
            date: null,
            menu: false,
            modal: false,
            dateFormatted: '',
            text1: '',
            stopControl:false,
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            carikod: '',
            unvan: '',
            active: '',
            changeTitleInfo:true,
            profilislemTipi: null,
            secilenprofilkayit: null,
            secilenprofilkayit1: null,
            yedeksecilenprofilkayit: null,
            tabletumveriler: [],
            tabloalanisimleri: [],
            itemssablon: [],
            itemsprofil: [],
            sablonobjeler: [],
            Sablon: {
                TemplateID: null,
                ProfilID: null,
            },

        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.prevRoute = from.path
        })
    },
    mounted() {

        this.$validator.localize('en', this.dictionary)

        this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

        if (this.sayfayetki.Status == true) {

         

            this.Bilet.GenelBilgileri.ArkmanUsers = null;

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.PB=credentials.ParaBirimi;
            //fatura unvan degısıklıgı
            if (credentials.AnaSirketKodu != 'WEB0000000342') {
                    this.changeTitleInfo = true;
            }else{
                this.changeTitleInfo = false;
            }

            var params1 = {
                CompanyCode: credentials.SirketKodu
            }

            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ClassList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.classitems = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-class'
                    this.progress = false
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-class'
                    this.progress = false
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/TicketHelpers/GetReserveName', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.RezTutarEtiket = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-class'
                    this.progress = false
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-class'
                    this.progress = false
                    this.snackbar = true
                }
            })

            this.$http.post(auth.API_URL + 'api/BankPos/List', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.bankapositems = response.body

                this.progress = false
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-bankpos'
                    this.progress = false
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-bankpos'
                    this.snackbar = true
                    this.progress = false
                }
            })

            if (this.$route.query.isl == 'get') {

                var biletparams = {
                    SirketKodu: credentials.SirketKodu,
                    BiletNo: this.$route.query.biletno,
                    HavaYoluKodu: this.$route.query.hyolukod,
                    UcusTipi: this.$route.query.ucustipi
                }

                if (credentials.AnaSirketKodu != 'WEB0000000127') {
                    this.loadingdialog = true
                }

                this.biletnodisabled = true
                this.kaydetbuton = false
                this.guncellebtngorunum = true

                this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.loadingdialog = false

                    this.ticketGetProcess(response.body,1);

                }, (response) => {
                    if (response.status === 0) {
                        this.loadingdialog = false
                        this.text1 = response.body.ExceptionMessage;
                        this.snackbar = true
                    } else {
                        this.loadingdialog = false
                        this.text1 = response.body.ExceptionMessage;
                        this.snackbar = true
                    }
                })

                if (this.$route.query.tab == 8) {
                    this.active = '8'
                }

                if (this.$route.query.tab == 7) {
                    this.active = '7'
                }

            } else if (this.$route.query.isl == 'yeni') {

                this.faturabtn = true
                this.yenidialog = true
                this.Bilet.GenelBilgileri.ClassTip = null
                this.ucussayi = 1
                this.ucus1 = true
                this.ucus2 = false
                this.ucus3 = false
                this.ucus4 = false
                this.ucus5 = false
                this.iadebtn = false

                this.voidbtn = false
                this.kaydetbuton = true
                this.guncellebtngorunum = false

                //K seçili olduğundan bunları yap
                this.bankaposshow = false

                // this.taksitsayi = []
                this.servisposshow = false
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
                this.taksitsayiservis = []
                this.kredikartishow = false
                this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null

                this.slipnoshow = false
                this.Bilet.OdemeBilgileri.Slipkod = null

                this.makbuznoshow = false
                this.Bilet.OdemeBilgileri.MakbuzNo = null
                this.Bilet.GenelBilgileri.Referans.Kod = null
                this.Bilet.OdemeBilgileri.SatisSekli = 'K'
                this.bankaposshow = false
                this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
                // bura this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0

            } else if (this.$route.query.isl == 'voidget') {

                var biletparamsvoid = {
                    SirketKodu: credentials.SirketKodu,
                    BiletNo: this.$route.query.biletno,
                    HavaYoluKodu: this.$route.query.hyolukod,
                    UcusTipi: this.$route.query.ucustipi
                }
                this.loadingdialog = true
                this.ucus1 = true
                this.ucus2 = true
                this.ucus3 = true
                this.ucus4 = true
                this.ucus5 = true

                this.$http.post(auth.API_URL + 'api/Ticket/VoidGet', biletparamsvoid, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.taksitgetir();
                    this.taksitgetirservis();

                    this.guncellebuton = true
                    this.baslik_mesaji = "-Bu bilet void olmuştur"
                    this.voiddurum = false
                    this.voidiptalbtn = true

                    var seciliitems = [{
                        unvan1: response.body.GenelBilgileri
                            .MusteriKodu
                            .Unvan,
                        id: response.body.GenelBilgileri.MusteriKodu.Kod
                    }]

                    this.statecari = seciliitems
                    this.bekletme = true

                    if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
                        this.Bilet.GenelBilgileri.MusteriKodu.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
                    }

                    this.postaksitsayi.id = parseInt(response.body.OdemeBilgileri.BankaBilgileri.TaksitKod)
                    this.postaksitsayi.label = response.body.OdemeBilgileri.BankaBilgileri.TaksitKodLabel

                    this.servistaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.ServisTaksitKod

                    if (response.body.GenelBilgileri.RecordTypeInfo == null) {

                        var boskayit = {
                            RecordTypeID: 0,
                            RecordTypeExp: null
                        }
                        response.body.GenelBilgileri.RecordTypeInfo = boskayit
                    }

                    this.Bilet = response.body

                    this.UcusList = response.body.UcusBilgileri.UcusListesi

                    if (response.body.GenelBilgileri.Acente != '' && response.body.GenelBilgileri.Acente != null) {
                        this.baslik_mesaji = "(Bu bilet acenteden alınmış ve void olmuştur)"
                    } else {
                        this.baslik_mesaji = null
                    }

                    if (this.UcusList.length > 0) {

                        var i = 0
                        this.UcusList.forEach(element => {

                            if (i == 0 && i < this.UcusList.length) {
                                this.ucus1 = true
                                this.UcusListesi.Ucus1.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus1.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus1.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus1.FareBases = 0
                                }

                                this.UcusListesi.Ucus1.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus1.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus1.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus1.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus1.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus1.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus1.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus1.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus1.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus1.UcusSaat = this.UcusList[i].UcusSaat
                                this.UcusListesi.Ucus1.UcusTarihi = this.UcusList[i].UcusTarihi
                                this.UcusListesi.Ucus1.VarisSaat = this.UcusList[i].VarisSaat
                                this.UcusListesi.Ucus1.VarisTarihi = this.UcusList[i].VarisTarihi
                                i = i + 1
                            }
                            if (i == 1 && i < this.UcusList.length) {
                                this.ucus2 = true
                                this.UcusListesi.Ucus2.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus2.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus2.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus2.FareBases = 0
                                }
                                this.UcusListesi.Ucus2.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus2.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus2.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus2.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus2.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus2.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus2.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus2.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus2.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus2.UcusSaat = this.UcusList[i].UcusSaat
                                this.UcusListesi.Ucus2.UcusTarihi = this.UcusList[i].UcusTarihi
                                this.UcusListesi.Ucus2.VarisSaat = this.UcusList[i].VarisSaat
                                this.UcusListesi.Ucus2.VarisTarihi = this.UcusList[i].VarisTarihi
                                i = i + 1
                            }
                            if (i == 2 && i < this.UcusList.length) {
                                this.ucus3 = true
                                this.UcusListesi.Ucus3.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus3.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus3.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus3.FareBases = 0
                                }
                                this.UcusListesi.Ucus3.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus3.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus3.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus3.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus3.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus3.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus3.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus3.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus3.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus3.UcusSaat = this.UcusList[i].UcusSaat
                                this.UcusListesi.Ucus3.UcusTarihi = this.UcusList[i].UcusTarihi
                                this.UcusListesi.Ucus3.VarisSaat = this.UcusList[i].VarisSaat
                                this.UcusListesi.Ucus3.VarisTarihi = this.UcusList[i].VarisTarihi
                                i = i + 1
                            }

                            if (i == 3 && i < this.UcusList.length) {
                                this.ucus4 = true
                                this.UcusListesi.Ucus4.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus4.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus4.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus4.FareBases = 0
                                }
                                this.UcusListesi.Ucus4.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus4.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus4.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus4.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus4.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus4.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus4.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus4.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus4.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus4.UcusSaat = this.UcusList[i].UcusSaat
                                this.UcusListesi.Ucus4.UcusTarihi = this.UcusList[i].UcusTarihi
                                this.UcusListesi.Ucus4.VarisSaat = this.UcusList[i].VarisSaat
                                this.UcusListesi.Ucus4.VarisTarihi = this.UcusList[i].VarisTarihi
                                i = i + 1
                            }

                            if (i == 4 && i < this.UcusList.length) {
                                this.ucus5 = true
                                this.UcusListesi.Ucus5.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus5.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus5.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus5.FareBases = 0
                                }
                                this.UcusListesi.Ucus5.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus5.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus5.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus5.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus5.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus5.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus5.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus5.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus5.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus5.UcusSaat = this.UcusList[i].UcusSaat
                                this.UcusListesi.Ucus5.UcusTarihi = this.UcusList[i].UcusTarihi
                                this.UcusListesi.Ucus5.VarisSaat = this.UcusList[i].VarisSaat
                                this.UcusListesi.Ucus5.VarisTarihi = this.UcusList[i].VarisTarihi
                                i = i + 1
                            }
                        });
                    }
                    this.loadingdialog = false
                    this.analizkontrol = true

                }, (response) => {
                    if (response.status === 0) {

                        this.loadingdialog = false

                        this.text1 = 'Service Unavailable'
                        this.snackbar = true

                    } else {

                        this.loadingdialog = false

                        this.text1 = 'Service Unavailable'
                        this.snackbar = true

                    }
                })

            }

        } else {

            this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

                if (sonuc == true) {

                    if (this.prevRoute != null) {
                        let url = '#' + this.prevRoute

                        window.open(url, '_self')
                    } else {
                        let url = '#/'
                        window.open(url, '_self')
                    }
                }

            });

        }

    },
    filters: {

        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },
        bakiyekontrol: function (m) {
            return helpers.bakiyekontrol(m);
        }

    },
    methods: {
         getcostcentertitle() {

 var credentials = JSON.parse(window.localStorage.getItem('credentials'));
 var params1 = {
   CompanyCode:credentials.SirketKodu,
   Code: this.Bilet.GenelBilgileri.Masraf.Code,
  }
  this.$http.post(auth.API_URL + 'api/ExpenseCenter/Get', params1, {
    headers: {
      'Authorization': 'Bearer ' + auth.getAuthHeader()
    }
  }).then((response) => {
      
                    this.Bilet.NotlarBilgileri.Aciklama2 = this.Bilet.NotlarBilgileri.Aciklama2.replace(this.Bilet.GenelBilgileri.Masraf.Title,'');
                    this.Bilet.NotlarBilgileri.Aciklama2 +=' ' + response.body[0].CodeName;
                    this.Bilet.GenelBilgileri.Masraf.Title=response.body[0].CodeName;
  }, (response) => {
    if (response.status === 0) {
      this.text1 = 'Service Unavailable-masrafmerkezi'
      this.snackbar = true
      this.progress = false
    } else {
      this.text1 = 'Service Unavailable-masrafmerkezi'
      this.snackbar = true
      this.progress = false
    }
  })
 
},
        ticketGetProcess(ticketResponse,process){
            //process 1 : get page load 2: after save
            this.counter = 0;
            this.$route.query.isl = "get";
            this.faturabtn = false;
            this.biletnodisabled = true
            this.kaydetbuton = false
            this.guncellebtngorunum = true
            if(process == 2){
            let urlYeniBilet = '#/bilet/yeni/id?'+ 'isl=get&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +'&biletno=' + this.Bilet.GenelBilgileri.BiletNo + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi + '&tab=0'
             location.assign(urlYeniBilet);
             this.stopControl = true;
            }else{
            this.stopControl = false;
            }

            this.Bilet = ticketResponse;
          
             this.bekletme = true;

                    if (this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
                        this.tahsilatbtn = true
                    }

                    this.voiddurum = true

                    if (this.Bilet.GenelBilgileri.Status == 'S') {
                        this.miniTutar.Pesin = this.Bilet.OdemeBilgileri.PesinTutar
                        this.miniTutar.KrediKartli = this.Bilet.OdemeBilgileri.KrediKartTutar
                        this.miniTutar.Kredili = this.Bilet.OdemeBilgileri.KrediliTutar
                        this.miniTutar.PesinDoviz = this.Bilet.OdemeBilgileri.PesinDoviz
                        this.miniTutar.KrediKartliDoviz = this.Bilet.OdemeBilgileri.KrediKartDoviz
                        this.miniTutar.KrediliDoviz = this.Bilet.OdemeBilgileri.KrediliDoviz
                    }

                    this.KrediLimiti = this.Bilet.GenelBilgileri.MusteriKodu.KalanKrediLimit.toFixed(2).replace(
                        /(\d)(?=(\d{3})+\.)/g, '$1,')

                    this.Bilet.GenelBilgileri.Referans.Kod = String(this.Bilet.GenelBilgileri.Referans.Kod)

                    if (this.Bilet.GenelBilgileri.MusteriKodu.Kod != null) {
                        this.Bilet.GenelBilgileri.MusteriKodu.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
                    }
                    //burada çalışıyorum

                    this.servistaksitsayi = this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod

                    if (this.Bilet.FaturaBilgileri.FaturaNo != null && this.Bilet.FaturaBilgileri.FaturaNo != '') {
                        this.Fatura.FaturaTarih = this.Bilet.FaturaBilgileri.FaturaTarihi
                        this.Fatura.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri
                        this.Fatura.FaturaNo = this.Bilet.FaturaBilgileri.FaturaNo
                        this.faturanovarise = true
                    }

                    if (this.Bilet.FaturaBilgileri.FaturaSeri == 'H') {
                        this.faturalansinmi = false
                    }



                    var seciliitems = [{
                        unvan1: this.Bilet.GenelBilgileri
                            .MusteriKodu
                            .Unvan,
                        id: this.Bilet.GenelBilgileri.MusteriKodu.Kod
                    }]
                    this.caricompitems = seciliitems;

                    if(process == 2){
                         //bu kisim sadece bilet ilk kayitdan sonra calisacak. Cariye bagli olan compleri tetiklemek icin calistiriliyor
                        this.$refs.cariAnaComp.cariislemler();
                    }
                   
                    
                    
                    this.loadingdialog = false

                    this.taksitgetir();
                    this.taksitgetirservis();
                   
                    this.servispostaksitsayi.id = parseInt(this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod)
                    this.servispostaksitsayi.label = this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel

                    if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {

                        this.bankaposshow = false
                        this.servisposshow = false
                        this.kredikartishow = false
                        this.slipnoshow = false
                        this.makbuznoshow = false

                        this.postaksitsayi.id = null
                        this.postaksitsayi.label = null
                        this.servispostaksitsayi.id = null
                        this.servispostaksitsayi.label = null
                    }

                    if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
                        this.servisposshow = false
                        this.bankaposshow = false
                        this.kredikartishow = false
                        this.slipnoshow = false
                        this.makbuznoshow = true

                        this.postaksitsayi.id = null
                        this.postaksitsayi.label = null
                        this.servispostaksitsayi.id = null
                        this.servispostaksitsayi.label = null
                    }

                    if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
                        this.servisposshow = false
                        this.bankaposshow = true
                        this.kredikartishow = true
                        this.slipnoshow = true
                        this.makbuznoshow = true

                        this.postaksitsayi.id = parseInt(this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod)
                        this.postaksitsayi.label = this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel
                        this.servispostaksitsayi.id = null
                        this.servispostaksitsayi.label = null
                    }

                    if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
                        this.servisposshow = true
                        this.bankaposshow = true
                        this.kredikartishow = true
                        this.slipnoshow = true
                        this.makbuznoshow = true

                        this.postaksitsayi.id = null
                        this.postaksitsayi.label = null
                        this.servispostaksitsayi.id = parseInt(this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod)
                        this.servispostaksitsayi.label = this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel
                    }

                    if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
                        this.servisposshow = true
                        this.bankaposshow = true
                        this.kredikartishow = true
                        this.slipnoshow = true
                        this.makbuznoshow = true
                        this.postaksitsayi.id = parseInt(this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod)
                        this.postaksitsayi.label = this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel
                        this.servispostaksitsayi.id = parseInt(this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod)
                        this.servispostaksitsayi.label = this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel

                    }

                    this.UcusList = this.Bilet.UcusBilgileri.UcusListesi

                    // fatura no varsa güncellenemez void yapılamaz
                    var fatno = this.Bilet.FaturaBilgileri.FaturaNo

                    if (fatno != null && fatno != 0) {
                        this.guncellebuton = true
                        this.faturabtn = true
                        this.voiddurum = true
                        this.voidbtn = false
                        // this.iadebnt = false
                        this.faturanodisabled = true
                    } else {
                        this.faturanodisabled = false
                        this.guncellebuton = false
                        this.voiddurum = false
                        this.faturabtn = false
                        this.voidbtn = true
                        //  this.iadebtn = true

                    }

                    if (this.Bilet.GenelBilgileri.Acente == 'A') {
                        this.baslik_mesaji = '*** Bu bilet ' + this.Bilet.GenelBilgileri.AcenteKodu +
                            ' acentasından alınmıştır'
                    } else {
                        this.baslik_mesaji = ""

                    }
                    if (this.UcusList.length > 0) {

                        var i = 0

                        this.UcusList.forEach(element => {

                            if (i == 0 && i < this.UcusList.length) {

                                this.UcusListesi.Ucus1.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus1.BiletNo = this.UcusList[i].BiletNo

                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus1.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus1.FareBases = 0
                                }

                                this.UcusListesi.Ucus1.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus1.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus1.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus1.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus1.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus1.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus1.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus1.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus1.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus1.UcusSaat = this.UcusList[i].UcusSaat

                                if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus1.UcusTarihi = null
                                } else {
                                    this.UcusListesi.Ucus1.UcusTarihi = this.UcusList[i].UcusTarihi
                                }

                                this.UcusListesi.Ucus1.VarisSaat = this.UcusList[i].VarisSaat

                                if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus1.VarisTarihi = null
                                } else {
                                    this.UcusListesi.Ucus1.VarisTarihi = this.UcusList[i].UcusTarihi
                                }

                                i = i + 1
                            }
                            if (i == 1 && i < this.UcusList.length) {

                                this.UcusListesi.Ucus2.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus2.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus2.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus2.FareBases = 0
                                }
                                this.UcusListesi.Ucus2.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus2.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus2.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus2.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus2.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus2.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus2.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus2.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus2.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus2.UcusSaat = this.UcusList[i].UcusSaat

                                if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus2.UcusTarihi = null
                                } else {
                                    this.UcusListesi.Ucus2.UcusTarihi = this.UcusList[i].UcusTarihi
                                }
                                this.UcusListesi.Ucus2.VarisSaat = this.UcusList[i].VarisSaat

                                if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus2.VarisTarihi = null
                                } else {
                                    this.UcusListesi.Ucus2.VarisTarihi = this.UcusList[i].VarisTarihi
                                }
                                i = i + 1
                            }

                            if (i == 2 && i < this.UcusList.length) {

                                this.UcusListesi.Ucus3.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus3.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus3.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus3.FareBases = 0
                                }
                                this.UcusListesi.Ucus3.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus3.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus3.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus3.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus3.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus3.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus3.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus3.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus3.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus3.UcusSaat = this.UcusList[i].UcusSaat

                                if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus3.UcusTarihi = null
                                } else {
                                    this.UcusListesi.Ucus3.UcusTarihi = this.UcusList[i].UcusTarihi
                                }

                                this.UcusListesi.Ucus3.VarisSaat = this.UcusList[i].VarisSaat

                                if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus3.VarisTarihi = null
                                } else {
                                    this.UcusListesi.Ucus3.VarisTarihi = this.UcusList[i].VarisTarihi
                                }

                                i = i + 1
                            }

                            if (i == 3 && i < this.UcusList.length) {

                                this.UcusListesi.Ucus4.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus4.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus4.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus4.FareBases = 0
                                }
                                this.UcusListesi.Ucus4.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus4.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus4.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus4.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus4.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus4.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus4.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus4.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus4.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus4.UcusSaat = this.UcusList[i].UcusSaat

                                if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus4.UcusTarihi = null
                                } else {
                                    this.UcusListesi.Ucus4.UcusTarihi = this.UcusList[i].UcusTarihi
                                }

                                if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus4.VarisTarihi = null
                                } else {
                                    this.UcusListesi.Ucus4.VarisTarihi = this.UcusList[i].VarisTarihi
                                }

                                this.UcusListesi.Ucus4.VarisSaat = this.UcusList[i].VarisSaat

                                i = i + 1
                            }

                            if (i == 4 && i < this.UcusList.length) {

                                this.UcusListesi.Ucus5.Aktarma = this.UcusList[i].Aktarma
                                this.UcusListesi.Ucus5.BiletNo = this.UcusList[i].BiletNo
                                if (this.UcusList[i].FareBases != null && this.UcusList[i].FareBases != "") {
                                    this.UcusListesi.Ucus5.FareBases = parseFloat(this.UcusList[i].FareBases)
                                } else {
                                    this.UcusListesi.Ucus5.FareBases = 0
                                }
                                this.UcusListesi.Ucus5.Formno = this.UcusList[i].Formno
                                this.UcusListesi.Ucus5.ID = this.UcusList[i].ID
                                this.UcusListesi.Ucus5.Parkur = this.UcusList[i].Parkur
                                this.UcusListesi.Ucus5.ParkurNo = this.UcusList[i].ParkurNo
                                this.UcusListesi.Ucus5.SirketKodu = this.UcusList[i].SirketKodu
                                this.UcusListesi.Ucus5.UcusClass = this.UcusList[i].UcusClass
                                this.UcusListesi.Ucus5.UcusClassTip = this.UcusList[i].UcusClassTip
                                this.UcusListesi.Ucus5.UcusHY = this.UcusList[i].UcusHY
                                this.UcusListesi.Ucus5.UcusNo = this.UcusList[i].UcusNo
                                this.UcusListesi.Ucus5.UcusSaat = this.UcusList[i].UcusSaat

                                if (this.UcusList[i].VarisTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus5.VarisTarihi = null
                                } else {
                                    this.UcusListesi.Ucus5.VarisTarihi = this.UcusList[i].VarisTarihi
                                }

                                if (this.UcusList[i].UcusTarihi == '0001-01-01T00:00:00') {
                                    this.UcusListesi.Ucus5.UcusTarihi = null
                                } else {
                                    this.UcusListesi.Ucus5.UcusTarihi = this.UcusList[i].UcusTarihi
                                }

                                this.UcusListesi.Ucus5.VarisSaat = this.UcusList[i].VarisSaat
                                i = i + 1
                            }
                        });
                    }

                    if (this.Bilet.GenelBilgileri.Status == 'Ia' && this.Bilet.IadeFaturala == false) {

                        this.faturabtn = true
                        this.iadetab = true

                    } else if (this.Bilet.GenelBilgileri.Status == 'Ia' && this.Bilet.IadeFaturala == true) {
                        if (fatno != null && fatno != '') {
                            this.faturabtn = true
                            this.iadetab = true
                        } else {
                            this.faturabtn = false
                            this.iadetab = true
                        }

                    } else {

                        this.iadetab = false
                    }
                    this.Sablon.TemplateID=this.Bilet.TanimBilgileri.SablonID ;
                    this.Sablon.ProfilID= this.Bilet.TanimBilgileri.ProfilID  ;
                    if (this.Sablon.TemplateID!=null && this.Bilet.TanimBilgileri.ProfilID!=null)
                    {
                        this.sablondetaygetir(this.Bilet.TanimBilgileri.ProfilID);
                    }
                    this.Sablon.ProfilID= this.Bilet.TanimBilgileri.ProfilID  ;
                  
                    // this.Bilet.NotlarBilgileri.Aciklama2 = this.Bilet.NotlarBilgileri.Aciklama2.replace(this.Bilet.GenelBilgileri.Masraf.Code,'');
                    // this.Bilet.NotlarBilgileri.Aciklama2 +=' ' + this.Bilet.GenelBilgileri.Masraf.Title;
                    this.analizkontrol = true

        },
        kurgetirservis2(tarih,kod,IskontoTutar,ServisTutar) {
           if (kod=='' || kod==null)
           {
            return;
           }
          
            var params1 = {
                Tarih: tarih,
                DovizKod: kod
            }
          
            this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
                headers: auth.getAuthCompaniesInfo()
            }).then((response) => {
              
                  console.log(response.body);
                      if(response.body == 0.0){
                        
                    }else{
                       
                        this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar =  IskontoTutar * response.body
                        this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = ServisTutar * response.body
                    }
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-Kur Hesapla'
                    this.snackbar = true
                   
                } else {
                    this.text1 = 'Service Unavailable-Kur Hesapla'
                    this.snackbar = true
                    
                }
            })


},
        ticketGroupAdd(){
            this.Bilet.TanimBilgileri.ProfilID = this.Sablon.ProfilID;
            this.Bilet.TanimBilgileri.SablonID= this.Sablon.TemplateID;
            this.Bilet.GenelBilgileri.BiletNo = this.toplubilet[this.sentTicketNumber].BiletNo;
            this.Bilet.GenelBilgileri.YolcuAdi = this.toplubilet[this.sentTicketNumber].YolcuAdi;
            
            var paramsbilet = this.Bilet;

            this.$http.post(auth.API_URL + 'api/Ticket/TicketAdd', paramsbilet, {
               headers: {
                   'Authorization': 'Bearer ' + auth.getAuthHeader()
               }
           }).then((response) => {
              
              //islem sonrasi sonuclari gostermek icin liste olusturuluyor.
              var result;
              if(response.body.Status == true){
                result = {
                      TicketNo: this.toplubilet[this.sentTicketNumber].BiletNo,
                      ResponseMessage: response.body.ResponseMessage,
                      Status:true
                };
              }else{
                result = {
                      TicketNo: this.toplubilet[this.sentTicketNumber].BiletNo,
                      ResponseMessage: response.body.ResponseMessage,
                      Status:false
                };
              }
            
              this.groupTicketResultItems.push(result);
              this.sentTicketNumber += 1;

             //islem bittimi kontrolu
             if(this.sentTicketNumber == this.toplubilet.length){
                  this.groupTicketProgressDialog = false;
                  this.groupTicketDialog = true;
              }else{
                  this.ticketGroupAdd();
              }
               
           }, (response) => {
              var result = {
                      TicketNo: this.toplubilet[this.sentTicketNumber].BiletNo,
                      ResponseMessage: response.statusText,
                      Status:false
              };
              this.groupTicketResultItems.push(result);
              this.sentTicketNumber += 1;
             //islem bittimi kontrolu
             if(this.sentTicketNumber == this.toplubilet.length){
                  this.groupTicketProgressDialog = false;
                  this.groupTicketDialog = true;
              }else{
                  this.ticketGroupAdd();
              }
           })
        },
        getCurrentInfo(currentInfo){
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.eFaturaBilgi = currentInfo.EInvoiceCustomer
        this.Bilet.GenelBilgileri.MusteriKodu.Unvan = currentInfo.Title
        this.Fatura.EFaturaBilgi.Unvani = currentInfo.Title
        this.Fatura.EFaturaBilgi.Unvani2 = currentInfo.Title2
        this.Fatura.EFaturaBilgi.Adres1 = currentInfo.Invoice.Address
        this.Fatura.EFaturaBilgi.IlceSehir = currentInfo.Invoice.Province
        this.Fatura.EFaturaBilgi.Email = currentInfo.Email
        this.Fatura.EFaturaBilgi.VergiDairesi = currentInfo.Invoice.TaxOffice
        this.Fatura.EFaturaBilgi.VergiNo = currentInfo.Invoice.TaxNumber
        this.Fatura.EFaturaBilgi.TcKimlikNo = currentInfo.Invoice.IdentityNumber
        this.Fatura.EFaturaBilgi.Adi = currentInfo.Invoice.PerFirstName
        this.Fatura.EFaturaBilgi.Soyadi = currentInfo.Invoice.PerFamilyName
        this.Fatura.EFaturaBilgi.TUnvani = currentInfo.Invoice.PerTitle
        this.Fatura.EFaturaBilgi.DigerAdi = currentInfo.Invoice.PerMiddleName
        this.Fatura.EFaturaBilgi.OnAdiEki = currentInfo.Invoice.PerNameSuffix
        this.Bilet.GenelBilgileri.MusteriKodu.Uyari = currentInfo.WarningNote
        if(this.Bilet.GenelBilgileri.Masraf.Code == null || this.Bilet.GenelBilgileri.Masraf.Code == ""){
             this.Bilet.GenelBilgileri.Masraf.Code = currentInfo.ExpenseCenter;
        }

        if (currentInfo.AnalysisCode !== null && currentInfo.AnalysisCode !== "" && currentInfo.AnalysisCode.length > 0) {
            this.Bilet.TanimBilgileri.AnalizKod.AnalizKod = currentInfo.AnalysisCode
            this.$root.$emit('eventing', currentInfo.AnalysisCode);
        } else {
            this.$root.$emit('eventing', currentInfo.AnalysisCode);
        }

        

        this.analizCompShow = true
        if (this.$route.query.isl == 'get' && this.ilkgiriskontrol == true) {} else {
            this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = parseFloat(this.cariyeGoreIskontoHesapla(currentInfo));
        }

        if (this.$route.query.isl == 'yeni' && this.ilkgiriskontrol == true) {

            if (currentInfo.EArchiveSendType == true) {

                this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 1;
            } else {
                this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 0;
            }
        }

        if (currentInfo.EArchiveSendType == true && this.ilkgiriskontrol == false) {
            this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 1;
        } else if (currentInfo.EArchiveSendType == false && this.ilkgiriskontrol == false) {
            this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli = 0;
        }

        //0 ise Earşiv / 1 ise gib seri

        if (currentInfo.EInvoiceCustomer == 1) {
            this.earsivseridurum = 1
        }

        if (currentInfo.EInvoiceCustomer == 0) {
            this.earsivseridurum = 0
        }

            if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '' && this
            .Bilet.GenelBilgileri.MusteriKodu.Kod != '' && this.Bilet.GenelBilgileri.MusteriKodu.Kod != null) {

            if ((this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') && this
                .ilkgiriskontrol == false && this.$route.query.isl == 'get') {

                var paramsgetexpritydate = {
                    SatisTarihi: this.Bilet.TarihBilgileri.SatisTarihi,
                    UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
                    CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
                    SirketKodu: credentials.SirketKodu,
                }

                this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsgetexpritydate, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.ilkgiriskontrol = false
                    if (String(response.body) != "0001-01-01T00:00:00") {
                        this.Bilet.TarihBilgileri.OdemeTarihi = response.body
                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
            }

            if (this.$route.query.isl == 'yeni') {
                        
                var paramsGetExpiryDate = {
                    SatisTarihi: this.Bilet.TarihBilgileri.SatisTarihi,
                    UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
                    CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
                    SirketKodu: credentials.SirketKodu,
                }
                this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsGetExpiryDate, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.ilkgiriskontrol = false
                    if (String(response.body) != "0001-01-01T00:00:00") {
                        this.Bilet.TarihBilgileri.OdemeTarihi = response.body
                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
            }

        }

        this.ilkgiriskontrol = false


        },
        odemeTarihDegistir(){
           this.Bilet.TarihBilgileri.OdemeTarihi = this.odemeDialogTarih;
           this.odemeDialog = false;
        },
        checkCounter(){
            this.counter += 1;
            if (this.counter == 1) {
                if(this.Bilet.TutarBilgileri.TevkifatTutar.TevkifatKodu != null && this.Bilet.TutarBilgileri.TevkifatTutar.TevkifatKodu != '' &&
                    this.Bilet.TutarBilgileri.TevkifatTutar.TevkifatOran == 0 ){
                    this.text1 = this.$t('Please-Select-Withholding-Rate.');
                    this.snackbar = true;
                    this.counter = 0;
                }else{
                     this.biletkaydet();
                }   
             
            }
        },
        ServisYuzdeAnalizKod() {
            if (this.AnalizOran != -1) {
                var Tutar = 0
                this.analizCompShow = true

                Tutar = (this.Bilet.TutarBilgileri.ServisTutar.ServisTutar * this.AnalizOran) / 100
                this.Bilet.TanimBilgileri.AnalizTutar = Number(Tutar)
            }
        },
        analizKontrolYuzde(val) {
            this.AnalizOran = val
        },
        tutarEkle() {
            this.tahsilatbakiyeHesapla();
        },
        odakkaybiServis(v) {
            if (this.Bilet.GenelBilgileri.MusteriKodu.Kod != null && this.Bilet.GenelBilgileri.MusteriKodu.Kod != '') {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                var CurrentInput = {
                    Code: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
                    CompanyCode: credentials.SirketKodu
                }
                this.$http.post(auth.API_URL + 'api/Current/Get', CurrentInput, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = parseFloat(this.cariyeGoreIskontoHesapla(response.body));

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = response.body.StatusText
                        this.snackbar = true
                    }
                })
            }

        },
        cariyeGoreIskontoHesapla(caribilgi) {
            var iskontoYuzde = 0
            if (this.Bilet.GenelBilgileri.UcusTipi == "I") {
                iskontoYuzde = caribilgi.DiscountDomService
            } else {
                iskontoYuzde = caribilgi.DiscountIntService
            }
            var tutar = 0;

            if (this.Bilet.TutarBilgileri.ServisTutar.ServisTutar != 0) {
                tutar = (this.Bilet.TutarBilgileri.ServisTutar.ServisTutar / 100) * iskontoYuzde

                return tutar;
            } else {

                return tutar;
            }

        },
        odakSatisTarihi(v) {

            if (v != null && v != undefined) {
                if (this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                    if (v != null && v != '' && this.Bilet.GenelBilgileri.MusteriKodu.Kod != '' && this.Bilet.GenelBilgileri
                        .MusteriKodu.Kod != null) {
                        var paramsgetexpritydate = {
                            SatisTarihi: v,
                            UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
                            CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
                            SirketKodu: credentials.SirketKodu,
                        }

                        if (this.$route.query.isl == 'yeni') {

                            this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsgetexpritydate, {
                                headers: {
                                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                                }
                            }).then((response) => {

                                if (String(response.body) != "0001-01-01T00:00:00") {

                                    this.Bilet.TarihBilgileri.OdemeTarihi = response.body
                                }

                            })
                        } else if (this.$route.query.isl == 'get' && this.ilkgirissatistarihkontrol == false && this.stopControl == false) {

                            this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsgetexpritydate, {
                                headers: {
                                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                                }
                            }).then((response) => {

                                if (String(response.body) != "0001-01-01T00:00:00") {

                                    this.Bilet.TarihBilgileri.OdemeTarihi = response.body
                                }

                            })

                        }

                    }

                }
            }
            this.ilkgirissatistarihkontrol = false
        },
        satissekliChange() {
            if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
                this.Bilet.TarihBilgileri.OdemeTarihi = this.Bilet.TarihBilgileri.SatisTarihi
            }
            else if(this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F'){
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var paramsExpDate = {
                    SatisTarihi: this.Bilet.TarihBilgileri.SatisTarihi,
                    UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
                    CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
                    SirketKodu: credentials.SirketKodu,
                }

                this.$http.post(auth.API_URL + 'api/Helpers/GetExpiryDate', paramsExpDate, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    if (String(response.body) != "0001-01-01T00:00:00") {
                        if(this.Bilet.TarihBilgileri.OdemeTarihi != response.body.split('T')[0]){
                            this.odemeDialog = true;
                            this.odemeDialogTarih = response.body;
                        }
                    }else{
                         if(this.Bilet.TarihBilgileri.SatisTarihi != this.Bilet.TarihBilgileri.OdemeTarihi){
                            this.odemeDialog = true;
                            this.odemeDialogTarih = this.Bilet.TarihBilgileri.SatisTarihi;
                        }
                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
            }



        },
        odakminikredili(v) {
            this.miniTutar.Kredili = this.Bilet.TutarBilgileri.Kur * v;
        },
        odakminipesin(v) {
            this.miniTutar.Pesin = this.Bilet.TutarBilgileri.Kur * v;
        },
        odakminikredikartli(v) {
            this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.Kur * v;
        },
        getTaksitLabel() {
            if (this.postaksitsayi.id != undefined) {

                this.taksitsayi.forEach(element => {
                    if (element.TaksitID == this.postaksitsayi.id) {
                        this.postaksitsayi.label = element.TaksitAciklama
                    }
                });
            } else {
                this.postaksitsayi.label = null
            }

        },
        getServisTaksitLabel() {
            if (this.servispostaksitsayi.id != undefined) {

                this.taksitsayiservis.forEach(element => {
                    if (element.TaksitID == this.servispostaksitsayi.id) {
                        this.servispostaksitsayi.label = element.TaksitAciklama
                    }
                });
            } else {
                this.servispostaksitsayi.label = null
            }

        },

        getparabirimi() {
            return helpers.getparabirimi()
        },
        roundNumber(num, scale) {
            if (!("" + num).includes("e")) {
                return +(Math.round(num + "e+" + scale) + "e-" + scale);
            } else {
                var arr = ("" + num).split("e");
                var sig = ""
                if (+arr[1] + scale > 0) {
                    sig = "+";
                }
                return +(Math.round(+arr[0] + "e" + sig + (+arr[1] + scale)) + "e-" + scale);
            }
        },
        faturaEBDuzenle() {
            var url = '#/bilet/faturalibiletduzenle/id?' + 'isl=edit&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
                '&biletno=' +
                this.Bilet.GenelBilgileri.BiletNo + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi
            window.open(url, '_self')
        },

        tahsilatdagitduzenle() {
              
            if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {

                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }
                this.miniTutar.Kredili = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur

                this.miniTutar.Pesin = 0
                this.miniTutar.PesinDoviz = 0
                this.miniTutar.KrediKartli = 0
                this.miniTutar.KrediKartliDoviz = 0

            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {

                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }
                this.miniTutar.Pesin = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.PesinDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur

                this.miniTutar.Kredili = 0
                this.miniTutar.KrediliDoviz = 0

                this.miniTutar.KrediKartli = 0
                this.miniTutar.KrediKartliDoviz = 0

            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'C' || this.Bilet.OdemeBilgileri.SatisSekli == 'R' || this.Bilet
                .OdemeBilgileri.SatisSekli == 'F') {
                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }
                this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
                    .Kur
                this.miniTutar.Kredili = 0
                this.miniTutar.KrediliDoviz = 0
                this.miniTutar.Pesin = 0
                this.miniTutar.PesinDoviz = 0

            }

        },
        dialogtahsilatdag() {
            this.dialogtahsilatdagit = true
        },
        tahsilatal() {
            this.miniTutar.Pesin = this.Bilet.OdemeBilgileri.PesinTutar
            this.miniTutar.KrediKartli = this.Bilet.OdemeBilgileri.KrediKartTutar
            this.miniTutar.Kredili = this.Bilet.OdemeBilgileri.KrediliTutar
            this.miniTutar.PesinDoviz = this.Bilet.OdemeBilgileri.PesinDoviz
            this.miniTutar.KrediKartliDoviz = this.Bilet.OdemeBilgileri.KrediKartDoviz
            this.miniTutar.KrediliDoviz = this.Bilet.OdemeBilgileri.KrediliDoviz
        },
        tahsilatAyarla() {
                
            var top = this.roundNumber(this.miniTutar.Kredili + this.miniTutar.Pesin + this.miniTutar.KrediKartli, 2)

            if (top != 0) {
                
                if (top == this.Bilet.TutarBilgileri.NetTutar.NetTutar) {
                     
                    this.Bilet.OdemeBilgileri.PesinTutar = this.miniTutar.Pesin
                    this.Bilet.OdemeBilgileri.KrediKartTutar = this.miniTutar.KrediKartli
                    this.Bilet.OdemeBilgileri.KrediliTutar = this.miniTutar.Kredili


                    this.Bilet.OdemeBilgileri.PesinDoviz = this.miniTutar.PesinDoviz
                    this.Bilet.OdemeBilgileri.KrediKartDoviz = this.miniTutar.KrediKartliDoviz
                    this.Bilet.OdemeBilgileri.KrediliDoviz = this.miniTutar.KrediliDoviz
                    return true

                } else {
                    this.loadingdialog = false;
                    this.text1 = this.$t('The-total-collection-amount-must-equal-the-net-amount.')
                    this.snackbar = true
                    this.counter = 0;
                    return false
                }
            } else {
                     
                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                    
                }

                if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {
                    
                    this.miniTutar.Kredili = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                    this.miniTutar.KrediliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur
                    this.miniTutar.Pesin = 0
                    this.miniTutar.PesinDoviz = 0
                    this.miniTutar.KrediKartli = 0
                    this.miniTutar.KrediKartliDoviz = 0
                }

                if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
                    
                    this.miniTutar.Pesin = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                    this.miniTutar.PesinDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur
                    this.miniTutar.Kredili = 0
                    this.miniTutar.KrediliDoviz = 0
                    this.miniTutar.KrediKartli = 0
                    this.miniTutar.KrediKartliDoviz = 0
                }

                if (this.Bilet.OdemeBilgileri.SatisSekli != 'K' || this.Bilet.OdemeBilgileri.SatisSekli != 'P') {
                    
                    this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                    this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
                        .Kur
                    this.miniTutar.Kredili = 0
                    this.miniTutar.KrediliDoviz = 0
                    this.miniTutar.Pesin = 0
                    this.miniTutar.PesinDoviz = 0
                }
                return true
                 
            }

        },
        cariservisgetir() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
            this.servisclass.SirketKodu = credentials.SirketKodu
            this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
            this.servisclass.Parkurlar.Parkur1 = this.Bilet.GenelBilgileri.Parkurlar.Parkur1
            this.servisclass.Parkurlar.Parkur2 = this.Bilet.GenelBilgileri.Parkurlar.Parkur2
            this.servisclass.Parkurlar.Parkur3 = this.Bilet.GenelBilgileri.Parkurlar.Parkur3
            this.servisclass.Parkurlar.Parkur4 = this.Bilet.GenelBilgileri.Parkurlar.Parkur4
            this.servisclass.Parkurlar.Parkur5 = this.Bilet.GenelBilgileri.Parkurlar.Parkur5
            this.servisclass.DefaultKontrol = true

            var params1 = this.servisclass

            this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                if (response.body.length != 0) {

                    this.Bilet.TanimBilgileri.ServisKod = response.body[0].Kod
                    var params = {
                        HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                        SirketKodu: credentials.SirketKodu,
                        ServisKodBilgi: response.body[0],
                        KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
                        TutarBilgi: {
                            ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
                            BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
                            VergiTutar: this.Bilet.TutarBilgileri.PtaTutar.PtaTutar + this.Bilet.TutarBilgileri.AlanVergiTutar
                                .AlanVergitutar +
                                this.Bilet.TutarBilgileri.YFFTutar.YFFTutar // mco + alan + ceza + yff
                        }
                    }

                    this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
                        headers: auth.getAuthCompaniesInfo()
                    }).then((response) => {
                       
                if (params.ServisKodBilgi.DovizKod!='')
                {
                    this.kurgetirservis2(this.Bilet.TarihBilgileri.SatisTarihi,params.ServisKodBilgi.DovizKod,response.body.IskontoTutar,response.body.ServisTutar)
                }
                else
                {
                    this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body.IskontoTutar 
                    this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body.ServisTutar 
                }
                        
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable-GetServiceCodePrice'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable-GetServiceCodePrice'
                            this.snackbar = true
                        }
                    })

                } else {

                }

            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        },

        uyelikKontorSorgula: function (hareketTip, hareketSayisi) {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var params = {
                MusteriID: credentials.MusteriID,
                HareketTip: hareketTip,
                HareketSayisi: hareketSayisi
            }

            this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                return response.body
            }, (response) => {

                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-ProductCustomerInfo'
                    this.snackbar = true
                    return null
                } else {
                    this.text1 = 'Service Unavailable-ProductCustomerInfo'
                    this.snackbar = true
                    return null
                }
            })
        },
        tahsilatbakiyeHesapla() {

            this.tahsilatBakiye = this.Bilet.TutarBilgileri.NetTutar.NetTutar
            this.tahsilatitems.forEach(element => {
                this.tahsilatBakiye = this.tahsilatBakiye - element.Tutar
            });
        },
        profilKaydet() {
            if (this.profilislemTipi != 'yeni') {

                if (this.Sablon.ProfilID != null) {
                    var detayobject = {};
                var duzenlenenveri = {}
                var duzenlenenkayit = []
                var Veriler = []

                this.sablonobjeler.forEach(element => {
                    if (element.type != 'I' && element.type != 'SI') {
                        var duzenlenenveri = {}
                        var element1 = document.getElementById(element.vmodelname);
                        if (element1 != null && element1.value!=null && element1.value!="") {
                            duzenlenenveri['AlanAdi'] = element.labeller
                            duzenlenenveri['AlanID'] = element1.id
                            if (element.type === 'M') {
                                var yedekveri = element1.value
                                yedekveri = yedekveri.replace("₺", "")
                                yedekveri = yedekveri.replace(",", "")
                                duzenlenenveri['Veri'] = yedekveri
                            } else if (element.type === 'B') {
                                var yedekveri = element1.value
                                yedekveri = yedekveri.replace(",", "")
                                duzenlenenveri['Veri'] = yedekveri
                            } else {
                                duzenlenenveri['Veri'] = element1.value
                            }
                            if (element.type === 'D') {
                               
                                // var parts = element.value.split(".");
                                // var yedekveridate = parts[2] + '-' + parts[1] + '-' + parts[0]
                                // duzenlenenveri['Veri'] = yedekveridate
                                duzenlenenveri['Veri'] = element.value
                            }

                            if (duzenlenenveri!={} && duzenlenenveri!='' && duzenlenenveri!='undefined' && duzenlenenveri!=null )
                        {
                           
                            Veriler.push(duzenlenenveri);
                        }

                        } else {}
                       
                        
                    }
                });

                detayobject['Veriler'] = Veriler
                detayobject['ID'] = this.Sablon.ProfilID
                detayobject['SablonID'] = this.Sablon.TemplateID
                duzenlenenkayit.push(detayobject)

                var params = detayobject

                this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataUpdate', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true

                    if (response.body.Status == true) {
                        this.sablondetaygetir(this.Sablon.ProfilID);
                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.detaykont = false
                        this.progress = false

                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.detaykont = false
                        this.progress = false
                    }
                })



                    var i = 0
                    this.Bilet.TanimBilgileri.ProfilID = this.Sablon.ProfilID
                    this.Bilet.TanimBilgileri.SablonID = this.Sablon.TemplateID

                    // this.text1 = this.$t('Your-profile-information-has-been-added')
                    // this.snackbar = true
                } else {
                    this.text1 = this.$t('Please-Select-a-Profile')
                    this.snackbar = true
                }

            } else {
                var detayobject = {};
                var duzenlenenveri = {}
                var duzenlenenkayit = []
                var Veriler = []

                this.sablonobjeler.forEach(element => {
                    if (element.type != 'I' && element.type != 'SI') {
                        var duzenlenenveri = {}
                        var element1 = document.getElementById(element.vmodelname);
                        if (element1 != null && element1.value!=null && element1.value!="") {
                           
                            duzenlenenveri['AlanAdi'] = element.labeller
                            duzenlenenveri['AlanID'] = element1.id
                            if (element.type === 'M') {
                                var yedekveri = element1.value
                                yedekveri = yedekveri.replace("₺", "")
                                yedekveri = yedekveri.replace(",", "")
                                duzenlenenveri['Veri'] = yedekveri
                            } else if (element.type === 'B') {
                                var yedekveri = element1.value
                                yedekveri = yedekveri.replace(",", "")
                                duzenlenenveri['Veri'] = yedekveri
                            } else {
                                duzenlenenveri['Veri'] = element1.value
                            }
                            if (element.type === 'D') {
                               
                                // var parts = element.value.split(".");
                                // var yedekveridate = parts[2] + '-' + parts[1] + '-' + parts[0]
                                // duzenlenenveri['Veri'] = yedekveridate
                                duzenlenenveri['Veri'] = element.value
                            }
                        
                            if (duzenlenenveri!={} && duzenlenenveri!='' && duzenlenenveri!='undefined' && duzenlenenveri!=null )
                        {
                            Veriler.push(duzenlenenveri);
                        }
                        } else {}
                       
                        
                    }
                });

                detayobject['Veriler'] = Veriler
                detayobject['ID'] = null
                detayobject['SablonID'] = this.Sablon.TemplateID
                duzenlenenkayit.push(detayobject)

                var params = detayobject

                this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataAdd', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true

                    if (response.body.Status == true) {
                        this.sablondetaygetir(response.body.SaveID);
                    }

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.detaykont = false
                        this.progress = false

                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                        this.detaykont = false
                        this.progress = false
                    }
                })

            }

        },
        yeniProfilekle() {
            this.profilislemTipi = 'yeni'

            if (this.Sablon.TemplateID != null) {
                var secilenkayit = []
                var yenikayit = []

                this.itemssablon.forEach(element => {
                    if (element.ID == this.Sablon.TemplateID) {
                        secilenkayit = element.DetayList
                    }
                });

                secilenkayit.forEach(element => {
                    var NewObject = {};
                    NewObject['type'] = element.AlanID.substr(0, 1)

                    console.log(element.AlanID.substr(0, 1));

                    NewObject['labeller'] = element.AlanAdi
                    NewObject['vmodelname'] = element.AlanID
                    NewObject['value'] = null
                    yenikayit.push(NewObject)
                });

                this.sablonobjeler = yenikayit
               
            } else {
                this.text1 = this.$t('Select-Template')
                this.snackbar = true
            }
        },
        Getirdeger(e) {
            this.profilislemTipi = 'get'

            //var kayit = {}
            this.itemsprofil.forEach(element => {

                if (e == element.ID)
                    //kayit = element
                    this.secilenprofilkayit = element
            });

            var i = 0
            var secilikayit = []
            var secilikayit1 = []

            Object.keys(this.secilenprofilkayit).forEach(key => {
                var NewObject = {};
                NewObject[Object.keys(this.secilenprofilkayit)[i]] = this.secilenprofilkayit[key]
                if (Object.keys(this.secilenprofilkayit)[i] == 'SablonID') {
                    NewObject['type'] = 'SI'
                } else {
                    NewObject['type'] = Object.keys(this.secilenprofilkayit)[i].substr(0, 1)
                }
                NewObject['vmodelname'] = Object.keys(this.secilenprofilkayit)[i]
                var sira = this.tabloalanisimleri.findIndex(x => x.value === Object.keys(this.secilenprofilkayit)[i]);
                var labeldegeri = this.tabloalanisimleri[sira].text
                NewObject['labeller'] = labeldegeri
                NewObject['value'] = this.secilenprofilkayit[key]
                i = i + 1
                secilikayit.push(NewObject)
            });

            this.sablonobjeler = secilikayit

            this.yedeksablonobjeler = JSON.stringify(secilikayit)
            //   this.yedeksablonobjeler=secilikayit
        },
        hykoddegistir() {
            if (this.faturanovarise != true) {
                this.dialoghydegistir = true;
            } else {
                this.text1 = this.$t('You-cannot-change-the-airline-code-of-the-invoiced-ticket')
                this.snackbar = true
            }
        },
        biletsilsor() {
            if (this.faturanovarise != true) {
                this.kisamesaj = this.$t('Are-you-sure-you-want-to-delete-this-ticket')
                this.dialogkisamesaj = true
                this.btnsilsor = true
            } else {
                this.text1 = this.$t('You-cannot-delete-an-invoiced-ticket')
                this.snackbar = true
            }

        },
        biletyazdir() {

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var params = {
                SirketKodu: credentials.SirketKodu,
                FaturaSeri: this.Bilet.FaturaBilgileri.FaturaSeri,
                FaturaNo: this.Bilet.FaturaBilgileri.FaturaNo,
                FaturaGuid: this.Bilet.FaturaBilgileri.EfaturaBilgileri.Guid
            }

            this.$http.post(auth.API_URL + 'api/Invoice/EInvoiceList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                this.Fatura.FaturaBilgi.FaturaPdfID = response.body[0].FaturaPdfID

                var prm = {
                    id: response.body[0].EfaturaID,
                    guid: response.body[0].GuiID
                };

                this.$refs.reportbrosablon.Print(prm, this.Fatura.FaturaBilgi.FaturaPdfID).then(
                    confirm => {
                        if (confirm.sonuc == true) {

                        } else {
                            this.text1 = confirm.mesaj
                            this.snackbar = true
                        }
                    });

            }, (response) => {
                if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable-EInvoiceList'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-EInvoiceList'
                    this.snackbar = true
                }
            })

        },
        xsltsec(Faturaid) {
            this.dizaynsec.forEach(element => {
                if (element.FaturaId == Faturaid) {
                    this.Fatura.FaturaBilgi.FaturaXSLTID = element.FaturaXsltId
                    this.Fatura.FaturaBilgi.FaturaPdfID = element.FaturaPdfID
                }
            });
        },
        getImgUrl(img) {
            return logoo.logoControl(img);
        },
        iadeduzenle(k) {
            var url = '#/bilet/biletiade/id?' + 'isl=iadeget&hyolukod=' + k.GenelBilgileri.HavaYoluKodu + '&biletno=' + k
                .GenelBilgileri
                .BiletNo + '&formno=' + k.GenelBilgileri.Formno + '&sirano=' + k.GenelBilgileri.Sirano + '&ucustipi=' + this
                .Bilet
                .GenelBilgileri.UcusTipi
            window.open(url, '_self')
        },
        dizayngetir() {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var hattipi = null

            if (this.Bilet.GenelBilgileri.UcusTipi == 'I') {
                hattipi = false
            } else {
                hattipi = true
            }

            var params = {
                SirketKodu: credentials.SirketKodu,
                FaturaTip: this.Fatura.FaturaBilgi.FaturaTip,
                DovizliFatura: this.Fatura.Opsiyonlar.DovizliFatura,
                HatTipi: hattipi,
                TumFiltre: true
            }

            this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.dizaynsec = response.body
            }, (response) => {
                if (response.status === 0) {
                    this.progress = false
                    this.text1 = 'Service Unavailable-InvoiceMainTableList'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-InvoiceMainTableList'
                    this.snackbar = true
                }
            })

        },
        faturadialogac() {

            if (this.Bilet.GenelBilgileri.MusteriKodu.Kod != null && this.Bilet.GenelBilgileri.MusteriKodu.Kod != '') {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var hattipi = null

                if (this.Bilet.GenelBilgileri.UcusTipi == 'I') {
                    hattipi = false
                } else {
                    hattipi = true
                }

                var params = {
                    SirketKodu: credentials.SirketKodu,
                    FaturaTip: 'O',
                    DovizliFatura: false,
                    TumFiltre: true,
                    HatTipi: hattipi
                }

                this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.dizaynsec = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.progress = false
                        this.text1 = 'Service Unavailable-InvoiceMainTableList'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-InvoiceMainTableList'
                        this.snackbar = true
                    }
                })

                //0 ise Earşiv / 1 ise gib seri

                if (this.earsivseridurum == 1) {

                    var params1 = {
                        CompanyCode: credentials.SirketKodu,
                        PassiveControl: true,

                    }

                    this.$http.post(auth.API_URL + 'api/Definitions/GibSerialList', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                       if(response.body.length == 1){
                            this.Fatura.GibSeri = response.body[0].Seri 
                        }
                            this.gibseri = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })
                }

                if (this.earsivseridurum == 0) {

                    var params1 = {
                        CompanyCode: credentials.SirketKodu,
                        PassiveControl: true,
                    }
                    this.$http.post(auth.API_URL + 'api/Definitions/GibSerialEarchiveList', params1, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        if(response.body.length == 1){
                            this.Fatura.GibSeri = response.body[0].Seri 
                        }
                            this.gibseri = response.body
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })
                }

                var faturabilgi = null

                if (this.eFaturaBilgi == 0) {
                    faturabilgi = false
                } else {
                    faturabilgi = true
                }

                var params1 = {
                    SirketKodu: credentials.SirketKodu,
                    EFaturaBilgi: faturabilgi,
                    EArsivBilgi: false,
                    ParamKontrol: true,
                    InternetSatis: this.Bilet.FaturaBilgileri.EfaturaBilgileri.InternetSatis
                }

                this.$http.post(auth.API_URL + 'api/TicketHelpers/GetLastBillNumber', params1, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.Fatura.FaturaSeri = response.body.FaturaSeri
                    this.Fatura.FaturaNo = response.body.FaturaNo

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

                this.faturadialog = true
            } else {
                this.text1 = this.$t('Please-select-your-current-code-before-invoicing.')
                this.snackbar = true
            }

        },
        yeniiadeekle() {
            var url = '#/bilet/biletiade/id?' + 'isl=yeniiade&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
                '&biletno=' + this.Bilet.GenelBilgileri.BiletNo + '&formno=' + this.Bilet.GenelBilgileri.Formno + '&sirano=' +
                this.Bilet.GenelBilgileri.Sirano + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi
            window.open(url, '_self')
        },

        kurgetirfatura(tarih, kod) {
            var params1 = {
                Tarih: tarih,
                DovizKod: kod,
                DovizAdi: null,
                KurTutar: 0
            }

            if (tarih != null && tarih != '') {
          

                this.$http.post(auth.API_URL + 'api/Definitions/GetWebRate', params1, {
                    headers: auth.getAuthCompaniesInfo()
                }).then((response) => {
                     if(response.body == 0.0){
                  this.BiletAyrintiliOdeme.Kur = 1
                    }else{
                    this.BiletAyrintiliOdeme.Kur = response.body
                    }
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Kur Hesapla'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Kur Hesapla'
                        this.snackbar = true
                    }
                })
            }

        },

        sayfakapat() {
            var url1 = '#/bilet/index'
            window.location.href = url1

        },

        voidyap() {
            this.voiddialog = true
        },
        tahsilatekle() {

            //alanları temizleyelim

            this.BiletAyrintiliOdeme.CariKod = null
            this.BiletAyrintiliOdeme.Referans = null
            this.BiletAyrintiliOdeme.Masraf = null
            this.BiletAyrintiliOdeme.EvrakCinsi = null
            this.BiletAyrintiliOdeme.Doviz = null
            this.BiletAyrintiliOdeme.Kur = 0
            this.BiletAyrintiliOdeme.Tarih = getDateNow()
            this.BiletAyrintiliOdeme.Tutar = 0
            this.BiletAyrintiliOdeme.DovizTutar = 0
            this.BiletAyrintiliOdeme.PosKod = null
            this.BiletAyrintiliOdeme.EvrakNo = null
            this.BiletAyrintiliOdeme.KrediKartNo = null
            this.BiletAyrintiliOdeme.Aciklama = null
            this.BiletAyrintiliOdeme.TaksitKod = null
            this.BiletAyrintiliOdeme.TaksitKodLabel = null
            this.BiletAyrintiliOdeme.PuanTutar = 0
            this.BiletAyrintiliOdeme.BankaKod = null
            this.BiletAyrintiliOdeme.KarsiCari = ''

            //ana sayfadan kaydet için alınacak alanlar

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            this.BiletAyrintiliOdeme.CariKod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
            this.BiletAyrintiliOdeme.SirketKodu = credentials.SirketKodu
            this.BiletAyrintiliOdeme.BiletNo = this.Bilet.GenelBilgileri.BiletNo
            this.BiletAyrintiliOdeme.FormNo = this.Bilet.GenelBilgileri.Formno
            this.BiletAyrintiliOdeme.Referans = this.Bilet.GenelBilgileri.Referans.Kod
            this.BiletAyrintiliOdeme.Masraf = this.Bilet.GenelBilgileri.Masraf.Code
            this.BiletAyrintiliOdeme.Faturano = this.Bilet.FaturaBilgileri.FaturaNo
            this.BiletAyrintiliOdeme.FaturaTarih = this.Bilet.FaturaBilgileri.FaturaTarih
            this.BiletAyrintiliOdeme.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri

            this.$refs.tahsilatdialog1.open("tahsilat", this.tahsilatBakiye).then(sonuc => {
                if (sonuc == true) {
                    //kayıt başarılı ise listeyi güncelleyelim
                    var tahsilatparams = {
                        SirketKodu: credentials.SirketKodu,
                        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                        FormNo: this.Bilet.GenelBilgileri.Formno,
                        BA: 1,
                        CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
                    }
                    this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {
                        this.tahsilatitems = response.body
                        this.tahsilatbakiyeHesapla()
                    }, (response) => {
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        }
                    })
                }
            });

        },
        servissec(v) {

            var params = {
                ServisKodBilgi: v,
                HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                KurTarih: this.Bilet.TarihBilgileri.SatisTarihi,
                TutarBilgi: {
                    ServisTutar: this.Bilet.TutarBilgileri.ServisTutar.ServisTutar,
                    BiletTutar: this.Bilet.TutarBilgileri.Tutar.Tutar,
                    VergiTutar: this.Bilet.TutarBilgileri.PtaTutar.PtaTutar + this.Bilet.TutarBilgileri.AlanVergiTutar
                        .AlanVergitutar +
                        this.Bilet.TutarBilgileri.YFFTutar.YFFTutar // mco + alan + ceza + yff
                }
            }

            this.$http.post(auth.API_URL + 'api/Helpers/GetServiceCodePrice', params, {
                headers: auth.getAuthCompaniesInfo()
            }).then((response) => {
                if (v.DovizKod!='')
                {
                    this.kurgetirservis2(this.Bilet.TarihBilgileri.SatisTarihi,v.DovizKod,response.body.IskontoTutar,response.body.ServisTutar)
                }
                else
                {
                    this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar = response.body.IskontoTutar 
                    this.Bilet.TutarBilgileri.ServisTutar.ServisTutar = response.body.ServisTutar 
                }
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-GetServiceCodePrice'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable-GetServiceCodePrice'
                    this.snackbar = true
                }
            })
            this.Bilet.TanimBilgileri.ServisKod = v.Kod
            this.servisdialog = false

        },
        GibSeriKontrol(val){
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            if(credentials.EFatura == '1'){ // efaturacı ise kontrol ediliyor. 
                if(val != null && val != ''){
                    return true
                }else{
                    return false
                }
            }else{
                return true
            }
        },
        getDateNow: getDateNow,
        tahsilatkaydet: tahsilatkaydet,
        taksitgetir: taksitgetir,
        taksitgetirservis: taksitgetirservis,
        taksitgetirtahsilat: taksitgetirtahsilat,
        biletislemsorgula: biletislemsorgula,
        biletkaydet: biletkaydet,
        servisgetir: servisgetir,
        voidislem: voidislem,
        voidiptal: voidiptal,
        tarihformatla: tarihformatla,
        tahsilatgetir: tahsilatgetir,
        tahsilatsil: tahsilatsil,
        tahsilatguncelle: tahsilatguncelle,
        iadeiptal: iadeiptal,
        faturakaydet: faturakaydet,
        coklubiletkayit: coklubiletkayit,
        serviscodeControl: serviscodeControl,
        tutarTopla: tutarTopla,
        tutarToplaSatisDoviz: tutarToplaSatisDoviz,
        tutarToplaAlisDoviz: tutarToplaAlisDoviz,
        biletsil: biletsil,
        havayoluKoddegistir,
        sablondetaygetir
    },
    computed:{
            dizayntipi(){
                return [{
                    text: this.$t('Default'),
                    value: 'O'
                },
                {
                    text: this.$t('Special'),
                    value: 'O'
                },
            ]
            },
            dizaynxslt(){
            return [{
                text: 'tek değer',
                value: '0'
            }, 
            ]
            },
            crskodu(){
            return [{
                text: 'Manuel',
                value: 'Manuel'
            }, {
                text: '1 - Amadeus ' + this.$t('International-Line'),
                value: 'AmadeusDisHat'
            }, {
                text: '2 - TK ' + this.$t('Domestic-Line'),
                value: 'TkIcHat'
            }, {
                text: '3 - Atlas',
                value: 'Atlas'
            }, {
                text: '4 - Pegasus',
                value: 'Pegasus'
            }, {
                text: '5 - Onur',
                value: 'Onur'
            }, {
                text: '6 - SunExpress',
                value: 'SunExpress'
            }, {
                text: '7 - Galileo ' + this.$t('Domestic-Line'),
                value: 'GalileoIcHat'
            }, {
                text: '8 - Galileo ' + this.$t('International-Line'),
                value: 'GalileoDisHat'
            }, {
                text: '9 - WorldSpan',
                value: 'Worldspan'
            }, {
                text: '10 - BoraJet',
                value: 'BoraJet'
            }, {
                text: '11 - IATI',
                value: 'IATI'
            }, {
                text: '12 - Sabre',
                value: 'Sabre'
            }, {
                text: '13 - Bilet Bank',
                value: 'BiletBank'
            }, {
                text: '14 - Kolay Bilet',
                value: 'KolayBilet'
            },
             {
                text: '15 - Air Arabia',
                value: 'AirArabia'
            },
             {
                text: '16 - Corendon',
                value: 'Corendon'
            },
             {
                text: '17 - Puzzle',
                value: 'Puzzle'
            },
            {
                text: '18 - AmadeusAPI',
                value: 'AmadeusAPI'
            },
            {
                text: '19 - THYAPI',
                value: 'AmadeusAPI'
            },
            {
                text: '20 - PegasusAPI',
                value: 'PegasusAPI'
            },
            {
                text: '21 - SunExpressAPI',
                value: 'SunExpressAPI'
            },
            {
                text: '22 - AtlasGlobalAPI',
                value: 'AtlasGlobalAPI'
            },
            {
                text: '23 - OnurAirAPI',
                value: 'OnurAirAPI'
            },
            {
                text: '24 - GalileoAPI',
                value: 'GalileoAPI'
            },
            {
                text: '25 - SabreAPI',
                value: 'SabreAPI'
            },
            {
                text:'26 - Amadeus Ic Hat',
                value:'AmadeusIcHat'
            },
            {
                text:'27 - Turkmenistan Airline',
                value:'TurkmenistanAirline'
            },
            {
                text:'28 - BookingAgora',
                value:'BookingAgora'
            },
            {
                text:'33 - BiziTravel',
                value:'BiziTravel'
            },
            {
                text:'98 - AerTicket',
                value:'AerTicket'
            },
            {
                text:'99 - ArkmanAktarim',
                value:'ArkmanAktarim'
            },
            {
                text:'97 - OtelFirsati',
                value:'OtelFirsati'
            },
            {
                text:'29 - Germania',
                value:'Germania'
            },
            {
                text:'30 - VadeFarki',
                value:'VadeFarki'
            },
            {
                text:'31 - SMS',
                value:'SMS'
            },
            {
                text:'32 - Bilgilendirme',
                value:'Bilgilendirme'
            },
            {
                text:'34 - Airays',
                value:'Airays'
            },
            {
                text:'35 - NDC',
                value:'NDC'
            },
            {
                text:'36 - Travelfusion',
                value:'Travelfusion'
            },
            {
                text:'37 - Greencode',
                value:'Greencode'
            },
           
            {
                text:'40 - AJET',
                value:'AJet'
            },
            {
                text:'41 - FlyKhy',
                value:'FlyKhy'
            },
            {
                text:'42 - BiletAll',
                value:'BiletAll'
            },
            ]
            },
            odemesekli1(){
                return [{
                    text: this.$t('Credit-Debit-Card'),
                    value: '0'
                },
                {
                    text: 'EFT-' + this.$t('Transfer-v3'),
                    value: '1'
                },
                {
                    text: this.$t('Cash-on-delivery'),
                    value: '2'
                },
                {
                    text: this.$t('Payment-Intermediary'),
                    value: '3'
                },
                {
                    text: this.$t('Other'),
                    value: '4'
                }
            ]
            },
            komisyontip(){
                return [{
                text: this.$t('K-Commission'),
                value: 'K'
            }, {
                text: this.$t('P-No-commission'),
                value: 'N'
            }]
            },
            satissekliitem(){
                return [{
                text: 'K-' + this.$t('With-Credit'),
                value: 'K'
            }, {
                text: 'P-' + this.$t('Cash'),
                value: 'P'
            }, {
                text: this.$t('R-Card'),
                value: 'R'
            }, {
                text: this.$t('C-Card'),
                value: 'C'
            }, {
               
                text: this.$t('F-KrediKartlı'),
                value: 'F'
            }]
            },
            fiyatturu(){
                return [{
                    text: 'AD-' + this.$t('Adult'),
                    value: 'AD'
                },
                {
                    text: 'CHD-' + this.$t('Child'),
                    value: 'CHD'
                },
                {
                    text: 'INF-' + this.$t('Baby'),
                    value: 'INF'
                },
                {
                    text: 'TUS-Diplomatik',
                    value: 'TUS'
                },
                {
                    text: 'EX',
                    value: 'EX'
                },
                {
                    text: 'STD-' + this.$t('Student'),
                    value: 'STD'
                },
                {
                    text: 'SRC-' + this.$t('Elderly'),
                    value: 'SRC'
                },
                {
                    text: 'MIL-' + this.$t('Soldier'),
                    value: 'MIL'
                },
                {
                    text: 'YTH-' + this.$t('Young'),
                    value: 'YTH'
                }
            ]
            },
            biletyon(){
                return [{
                    text: 'T-' + this.$t('One-way'),
                    value: 'T'
                },
                {
                    text: 'C-' + this.$t('round-trip'),
                    value: 'C'
                },
                {
                    text: 'R-Rissue',
                    value: 'R'
                }
            ]
            },
            classtip(){
                return [{
                    text: 'B-Business',
                    value: 'B'
                },
                {
                    text: 'C-Premium Economy',
                    value: 'C'
                },
                {
                    text: 'E-Economy',
                    value: 'E'
                },
                {
                    text: this.$t('First-Class'),
                    value: 'F'
                },
                {
                    text: this.$t('Promotion'),
                    value: 'P'
                },
                {
                    text: 'X-Infant',
                    value: 'X'
                }
            ]
            },
       musteritipi(){
        return [{
               text: this.$t('Individual'),
               value: 'B'
           },
           {
               text: this.$t('Corporate'),
               value: 'K'
           }
       ]
       },
            efaturatipi(){
                return [{
                    text: this.$t('Commercial'),
                    value: '0'
                },
                {
                    text: this.$t('Basic'),
                    value: '1'
                },
                {
                    text:  this.$t('Export'),
                    value: '2'
                }
            ]
            },
            islembilgileri(){
                return [{
                    text: this.$t('Hard-Copy-Invoice'),
                    value: 'false'
                },
                {
                    text: this.$t('Electronic-Invoice'),
                    value: 'true'
                }
            ]
            },

            evethayir(){
                return[{
                    text: this.$t('Yes'),
                    value: 'E'
                },
                {
                    text: this.$t('No-v2'),
                    value: 'H'
                },
            ]
            },
            ucustipi(){
            return [{
                    text: this.$t('Domestic-Line'),
                    value: 'I'
                },
                {
                    text: this.$t('International-Line'),
                    value: 'D'
                },
                {
                    text: 'BSP',
                    value: 'B'
                }
            ]
            },
            faturatipi(){
            return [{
                    text: this.$t('Sales-Invoice'),
                    value: 0
                },
                {
                    text: this.$t('Return-Invoice'),
                    value: 1
                }
            ]
            },
            gonderimsekli(){
                return[{
                    text: this.$t('Paper'),
                    value: 0
                },
                {
                    text: this.$t('Electronic'),
                    value: 1
                }
            ]
            },
            odemesekli: function(){
            return [{
                    text: this.$t('Normal-Sales'),
                    value: 0
                },
                {
                    text: this.$t('Internet-Sales'),
                    value: 1
                }
            ]
            },
             headers(){
             return [{
                    text: this.$t('Payment-Date'),
                    value: 'Tarih'
                },
                {
                    text: this.$t('Document-Type'),
                    value: 'Evrak.Evrakkod',

                },
                {
                    text: this.$t('Document-No'),
                    value: 'Evrakno'
                },
                {
                    text: this.$t('Description'),
                    value: 'Aciklama',
                },
                {
                    text:  this.$t('Amount'),
                    value: 'Tutar',
                    align: 'right'
                },
                {
                    text: this.$t('Currency-Type'),
                    value: 'DovizCinsi',
                    align: 'center'
                },
                {
                    text: this.$t('Currency-Amount'),
                    value: 'DovizTutar',
                    align: 'right'

                },
                {
                    text: this.$t('Pos-Code'),
                    value: 'PosKod',
                    align: 'center'
                },
                {
                    text: '',
                    value: '',
                    align: ''
                }

            ]
            },

            headersservis(){
                return [{
                    text: this.$t('Code'),
                    value: 'Kod'
                },
                {
                    text: this.$t('Description'),
                    value: 'Aciklama',

                },
                {
                    text: this.$t('Amount'),
                    value: 'Tutar'
                },
                {
                    text: this.$t('Currency'),
                    value: 'DovizKod',
                }
            ]
            },
            headeriade(){
            // eslint-disable-next-line no-sparse-arrays
            return [{
                    text: this.$t('Refund-Date'),
                    value: 'TarihBilgileri.IadeTarihi'
                },
                {
                    text: this.$t('Ticket-No'),
                    value: 'GenelBilgileri.BiletNo'
                },
                {
                    text: this.$t('Airline-Code'),
                    value: 'GenelBilgileri.HavaYoluKodu'

                },
                {
                    text: this.$t('Net-Amount'),
                    value: 'TutarBilgileri.NetTutar.NetTutar'
                },

                {
                    text: this.$t('Form-No'),
                    value: 'GenelBilgileri.Formno'
                }, ,
                {
                    text: this.$t('Item-No'),
                    value: 'GenelBilgileri.Sirano'
                },
            ]
            },  
    },
    beforeMount: beforeMount,

    components: {
        'parainput': parainput,
        'dovizinput': dovizinput,
        'yuzdeinput': yuzdeinput,
        'ucusdetay': ucusdetay,
        'notlar': notlar,
        'ozelbilgiler': ozelbilgiler,
        'tutarbilgileri': tutarbilgileri,
        'fatura': fatura,
        'tahsilatdialog1': tahsilatdialog1,
        'yenibiletno': yenibiletno,
        'masrafmerkezicomp': masrafmerkezicomp,
        'referansmerkezicomp': referansmerkezicomp,
        'bolumcomp': bolumcomp,
        doviztutarcomp,
        reportbrosablon,
        tarihim,
        parkurcomp,
        kredikartcomp,
        analizcomp,
        analizcompyeni,
        analizcompyeni1,
        musteribilgipart,
        kesenkisi,
        hykoddegistircomp,
        moneyinput,
        duzyaziinput,
        sayiinput,
        tarihinput,
        caricomp,
        yetkidialog,
        onaydialog,
        loadingcomp,
        tevkifat,
        snackbarcomp
    },
    watch: {
    'Bilet.GenelBilgileri.Masraf.Code':function(val)
    {
        this.getcostcentertitle();
        
    },
        'Bilet.GenelBilgileri.OpenBilet': function (val) {
            if (val == true) {
                if (this.Bilet.TarihBilgileri.OpenTarihi == '0001-01-01T00:00:00' || this.Bilet.TarihBilgileri.OpenTarihi ==
                    null || this.Bilet.TarihBilgileri.OpenTarihi == '')
                    this.Bilet.TarihBilgileri.OpenTarihi = helpers.adddays(365);
            }
        },
        bankapositems: function (val) {
            if (val.length > 0) {
                this.taksitgetir();
                this.taksitgetirservis();
            }
        },
        faturalansinmi: function (val) {
            if (val == true) {
                this.faturalansinmilabel = this.$t('ticket-can-invoiced')
            } else {
                this.faturalansinmilabel = "Bu bilet faturalanmayacak"

            }
        },
        active(val1) {
            //tablar aktif olunca değerleri çekelim

            if (val1 == 0) {
                this.tabviewozel = false;
                this.tabviewgenel = true;
                this.tabviewiade = false;
                this.tabviewucusdetay = false;
                this.tabviewtutardetay = false;
                this.tabviewtahsilat = false;
                this.tabviewodeme = false;
                this.tabviewnotlar = false;
            } else if (val1 == 1) {
                this.tabviewozel = false;
                this.tabviewiade = false;
                this.tabviewucusdetay = true;
                this.tabviewtutardetay = false;
                this.tabviewtahsilat = false;
                this.tabviewodeme = false;
                this.tabviewnotlar = false;
            } else if (val1 == 2) {
                this.tabviewozel = false;
                this.tabviewiade = false;
                this.tabviewucusdetay = false;
                this.tabviewtutardetay = true;
                this.tabviewtahsilat = false;
                this.tabviewodeme = false;
                this.tabviewnotlar = false;
            } else if (val1 == 3) {
                this.tabviewozel = false;
                this.tabviewiade = false;
                this.tabviewucusdetay = false;
                this.tabviewtutardetay = false;
                this.tabviewtahsilat = true;
                this.tabviewodeme = false;
                this.tabviewnotlar = false;
            } else if (val1 == 4) {
                this.tabviewozel = false;
                this.tabviewiade = false;
                this.tabviewucusdetay = false;
                this.tabviewtutardetay = false;
                this.tabviewtahsilat = false;
                this.tabviewodeme = true;
                this.tabviewnotlar = false;
            } else if (val1 == 5) {
                this.tabviewozel = false;
                this.tabviewiade = false;
                this.tabviewucusdetay = false;
                this.tabviewtutardetay = false;
                this.tabviewtahsilat = false;
                this.tabviewodeme = false;
                this.tabviewnotlar = true;
            } else if (val1 == 6) {
                this.tabviewozel = true;
                this.tabviewiade = false;
                this.tabviewucusdetay = false;
                this.tabviewtutardetay = false;
                this.tabviewtahsilat = false;
                this.tabviewodeme = false;
                this.tabviewnotlar = false;
            } else if (val1 == 7) {
                this.tabviewozel = false;
                this.tabviewiade = true;
                this.tabviewucusdetay = true;
                this.tabviewtutardetay = false;
                this.tabviewtahsilat = false;
                this.tabviewodeme = false;
                this.tabviewnotlar = false;

            }

            if (val1 == 3 && this.tabcontroltahsilat != 1) {
                this.tabcontroltahsilat = 1
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var tahsilatparams = {
                    SirketKodu: credentials.SirketKodu,
                    BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                    FormNo: this.Bilet.GenelBilgileri.Formno,
                    BA: 1,
                    CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
                }

                this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.tahsilatitems = response.body
                    this.tahsilatbakiyeHesapla();
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

                ///burdayımmmmmmmmmmmmmm

            }
            if (val1 == 4 && this.tabcontrolodeme != 1) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.tabcontrolodeme = 1

                var odemeparams = {
                    SirketKodu: credentials.SirketKodu,
                    BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                    FormNo: this.Bilet.GenelBilgileri.Formno,
                    BA: 0,
                    CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
                }

                this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', odemeparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.odemeitems = response.body
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

            }

            if (val1 == 7 && this.tabcontroliade != 1) {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                this.tabcontroliade = 1
                var iadeparams = {

                    SirketKodu: credentials.SirketKodu,
                    HavaYoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                    FormNo: this.Bilet.GenelBilgileri.Formno,
                    BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                    Sirano: 0,
                    BaslangicTarihi: null,
                    BitisTarihi: null
                }

                this.$http.post(auth.API_URL + 'api/Ticket/RefundList', iadeparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.iadeitems = response.body

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Bilet İade List'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Bilet İade List'
                        this.snackbar = true
                    }
                })

            }

            if (val1 == 2 && this.tabcontroltutar != 1) {
                this.tabcontroltutar = 1
            }

            if (val1 == 8 && this.tabcontrolsablon != 1) {

                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                var params = {
                    SirketKodu: credentials.SirketKodu
                }
                this.progress = true
                this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateList', params, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {

                    this.itemssablon = response.body

                    this.progress = false
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })

                this.tabcontrolsablon = 1

            }

        },
        // loadingdialog(val) {
        //     alert("loading dialog " + val)
        //     if (!val) return
        //     setTimeout(() => (this.loadingdialog = val), )
        // },
        'Fatura.FaturaSeri': function (valueseri) {
            this.Fatura.FaturaSeri = valueseri.toUpperCase()
        },
        'Bilet.GenelBilgileri.MusteriKodu.Kod': function (valuecari) {
            if (this.Bilet.TutarBilgileri.ServisTutar.ServisTutar == 0) {

                if(this.$route.query.isl == 'get' && this.getControl == 0){
                    this.getControl = 1;
                }else{
                    this.cariservisgetir();
                }
                
            }
        },
        'Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu': function (val) {
            if (val == undefined | val == null) {
                this.taksitsayi = []
                this.postaksitsayi.id = null
                this.postaksitsayi.label = null
            }

        },

        'Bilet.TutarBilgileri.Tutar.Tutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.Tutar.TutarSatisDoviz = this.Bilet.TutarBilgileri.Tutar.Tutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'miniTutar.Pesin': function (value) {

            this.miniTutar.PesinDoviz = value / this.Bilet.TutarBilgileri.Kur
        },
        'miniTutar.KrediKartli': function (value) {
            this.miniTutar.KrediKartliDoviz = value / this.Bilet.TutarBilgileri.Kur
        },
        'miniTutar.Kredili': function (value) {
            this.miniTutar.KrediliDoviz = value / this.Bilet.TutarBilgileri.Kur
        },

        'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz= this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.TaxTutar.TaxTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.TaxTutar.TaxDoviz= this.Bilet.TutarBilgileri.TaxTutar.TaxTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.YFFTutar.YFFTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.YFFTutar.YFFDoviz= this.Bilet.TutarBilgileri.YFFTutar.YFFTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.DigerServisTutar.DigerServisTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisDoviz= this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.PtaTutar.PtaTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.PtaTutar.PtaSatisDoviz= this.Bilet.TutarBilgileri.PtaTutar.PtaTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.CezaTutar.CezaTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.CezaTutar.CezaSatisTutar= this.Bilet.TutarBilgileri.CezaTutar.CezaTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.ServisTutar.ServisTutar': function (value1) {
        
            this.tutarTopla();
            this.Bilet.TutarBilgileri.ServisTutar.ServisDoviz= this.Bilet.TutarBilgileri.ServisTutar.ServisTutar / this.Bilet.TutarBilgileri.Kur;
            this.tutarToplaSatisDoviz();
            
        },

        'Bilet.TutarBilgileri.ReserveTutar.ReserveTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.ReserveTutar.ReserveDoviz= this.Bilet.TutarBilgileri.ReserveTutar.ReserveTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.IskontoTutar.IskontoTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.IskontoTutar.IskontoDoviz= this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.CharterTutar.CharterTutar': function (value1) {
            this.tutarTopla();
            this.Bilet.TutarBilgileri.CharterTutar.CharterTutar= this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar / this.Bilet.TutarBilgileri.Kur
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.KaTutar.KaTutar': function (value1) {
            this.tutarTopla();
        },

        'Bilet.TutarBilgileri.Tutar.TutarSatisDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.PtaTutar.PtaSatisDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.TaxTutar.TaxSatisDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.YFFTutar.YFFDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.DigerServisTutar.DigerServisDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.CezaTutar.CezaSatisTutar': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.ServisTutar.ServisDoviz': function (value1) {
          
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.ReserveTutar.ReserveDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.CharterTutar.CharterSatisDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.KaTutar.KaDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },
        'Bilet.TutarBilgileri.IskontoTutar.IskontoDoviz': function (value1) {
            this.tutarToplaSatisDoviz();
        },

        'Bilet.TutarBilgileri.Tutar.TutarAlisDoviz': function (value1) {
            this.tutarToplaAlisDoviz();
        },
        'Bilet.TutarBilgileri.PtaTutar.PtaAlisDoviz': function (value1) {
            this.tutarToplaAlisDoviz();
        },
        'Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz': function (value1) {
            this.tutarToplaAlisDoviz();
        },
        'Bilet.TutarBilgileri.CezaTutar.CezaAlisTutar': function (value1) {
            this.tutarToplaAlisDoviz();
        },
        'Bilet.TutarBilgileri.CharterTutar.CharterAlisDoviz': function (value1) {
            this.tutarToplaAlisDoviz();
        },

        'Bilet.TarihBilgileri.SatisTarihi': function (value1) {

            // if (this.Bilet.OdemeBilgileri.SatisSekli == 'C' && this.Bilet.TarihBilgileri.OdemeTarihi != null && this.Bilet
            //   .TarihBilgileri.OdemeTarihi != '') {
            //   this.Bilet.TarihBilgileri.OdemeTarihi = this.Bilet.TarihBilgileri.SatisTarihi
            // }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'K' || this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
                var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '' && this
                    .Bilet
                    .GenelBilgileri.MusteriKodu.Kod != '' && this.Bilet.GenelBilgileri.MusteriKodu.Kod != null) {

                    var paramsgetexpritydate = {
                        SatisTarihi: value1,
                        UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
                        CariKodu: this.Bilet.GenelBilgileri.MusteriKodu.Kod,
                        SirketKodu: credentials.SirketKodu,
                    }
                }
            }
        },
        'Bilet.GenelBilgileri.UcusTipi': function (value2) {
            if (value2 == 'I') {
                this.ichatmi = true
                this.dishatmi = false
            } else if (value2 == 'D' || value2 == 'B') {
                this.dishatmi = true
                this.ichatmi = false
            }
        },
        'Bilet.OdemeBilgileri.SatisSekli': function (value3) {

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {

                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }
                this.miniTutar.Kredili = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur
                this.miniTutar.Pesin = 0
                this.miniTutar.PesinDoviz = 0
                this.miniTutar.KrediKartli = 0
                this.miniTutar.KrediKartliDoviz = 0
                this.bankaposshow = false
                this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
                this.taksitsayi = []
                this.servisposshow = false
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
                this.taksitsayiservis = []
                this.kredikartishow = false
                this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null
                this.slipnoshow = false
                this.Bilet.OdemeBilgileri.Slipkod = null
                this.makbuznoshow = false
                this.Bilet.OdemeBilgileri.MakbuzNo = null
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }
                this.miniTutar.Pesin = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.PesinDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri.Kur
                this.miniTutar.Kredili = 0
                this.miniTutar.KrediliDoviz = 0
                this.miniTutar.KrediKartli = 0
                this.miniTutar.KrediKartliDoviz = 0
                this.servisposshow = false
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
                this.taksitsayiservis = []
                this.bankaposshow = false
                this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
                this.taksitsayi = []
                this.kredikartishow = false
                this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartNo = null
                this.slipnoshow = false
                this.Bilet.OdemeBilgileri.Slipkod = null
                this.makbuznoshow = true
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }

                this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
                    .Kur
                this.miniTutar.Kredili = 0
                this.miniTutar.KrediliDoviz = 0
                this.miniTutar.Pesin = 0
                this.miniTutar.PesinDoviz = 0
                this.servisposshow = false
                this.Bilet.OdemeBilgileri.MakbuzNo = this.Bilet.GenelBilgileri.BiletNo
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosTutar = 0
                this.taksitsayiservis = []
                this.bankaposshow = true
                this.kredikartishow = true
                this.slipnoshow = true
                this.makbuznoshow = true
                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }
                this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
                    .Kur
                this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
                    .Kur
                this.miniTutar.Kredili = 0
                this.miniTutar.KrediliDoviz = 0
                this.miniTutar.Pesin = 0
                this.miniTutar.PesinDoviz = 0
                this.bankaposshow = false
                this.Bilet.OdemeBilgileri.MakbuzNo = this.Bilet.GenelBilgileri.BiletNo
                this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                this.Bilet.OdemeBilgileri.BankaBilgileri.PuanTutar = 0
                this.servisposshow = true
                this.kredikartishow = true
                this.slipnoshow = true
                this.makbuznoshow = true
            }

            if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
                if (this.Bilet.TutarBilgileri.Kur == 0 || this.Bilet.TutarBilgileri.Kur == null || this.Bilet.TutarBilgileri
                    .Kur == '') {
                    this.Bilet.TutarBilgileri.Kur = 1
                }
                this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
                    .Kur
                this.miniTutar.KrediKartli = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                this.miniTutar.KrediKartliDoviz = this.Bilet.TutarBilgileri.NetTutar.NetTutar / this.Bilet.TutarBilgileri
                    .Kur
                this.miniTutar.Kredili = 0
                this.miniTutar.KrediliDoviz = 0
                this.miniTutar.Pesin = 0
                this.miniTutar.PesinDoviz = 0

                this.servisposshow = true
                this.bankaposshow = true
                this.kredikartishow = true
                this.slipnoshow = true
                this.makbuznoshow = true
            }
        },
    }
}

function tutarTopla() {
    this.Bilet.TutarBilgileri.NetTutar.NetTutar =
        (this.Bilet.TutarBilgileri.Tutar.Tutar +
            this.Bilet.TutarBilgileri.PtaTutar.PtaTutar +
            this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar +
            this.Bilet.TutarBilgileri.TaxTutar.TaxTutar +
            this.Bilet.TutarBilgileri.YFFTutar.YFFTutar +
            this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisTutar +
            this.Bilet.TutarBilgileri.CezaTutar.CezaTutar +
            this.Bilet.TutarBilgileri.ServisTutar.ServisTutar +
            this.Bilet.TutarBilgileri.ReserveTutar.ReserveTutar +
            this.Bilet.TutarBilgileri.CharterTutar.CharterTutar +
            this.Bilet.TutarBilgileri.KaTutar.KaTutar) -
        this.Bilet.TutarBilgileri.IskontoTutar.IskontoTutar - this.Bilet.TutarBilgileri.TevkifatTutar.TevkifatTutar
    this.Bilet.TutarBilgileri.NetTutar.NetTutar = Math.round(this.Bilet.TutarBilgileri.NetTutar.NetTutar * 100) / 100
    this.tahsilatdagitduzenle()
}

function tutarToplaSatisDoviz() {
console.log( this.Bilet.TutarBilgileri.ServisTutar.ServisDoviz)

    this.Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz =
        (this.Bilet.TutarBilgileri.Tutar.TutarSatisDoviz +
            this.Bilet.TutarBilgileri.PtaTutar.PtaSatisDoviz +
            this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiSatisDoviz +
            this.Bilet.TutarBilgileri.TaxTutar.TaxSatisDoviz +
            this.Bilet.TutarBilgileri.YFFTutar.YFFDoviz +
            this.Bilet.TutarBilgileri.DigerServisTutar.DigerServisDoviz +
            this.Bilet.TutarBilgileri.CezaTutar.CezaSatisTutar +
            this.Bilet.TutarBilgileri.ServisTutar.ServisDoviz +
            this.Bilet.TutarBilgileri.ReserveTutar.ReserveDoviz +
            this.Bilet.TutarBilgileri.CharterTutar.CharterSatisDoviz +
            this.Bilet.TutarBilgileri.KaTutar.KaDoviz) -
        this.Bilet.TutarBilgileri.IskontoTutar.IskontoDoviz

         if (this.Bilet.TutarBilgileri.Kur==1)
         {
            this.Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz -=this.Bilet.TutarBilgileri.TevkifatTutar.TevkifatTutar;
         }
         this.Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz = Math.round(this.Bilet.TutarBilgileri.NetTutar.NetTutarSatisDoviz * 100) / 100

}

function tutarToplaAlisDoviz() {
    
    this.Bilet.TutarBilgileri.NetTutar.NetTutarAlisDoviz =
        this.Bilet.TutarBilgileri.Tutar.TutarAlisDoviz +
        this.Bilet.TutarBilgileri.PtaTutar.PtaAlisDoviz +
        this.Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiAlisDoviz +
        this.Bilet.TutarBilgileri.CezaTutar.CezaAlisTutar +
        this.Bilet.TutarBilgileri.CharterTutar.CharterAlisDoviz
}

function iadeiptal(m) {

    this.$refs.onaydialog.open(this.$t('Are-you-sure-you-want-to-delete-this-record'), 1).then(sonuc => {

        if (sonuc == true) {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var paramsiade = {
                SirketKodu: credentials.SirketKodu,
                BiletNo: m.GenelBilgileri.BiletNo,
                FormNo: m.GenelBilgileri.Formno,
                SiraNo: m.GenelBilgileri.Sirano,
                IadeTarihi: m.TarihBilgileri.IadeTarihi,
            }

            this.$http.post(auth.API_URL + 'api/Ticket/RefundDelete', paramsiade, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true

                var iadeparams = {

                    SirketKodu: credentials.SirketKodu,
                    HavaYoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                    FormNo: this.Bilet.GenelBilgileri.Formno,
                    BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                    Sirano: 0,
                    BaslangicTarihi: null,
                    BitisTarihi: null
                }

                this.$http.post(auth.API_URL + 'api/Ticket/RefundList', iadeparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.iadeitems = response.body

                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable-Bilet İade List'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable-Bilet İade List'
                        this.snackbar = true
                    }
                })

            }, (response) => {
                 this.text1 = this.$t(response.body.ResponseMessage)
                this.snackbar = true
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                     this.text1 = this.$t(response.body.ResponseMessage)
                    this.snackbar = true
                }
            })
        }
    });

}

function coklubiletkayit() {
    this.toplubilet = [];
    var controlaa = 1;
    this.objeler.forEach(element => {
        var yeniveri = {}
        var element1 = document.getElementById(element.vmodelname);
        if (element1 != null) {
            yeniveri['BiletNo'] = element.BiletNo
            yeniveri['YolcuAdi'] = element1.value
            this.toplubilet.push(yeniveri)
        }
    });

    this.toplubilet.forEach(element2 => {

        if (element2.YolcuAdi == null || element2.YolcuAdi == '') {
            controlaa = controlaa * 0;
        } else {
            controlaa = controlaa * 1;
        }
    });

    if (controlaa == 1) {
        this.cokluyolcudialog = false;
        this.yenidialog = false;
        this.biletnodisabled = true
        this.Bilet.GenelBilgileri.ArkmanUsers = null;
        this.Bilet.GenelBilgileri.Baglantili == false;
        this.yolcudisabled = true;

        this.bekletme = true;

    } else {
        this.text1 = this.$t('Please-fill-all-the-blanks.');
        this.snackbar = true;
        this.yolcudisabled = false;
    }
}

function tahsilatkaydet() {
    
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.BiletAyrintiliOdeme.CariKod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
    this.BiletAyrintiliOdeme.SirketKodu = credentials.SirketKodu
    this.BiletAyrintiliOdeme.BiletNo = this.Bilet.GenelBilgileri.BiletNo
    this.BiletAyrintiliOdeme.FormNo = this.Bilet.GenelBilgileri.Formno
    this.BiletAyrintiliOdeme.Referans = this.Bilet.GenelBilgileri.Referans.Kod
    this.BiletAyrintiliOdeme.Masraf = this.Bilet.GenelBilgileri.Masraf.Code
    this.BiletAyrintiliOdeme.Faturano = this.Bilet.FaturaBilgileri.FaturaNo
    this.BiletAyrintiliOdeme.FaturaTarih = this.Bilet.FaturaBilgileri.FaturaTarih
    this.BiletAyrintiliOdeme.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri

    var paramstahsilat = this.BiletAyrintiliOdeme
    this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentAdd', paramstahsilat, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true
        this.tahsilatdialog = false

        var tahsilatparams = {

            SirketKodu: credentials.SirketKodu,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            FormNo: this.Bilet.GenelBilgileri.Formno,
            BA: 1,
            CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
        }

        this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            this.tahsilatitems = response.body
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            }
        })

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = response.body.StatusText
            this.snackbar = true
        }
    })
}

function faturakaydet() {

    if (this.Fatura.FaturaTarih != null && this.Fatura.FaturaTarih != '') {

        if (this.Fatura.FaturaSeri != null && this.Fatura.FaturaSeri != '') {

            if (this.Fatura.FaturaNo != null && this.Fatura.FaturaNo != '') {

                if (this.Fatura.FaturaBilgi.FaturaID != null && this.Fatura.FaturaBilgi.FaturaID != '' && this.Fatura
                    .FaturaBilgi.FaturaID != 0) {

                    var controlValue = this.GibSeriKontrol(this.Fatura.GibSeri);
                    if (controlValue) {

                        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                        this.Fatura.SirketKodu = credentials.SirketKodu
                        this.Fatura.BiletBilgi.BiletNo = this.Bilet.GenelBilgileri.BiletNo
                        this.Fatura.BiletBilgi.FormNo = this.Bilet.GenelBilgileri.Formno
                        this.Fatura.BiletBilgi.UcusTip = this.Bilet.GenelBilgileri.UcusTipi
                        this.Fatura.BiletBilgi.OdemeTarihi = this.Bilet.TarihBilgileri.OdemeTarihi

                        var deneme = []
                        deneme = this.Bilet.GenelBilgileri.MusteriKodu
                        this.Fatura.BiletBilgi.CariKod = deneme
                        this.Fatura.BiletBilgi.NetTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar

                        this.Fatura.EArsivBilgi.GonderimSekli = this.Bilet.FaturaBilgileri.EfaturaBilgileri.GonderimSekli

                        this.Fatura.EArsivBilgi.InternetSatis = this.Bilet.FaturaBilgileri.EfaturaBilgileri.InternetSatis
                        this.Fatura.EArsivBilgi.OdemeSekli = this.Bilet.FaturaBilgileri.EfaturaBilgileri.OdemeSekli
                        this.Fatura.EArsivBilgi.OdemeSekliAciklama = this.Bilet.FaturaBilgileri.EfaturaBilgileri
                            .OdemeSekliAciklama
                        this.Fatura.EArsivBilgi.OdemeAraci = this.Bilet.FaturaBilgileri.EfaturaBilgileri.OdemeAraci

                        this.Fatura.EArsivBilgi.OdemeTarihi = this.Bilet.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi

                        if (this.Fatura.EArsivBilgi.OdemeTarihi == null || this.Fatura.EArsivBilgi.OdemeTarihi ==
                            '0001-01-01T00:00:00') {
                            this.Fatura.EArsivBilgi.OdemeTarihi = this.Bilet.TarihBilgileri.SatisTarihi
                        }

                        this.Fatura.EArsivBilgi.WebAdresi = this.Bilet.FaturaBilgileri.EfaturaBilgileri.WebAdresi

                        this.Fatura.DovizBilgi.DDovizTipi = this.Bilet.TutarBilgileri.Doviz.DovizKod
                        this.Fatura.DovizBilgi.DKur = this.Bilet.TutarBilgileri.Kur

                        var paramsfatura = this.Fatura
                        this.loadingvmodel = true

                        this.$http.post(auth.API_URL + 'api/TicketInvoice/TicketInvoiceAdd', paramsfatura, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {
                            if (response.body.FaturaStatus === true) {
                                this.faturadialog = false
                                this.text1 = response.body.FaturaResponse
                                this.snackbar = true

                                       setTimeout(function () {
                                        var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.Bilet.GenelBilgileri.HavaYoluKodu +
                                        '&biletno=' + this.Bilet.GenelBilgileri.BiletNo + '&ucustipi=' + this.Bilet.GenelBilgileri.UcusTipi + '&tab=0'                                        
                                         location.href = url
                                         location.reload();
                                        }.bind(this), 3000);
                                   this.loadingvmodel = false

                            } else {
                                this.text1 = response.body.FaturaResponse
                                this.snackbar = true
                                this.loadingvmodel = false
                            }
                        }, (response) => {
                            if (response.status === 0) {
                                this.loadingvmodel = false

                                this.text1 = 'Service Unavailable'
                                this.snackbar = true
                            } else {
                                this.loadingvmodel = false

                                this.text1 = response.body.StatusText
                                this.snackbar = true
                            }
                        })

                    } else {
                        this.text1 = this.$t('Please-choose-a-gib-series')
                        this.snackbar = true
                    }
                } else {
                    this.text1 = this.$t('Please-choose-invoice-design')
                    this.snackbar = true
                }
            } else {
                this.text1 = this.$t('Please-enter-invoice-no')
                this.snackbar = true
            }
        } else {
            this.text1 = this.$t('Please-enter-invoice-serial')
            this.snackbar = true
        }

    } else {
        this.text1 = this.$t('Please-enter-invoice-date')
        this.snackbar = true
    }

}

function tahsilatsil(deger) {

    if (deger.Nereden != 'C' && deger.Nereden != 'c') {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var paramstahsilat = {
            SirketKodu: credentials.SirketKodu,
            OdemeKod: deger.OdemeKod,
            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
            FormNo: this.Bilet.GenelBilgileri.Formno,
            Nereden: deger.Nereden,
            TanimID: deger.TanimID
        }

        this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentDelete', paramstahsilat, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            this.tahsilatdialog = false

            var tahsilatparams = {

                SirketKodu: credentials.SirketKodu,
                BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                FormNo: this.Bilet.GenelBilgileri.Formno,
                BA: 1,
                CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
            }

            this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.tahsilatitems = response.body
                this.tahsilatbakiyeHesapla();
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            } else {
                this.text1 = response.body.StatusText
                this.snackbar = true
            }
        })

    } else {
        this.kisamesaj = this.$t('record-has-received-transaction-cannot-process')
        this.dialogkisamesaj = true
    }
}

function tahsilatgetir(deger) {
        
    if (deger.Nereden != 'C' && deger.Nereden != 'c') {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.BiletAyrintiliOdeme.OdemeKod = deger.OdemeKod
        this.BiletAyrintiliOdeme.TanimID = deger.TanimID
        this.BiletAyrintiliOdeme.SirketKodu = credentials.SirketKodu
        this.BiletAyrintiliOdeme.BiletNo = this.Bilet.GenelBilgileri.BiletNo
        this.BiletAyrintiliOdeme.FormNo = this.Bilet.GenelBilgileri.Formno
        this.BiletAyrintiliOdeme.Nereden = deger.Nereden
        this.BiletAyrintiliOdeme.CariKod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
        this.BiletAyrintiliOdeme.Referans = this.Bilet.GenelBilgileri.Referans.Kod
        this.BiletAyrintiliOdeme.Masraf = this.Bilet.GenelBilgileri.Masraf.Code
        this.BiletAyrintiliOdeme.Faturano = deger.FaturaNo
        this.BiletAyrintiliOdeme.FaturaTarih = deger.FaturaTarih
        this.BiletAyrintiliOdeme.FaturaSeri = this.Bilet.FaturaBilgileri.FaturaSeri
        this.BiletAyrintiliOdeme.Tarih = deger.Tarih
        this.BiletAyrintiliOdeme.EvrakCinsi = deger.Evrak.Evrakkod
        this.BiletAyrintiliOdeme.Doviz = deger.DovizCinsi
        this.BiletAyrintiliOdeme.Kur = deger.Kur
        this.BiletAyrintiliOdeme.Tutar = deger.Tutar
        this.BiletAyrintiliOdeme.DovizTutar = deger.DovizTutar
        this.BiletAyrintiliOdeme.PosKod = deger.PosKod
        this.BiletAyrintiliOdeme.EvrakNo = deger.Evrakno
        this.BiletAyrintiliOdeme.KrediKartNo = deger.KrediKartNo
        this.BiletAyrintiliOdeme.Aciklama = deger.Aciklama
        this.BiletAyrintiliOdeme.TaksitKod = deger.TaksitID
        this.BiletAyrintiliOdeme.TaksitKodLabel = deger.TaksitKodLabel
        this.BiletAyrintiliOdeme.PuanTutar = deger.PuanTutar
        this.BiletAyrintiliOdeme.BankaKod = deger.BankaKod
        this.BiletAyrintiliOdeme.KarsiCari = deger.KarsiCari

        this.$refs.tahsilatdialog1.open("update", this.tahsilatBakiye).then(sonuc => {
            if (sonuc == true) {

                //kayıt başarılı ise listeyi güncelleyelim

                var tahsilatparams = {
                    SirketKodu: credentials.SirketKodu,
                    BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                    FormNo: this.Bilet.GenelBilgileri.Formno,
                    BA: 1,
                    CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
                }
                this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
                    headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                    }
                }).then((response) => {
                    this.tahsilatitems = response.body
                    this.tahsilatbakiyeHesapla();
                }, (response) => {
                    if (response.status === 0) {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    } else {
                        this.text1 = 'Service Unavailable'
                        this.snackbar = true
                    }
                })
            }
        });
    } else {
        this.kisamesaj = this.$t('record-has-received-transaction-cannot-process')
        this.dialogkisamesaj = true
    }

}

function tahsilatguncelle(deger) {

    if (deger.Nereden != 'C' && deger.Nereden != 'c') {
        var paramstahsilat = this.BiletAyrintiliOdeme
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        this.$http.post(auth.API_URL + 'api/Payment/DetailPaymentUpdate', paramstahsilat, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            this.tahsilatdialog = false

            var tahsilatparams = {

                SirketKodu: credentials.SirketKodu,
                BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                FormNo: this.Bilet.GenelBilgileri.Formno,
                BA: 1,
                CariKod: this.Bilet.GenelBilgileri.MusteriKodu.Kod
            }

            this.$http.post(auth.API_URL + 'api/CurrentMovement/CurrentTicketList', tahsilatparams, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {
                this.tahsilatitems = response.body
                this.tahsilatbakiyeHesapla();
            }, (response) => {
                if (response.status === 0) {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                } else {
                    this.text1 = 'Service Unavailable'
                    this.snackbar = true
                }
            })

        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            } else {
                this.text1 = response.body.StatusText
                this.snackbar = true
            }
        })

    } else {
        this.kisamesaj = this.$t('record-has-received-transaction-cannot-process')
        this.dialogkisamesaj = true
    }
}

function tarihformatla(datem) {
    var gun = datem.getDate();
    var ay = datem.getMonth() + 1;
    var yil = datem.getFullYear();

    if (ay < 10) {
        ay = '0' + ay
    }
    if (gun < 10) {
        gun = '0' + gun
    }

    return yil + "-" + ay + "-" + gun;

}

function biletsil() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    var manage = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

    var paramsvoid = {
        SirketKodu: credentials.SirketKodu,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
        Formno: this.Bilet.GenelBilgileri.Formno,
        UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
        Login: {
            UserID: manage.UserInfo.UserID,
            Email: manage.UserInfo.Email
        },
        IssueDate: getDateNow()
    }

    this.$http.post(auth.API_URL + 'api/Ticket/TicketDelete', paramsvoid, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true

        if (response.body.Status == true) {
            setTimeout(function () {
                this.sayfakapat()
            }.bind(this), 750)
            this.dialogkisamesaj = false

        }

    }, (response) => {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })
}

function havayoluKoddegistir() {

    if (this.vmodelhyKod.HavaYoluKodu != null && this.vmodelhyKod.UcusTipi != null) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var acentebileti = false

        if (this.vmodelhyKod.AcenteKodu != null) {
            acentebileti = true
        } else {
            acentebileti = false
        }

        var params = {
            BiletBilgi: {
                SirketKodu: credentials.SirketKodu,
                HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                FormNo: this.Bilet.GenelBilgileri.Formno,
                BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                SatisTarihi: this.Bilet.TarihBilgileri.SatisTarihi,
            },
            HavaYoluKodu: this.vmodelhyKod.HavaYoluKodu,
            UcusTipi: this.vmodelhyKod.UcusTipi,
            AcenteBilet: acentebileti,
            AcenteKodu: this.vmodelhyKod.AcenteKodu,
            UserID: credentials.UserID
        }

        this.$http.post(auth.API_URL + 'api/Ticket/TicketAirlineChange', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

            if (response.body.Status == true) {
                
                     setTimeout(function () {
                    var url = '#/bilet/yeni/id?' + 'isl=get&hyolukod=' + this.vmodelhyKod.HavaYoluKodu + '&biletno=' + this.Bilet.GenelBilgileri.BiletNo + '&ucustipi=' + this.vmodelhyKod.UcusTipi                                     
                    location.href = url
                    location.reload();
                    }.bind(this), 2000);
                this.dialoghydegistir = false

            }

        }, (response) => {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            if (response.status === 0) {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            } else {
                this.text1 = 'Service Unavailable'
                this.snackbar = true
            }
        })
    } else {
        this.text1 = 'Havayolu Kodu veya Uçuş Tipini boş bırakamazsınız!'
        this.snackbar = true
    }

}

function voidislem() {

    if (this.$refs.formvoid.validate()) {
        this.loadingdialog = true
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params = {
            MusteriID: credentials.MusteriID,
            HareketTip: 'Void',
            HareketSayisi: 1
        }

        this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {

            if (response.body.UyelikStatus == true) {

                if (response.body.KontorStatus == true) {

                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                    var paramsvoid = {
                        SirketKodu: credentials.SirketKodu,
                        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                        HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                        Formno: this.Bilet.GenelBilgileri.Formno,
                        UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
                        // Login: {eklenecek},
                        IssueDate: this.voidTarihi,
                    }

                    this.$http.post(auth.API_URL + 'api/Ticket/VoidAdd', paramsvoid, {
                        headers: {
                            'Authorization': 'Bearer ' + auth.getAuthHeader()
                        }
                    }).then((response) => {

                      if (response.body.Status != Boolean(false)) {
                        this.text1 = this.$t('Void-operation-completed')
                        this.snackbar = true
                        setTimeout(function () {
                            this.sayfakapat()
                        }.bind(this), 750)
                        this.voiddialog = false
                       }else{
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                        this.loadingdialog = false
                        }
                        
                    }, (response) => {
                         this.text1 = this.$t(response.body.ResponseMessage)
                        this.snackbar = true
                        if (response.status === 0) {
                            this.text1 = 'Service Unavailable'
                            this.snackbar = true
                        } else {
                             this.text1 = this.$t(response.body.ResponseMessage)
                            this.snackbar = true
                        }
                    })
                    this.loadingdialog = true

                } else {
                    this.loadingdialog = true
                    this.text1 = this.$t('not-process-need-purchase-continue-process')
                    this.snackbar = true
                }

            } else {
                this.loadingdialog = true
                this.text1 = this.$t('membership-expired-need-renew-membership-process')
                this.snackbar = true
            }

        }, (response) => {

            if (response.status === 0) {
                this.text1 = 'Service Unavailable-ProductCustomerInfo'
                this.snackbar = true
                this.loadingdialog = true
                islemok = false
            } else {
                this.text1 = 'Service Unavailable-ProductCustomerInfo'
                this.snackbar = true
                this.loadingdialog = true
            }
        })

    }

}

function voidiptal() {

    this.loadingvmodel = true;
    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var paramsvoid = {
        SirketKodu: credentials.SirketKodu,
        BiletNo: this.Bilet.GenelBilgileri.BiletNo,
        HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
        Formno: this.Bilet.GenelBilgileri.Formno,
        UcusTipi: this.Bilet.GenelBilgileri.UcusTipi,
        IssueDate: this.Bilet.TarihBilgileri.SatisTarihi
    }

    this.$http.post(auth.API_URL + 'api/Ticket/VoidCancel', paramsvoid, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {


        if (response.body.Status != Boolean(false)) {
        this.text1 = 'Void iptal işlemi tamamlandı.'
        this.snackbar = true
        this.loadingvmodel = false;
        setTimeout(function () {
            this.sayfakapat()
        }.bind(this), 750)
        }
        else{
         this.text1 = this.$t(response.body.ResponseMessage)
        this.snackbar = true
        this.loadingdialog = false
        this.loadingvmodel = false;
        }



    }, (response) => {
        this.text1 = response.body.ExceptionMessage
        this.snackbar = true
        this.loadingvmodel = false;
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = response.body.ExceptionMessage
            this.snackbar = true
        }
    })
}

function biletkaydet() {
   
   if (this.counter == 1) {
         this.Bilet.TanimBilgileri.ProfilID = this.Sablon.ProfilID;
         this.Bilet.TanimBilgileri.SablonID= this.Sablon.TemplateID;
        if (this.Bilet.GenelBilgileri.MusteriKodu.Kod != null && this.Bilet.GenelBilgileri.MusteriKodu.Kod != '') {
               
            if (this.Bilet.TarihBilgileri.SatisTarihi != null && this.Bilet.TarihBilgileri.SatisTarihi != '') {
              
                if (this.Bilet.TarihBilgileri.OdemeTarihi != null && this.Bilet.TarihBilgileri.OdemeTarihi != '') {
                    
                    if (this.biletcoklumu == false) {
                        this.loadingdialog = true
                    }
                    
                    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

                    this.Bilet.GenelBilgileri.SirketKodu = credentials.SirketKodu

                    var yeniucuslistesi = []

                    var parkurno = 1

                    if (this.UcusListesi.Ucus1.FareBases != 0 ||
                        (this.UcusListesi.Ucus1.Parkur != '' && this.UcusListesi.Ucus1.Parkur != null) ||
                        (this.UcusListesi.Ucus1.ParkurNo != '' && this.UcusListesi.Ucus1.ParkurNo != null) ||
                        (this.UcusListesi.Ucus1.UcusClass != '' && this.UcusListesi.Ucus1.UcusClass != null) ||
                        (this.UcusListesi.Ucus1.UcusHY != '' && this.UcusListesi.Ucus1.UcusHY != null) ||
                        (this.UcusListesi.Ucus1.UcusNo != '' && this.UcusListesi.Ucus1.UcusNo != null) ||
                        (this.UcusListesi.Ucus1.UcusSaat != '' && this.UcusListesi.Ucus1.UcusSaat != null) ||
                        (this.UcusListesi.Ucus1.UcusTarihi != '' && this.UcusListesi.Ucus1.UcusTarihi != null) ||
                        (this.UcusListesi.Ucus1.VarisSaat != '' && this.UcusListesi.Ucus1.VarisSaat != null) ||
                        (this.UcusListesi.Ucus1.VarisTarihi != '' && this.UcusListesi.Ucus1.VarisTarihi != null)) {
                            
                        var ucuslistesi1 = {
                            Aktarma: this.UcusListesi.Ucus1.Aktarma,
                            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                            FareBases: this.UcusListesi.Ucus1.FareBases,
                            Formno: this.Bilet.GenelBilgileri.Formno,
                            ID: this.UcusListesi.Ucus1.ID,
                            Parkur: this.UcusListesi.Ucus1.Parkur,
                            ParkurNo: parkurno, //this.UcusListesi.Ucus1.ParkurNo,
                            SirketKodu: credentials.SirketKodu,
                            UcusClass: this.UcusListesi.Ucus1.UcusClass,
                            UcusClassTip: this.UcusListesi.Ucus1.UcusClassTip,

                            UcusHY: this.UcusListesi.Ucus1.UcusHY,
                            UcusNo: this.UcusListesi.Ucus1.UcusNo,
                            UcusSaat: this.UcusListesi.Ucus1.UcusSaat,
                            UcusTarihi: this.UcusListesi.Ucus1.UcusTarihi,
                            VarisSaat: this.UcusListesi.Ucus1.VarisSaat,
                            VarisTarihi: this.UcusListesi.Ucus1.VarisTarihi
                        }
                        yeniucuslistesi.push(ucuslistesi1)
                        parkurno = parkurno + 1
              
                    }

                    if (this.UcusListesi.Ucus2.FareBases != 0 ||
                        (this.UcusListesi.Ucus2.Parkur != '' && this.UcusListesi.Ucus2.Parkur != null) ||
                        (this.UcusListesi.Ucus2.ParkurNo != '' && this.UcusListesi.Ucus2.ParkurNo != null) ||
                        (this.UcusListesi.Ucus2.UcusClass != '' && this.UcusListesi.Ucus2.UcusClass != null) ||
                        (this.UcusListesi.Ucus2.UcusHY != '' && this.UcusListesi.Ucus2.UcusHY != null) ||
                        (this.UcusListesi.Ucus2.UcusNo != '' && this.UcusListesi.Ucus2.UcusNo != null) ||
                        (this.UcusListesi.Ucus2.UcusSaat != '' && this.UcusListesi.Ucus2.UcusSaat != null) ||
                        (this.UcusListesi.Ucus2.UcusTarihi != '' && this.UcusListesi.Ucus2.UcusTarihi != null) ||
                        (this.UcusListesi.Ucus2.VarisSaat != '' && this.UcusListesi.Ucus2.VarisSaat != null) ||
                        (this.UcusListesi.Ucus2.VarisTarihi != '' && this.UcusListesi.Ucus2.VarisTarihi != null)) {
                        
                        var ucuslistesi2 = {
                            Aktarma: this.UcusListesi.Ucus2.Aktarma,
                            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                            FareBases: this.UcusListesi.Ucus2.FareBases,
                            Formno: this.Bilet.GenelBilgileri.Formno,
                            ID: this.UcusListesi.Ucus2.ID,
                            Parkur: this.UcusListesi.Ucus2.Parkur,
                            ParkurNo: parkurno, //this.UcusListesi.Ucus2.ParkurNo,
                            SirketKodu: credentials.SirketKodu,
                            UcusClass: this.UcusListesi.Ucus2.UcusClass,
                            UcusClassTip: this.UcusListesi.Ucus2.UcusClassTip,
                            UcusHY: this.UcusListesi.Ucus2.UcusHY,
                            UcusNo: this.UcusListesi.Ucus2.UcusNo,
                            UcusSaat: this.UcusListesi.Ucus2.UcusSaat,
                            UcusTarihi: this.UcusListesi.Ucus2.UcusTarihi,
                            VarisSaat: this.UcusListesi.Ucus2.VarisSaat,
                            VarisTarihi: this.UcusListesi.Ucus2.VarisTarihi
                        }
                        yeniucuslistesi.push(ucuslistesi2)
                        parkurno = parkurno + 1
           
                    }

                    if (this.UcusListesi.Ucus3.FareBases != 0 ||
                        (this.UcusListesi.Ucus3.Parkur != '' && this.UcusListesi.Ucus3.Parkur != null) ||
                        (this.UcusListesi.Ucus3.ParkurNo != '' && this.UcusListesi.Ucus3.ParkurNo != null) ||
                        (this.UcusListesi.Ucus3.UcusClass != '' && this.UcusListesi.Ucus3.UcusClass != null) ||
                        (this.UcusListesi.Ucus3.UcusHY != '' && this.UcusListesi.Ucus3.UcusHY != null) ||
                        (this.UcusListesi.Ucus3.UcusNo != '' && this.UcusListesi.Ucus3.UcusNo != null) ||
                        (this.UcusListesi.Ucus3.UcusSaat != '' && this.UcusListesi.Ucus3.UcusSaat != null) ||
                        (this.UcusListesi.Ucus3.UcusTarihi != '' && this.UcusListesi.Ucus3.UcusTarihi != null) ||
                        (this.UcusListesi.Ucus3.VarisSaat != '' && this.UcusListesi.Ucus3.VarisSaat != null) ||
                        (this.UcusListesi.Ucus3.VarisTarihi != '' && this.UcusListesi.Ucus3.VarisTarihi != null)) {
 
                
                        var ucuslistesi3 = {
                            Aktarma: this.UcusListesi.Ucus3.Aktarma,
                            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                            FareBases: this.UcusListesi.Ucus3.Bases,
                            Formno: this.Bilet.GenelBilgileri.Formno,
                            ID: this.UcusListesi.Ucus3.ID,
                            Parkur: this.UcusListesi.Ucus3.Parkur,
                            ParkurNo: parkurno, //this.UcusListesi.Ucus3.ParkurNo,
                            SirketKodu: credentials.SirketKodu,
                            UcusClass: this.UcusListesi.Ucus3.UcusClass,
                            UcusClassTip: this.UcusListesi.Ucus3.UcusClassTip,
                            UcusHY: this.UcusListesi.Ucus3.UcusHY,
                            UcusNo: this.UcusListesi.Ucus3.UcusNo,
                            UcusSaat: this.UcusListesi.Ucus3.UcusSaat,
                            UcusTarihi: this.UcusListesi.Ucus3.UcusTarihi,
                            VarisSaat: this.UcusListesi.Ucus3.VarisSaat,
                            VarisTarihi: this.UcusListesi.Ucus3.VarisTarihi
                        }
                        yeniucuslistesi.push(ucuslistesi3)
                        parkurno = parkurno + 1

                    }

                    if (this.UcusListesi.Ucus4.FareBases != 0 ||
                        (this.UcusListesi.Ucus4.Parkur != '' && this.UcusListesi.Ucus4.Parkur != null) ||
                        (this.UcusListesi.Ucus4.ParkurNo != '' && this.UcusListesi.Ucus4.ParkurNo != null) ||
                        (this.UcusListesi.Ucus4.UcusClass != '' && this.UcusListesi.Ucus4.UcusClass != null) ||
                        (this.UcusListesi.Ucus4.UcusHY != '' && this.UcusListesi.Ucus4.UcusHY != null) ||
                        (this.UcusListesi.Ucus4.UcusNo != '' && this.UcusListesi.Ucus4.UcusNo != null) ||
                        (this.UcusListesi.Ucus4.UcusSaat != '' && this.UcusListesi.Ucus4.UcusSaat != null) ||
                        (this.UcusListesi.Ucus4.UcusTarihi != '' && this.UcusListesi.Ucus4.UcusTarihi != null) ||
                        (this.UcusListesi.Ucus4.VarisSaat != '' && this.UcusListesi.Ucus4.VarisSaat != null) ||
                        (this.UcusListesi.Ucus4.VarisTarihi != '' && this.UcusListesi.Ucus4.VarisTarihi != null)) {
                        var ucuslistesi4 = {
                            Aktarma: this.UcusListesi.Ucus4.Aktarma,
                            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                            FareBases: this.UcusListesi.Ucus4.FareBases,
                            Formno: this.Bilet.GenelBilgileri.Formno,
                            ID: this.UcusListesi.Ucus4.ID,
                            Parkur: this.UcusListesi.Ucus4.Parkur,
                            ParkurNo: parkurno, //this.UcusListesi.Ucus4.ParkurNo,
                            SirketKodu: credentials.SirketKodu,
                            UcusClass: this.UcusListesi.Ucus4.UcusClass,
                            UcusClassTip: this.UcusListesi.Ucus4.UcusClassTip,

                            UcusHY: this.UcusListesi.Ucus4.UcusHY,
                            UcusNo: this.UcusListesi.Ucus4.UcusNo,
                            UcusSaat: this.UcusListesi.Ucus4.UcusSaat,
                            UcusTarihi: this.UcusListesi.Ucus4.UcusTarihi,
                            VarisSaat: this.UcusListesi.Ucus4.VarisSaat,
                            VarisTarihi: this.UcusListesi.Ucus4.VarisTarihi
                        }
                        yeniucuslistesi.push(ucuslistesi4)
                        parkurno = parkurno + 1
  
                    }

                    if (this.UcusListesi.Ucus5.FareBases != 0 ||
                        (this.UcusListesi.Ucus5.Parkur != '' && this.UcusListesi.Ucus5.Parkur != null) ||
                        (this.UcusListesi.Ucus5.ParkurNo != '' && this.UcusListesi.Ucus5.ParkurNo != null) ||
                        (this.UcusListesi.Ucus5.UcusClass != '' && this.UcusListesi.Ucus5.UcusClass != null) ||
                        (this.UcusListesi.Ucus5.UcusHY != '' && this.UcusListesi.Ucus5.UcusHY != null) ||
                        (this.UcusListesi.Ucus5.UcusNo != '' && this.UcusListesi.Ucus5.UcusNo != null) ||
                        (this.UcusListesi.Ucus5.UcusSaat != '' && this.UcusListesi.Ucus5.UcusSaat != null) ||
                        (this.UcusListesi.Ucus5.UcusTarihi != '' && this.UcusListesi.Ucus5.UcusTarihi != null) ||
                        (this.UcusListesi.Ucus5.VarisSaat != '' && this.UcusListesi.Ucus5.VarisSaat != null) ||
                        (this.UcusListesi.Ucus5.VarisTarihi != '' && this.UcusListesi.Ucus5.VarisTarihi != null)) {
                        var ucuslistesi5 = {
                            Aktarma: this.UcusListesi.Ucus5.Aktarma,
                            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                            FareBases: this.UcusListesi.Ucus5.FareBases,
                            Formno: this.Bilet.GenelBilgileri.Formno,
                            ID: this.UcusListesi.Ucus5.ID,
                            Parkur: this.UcusListesi.Ucus5.Parkur,
                            ParkurNo: parkurno, //this.UcusListesi.Ucus5.ParkurNo,
                            SirketKodu: credentials.SirketKodu,
                            UcusClass: this.UcusListesi.Ucus5.UcusClass,
                            UcusClassTip: this.UcusListesi.Ucus5.UcusClassTip,

                            UcusHY: this.UcusListesi.Ucus5.UcusHY,
                            UcusNo: this.UcusListesi.Ucus5.UcusNo,
                            UcusSaat: this.UcusListesi.Ucus5.UcusSaat,
                            UcusTarihi: this.UcusListesi.Ucus5.UcusTarihi,
                            VarisSaat: this.UcusListesi.Ucus5.VarisSaat,
                            VarisTarihi: this.UcusListesi.Ucus5.VarisTarihi
                        }
                        yeniucuslistesi.push(ucuslistesi5)
                        parkurno = parkurno + 1
        
                    }

                    this.Bilet.UcusBilgileri.UcusListesi = yeniucuslistesi

                    //satış şekline göre tutarları yazıyoruz
                    if (this.Bilet.OdemeBilgileri.SatisSekli == 'K') {
                     
                        this.Bilet.OdemeBilgileri.KrediliTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                        this.Bilet.OdemeBilgileri.PesinTutar = 0
                        this.Bilet.OdemeBilgileri.KrediKartTutar = 0
                        this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = null

                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = null

                    } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'P') {
                        this.Bilet.OdemeBilgileri.PesinTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                        this.Bilet.OdemeBilgileri.KrediliTutar = 0
                        this.Bilet.OdemeBilgileri.KrediKartTutar = 0
                        this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'P'

                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = null
                        
                    } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'R' || this.Bilet.OdemeBilgileri.SatisSekli == 'C' ||
                        this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
                          
                        if (this.Bilet.OdemeBilgileri.SatisSekli == 'R') {
                            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'R'
                      
                            this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                            this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = null

                            if (this.servispostaksitsayi.id != undefined) {
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = this.servispostaksitsayi.id
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = this.servispostaksitsayi.label
                           
                            } else {
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = null
                        
                            }

                        } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'C') {
                            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'C'
                                  
                            if (this.postaksitsayi.id != undefined) {
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = this.postaksitsayi.id
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = this.postaksitsayi.label
                            
                            } else {
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = null
                              
                            }

                            this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                            this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = null
                          

                        } else if (this.Bilet.OdemeBilgileri.SatisSekli == 'F') {
                           
                            this.Bilet.OdemeBilgileri.KrediKartBilgi.KrediKartTip = 'F'
                            //this.Bilet.OdemeBilgileri.SatisSekli = 'F'

                            if (this.postaksitsayi.id != undefined) {
                                
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = this.postaksitsayi.id
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = this.postaksitsayi.label
                            } else {
                            
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                                this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = null
                            }

                            if (this.servispostaksitsayi.id != undefined) {
                                
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = this.servispostaksitsayi.id
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = this.servispostaksitsayi.label
                            } else {
                             
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                                this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = null
                            }

                        }
                                        
                        this.Bilet.OdemeBilgileri.KrediKartTutar = this.Bilet.TutarBilgileri.NetTutar.NetTutar
                        this.Bilet.OdemeBilgileri.KrediliTutar = 0
                        this.Bilet.OdemeBilgileri.PesinTutar = 0
                    }

                    if (this.faturanovarise == false && this.faturalansinmi == false) {
                        this.Bilet.FaturaBilgileri.FaturaSeri = 'H'
                 
                    } else {
                        this.Bilet.FaturaBilgileri.FaturaSeri = null
                     
                    }

                    if (this.postaksitsayi.id != undefined) {
                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = this.postaksitsayi.id
                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = this.postaksitsayi.label
                      
                    } else {
                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKod = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.TaksitKodLabel = null
                 
                    }

                    if (this.servispostaksitsayi.id != undefined) {
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = this.servispostaksitsayi.id
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = this.servispostaksitsayi.label
               
                    } else {
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKod = null
                        this.Bilet.OdemeBilgileri.BankaBilgileri.ServisTaksitKodLabel = null
                     
                    }

                    //satış bilet değilse
                    if (this.Bilet.GenelBilgileri.Status != 'S') {
                        this.Bilet.TarihBilgileri.OpenTarihi = null
                        this.Bilet.GenelBilgileri.OpenBilet = false
                      
                    }

                    // var kod2=this.Bilet.MusteriKodu.Kod;
                    // var MusteriKodu2 = {
                    //         Kod: kod2
                    // }
                    // this.Bilet.MusteriKodu=MusteriKodu2;

                    var tahsilatdurumu = this.tahsilatAyarla();
                    if (tahsilatdurumu == true) {
                    if (this.biletcoklumu == false) {
                        
                       var paramsbilet = this.Bilet;
                       this.$http.post(auth.API_URL + 'api/Ticket/TicketAddAndLoad', paramsbilet, {
                           headers: {
                               'Authorization': 'Bearer ' + auth.getAuthHeader()
                           }
                        }).then((response) => {
                       this.text1 = this.$t(response.body.ResponseMessage)
                       this.snackbar = true
                       this.loadingdialog = false
                       if (response.body.Status != Boolean(false)) {
                        this.ilkgiriskontrol = true;
                        this.ticketGetProcess(response.body.Bilet,2);
                       }else{
                        this.loadingdialog = false
                        this.counter = 0
                        }

                       }, (response) => {
                                if (response.status === 0) {
                                    this.text1 = 'Service Unavailable'
                                    this.snackbar = true
                                    this.counter = 0
                                    this.loadingdialog = false

                                } else {
                                    let data ={
                                    response: response,
                                    request: paramsbilet,
                                    api:'TicketSaveAndLoad',
                                    type:3,
                                    message: this.$t(response.body.ExceptionMessage)
                                    };
                                    this.$refs.showMessage.open(data);
                                    this.counter = 0
                                    this.loadingdialog = false

                                }
                            })
                         }

                        if (this.biletcoklumu == true) {
                            this.groupTicketProgressDialog = true;
                             this.ticketGroupAdd();
                        }

                    } else {}

                } else {
                    this.text1 = this.$t('Please-enter-payment-date')
                    this.snackbar = true
                    this.counter = 0

                }
            } else {
                this.text1 = this.$t('Please-select-a-sales-date')
                this.snackbar = true
                this.counter = 0

            }
        } else {
            this.text1 = this.$t('Please-select-a-current-code')
            this.snackbar = true
            this.counter = 0
        }
   } else {
       return false;
   }
}

function biletislemsorgula() {
    this.biletislemCounter += 1;
    if(this.biletislemCounter == 1){
    if (this.Bilet.GenelBilgileri.Baglantili == false) {

        var control1 = false

        if (this.Bilet.GenelBilgileri.BiletNo != null && this.Bilet.GenelBilgileri.BiletNo != '') {

            if (this.Bilet.GenelBilgileri.HavaYoluKodu != null && this.Bilet.GenelBilgileri.HavaYoluKodu != '') {

                if (this.Bilet.GenelBilgileri.UcusTipi != null && this.Bilet.GenelBilgileri.UcusTipi != '') {

                    if (this.Bilet.GenelBilgileri.AcenteKodu != '' && this.Bilet.GenelBilgileri.AcenteKodu != null && this
                        .Bilet.GenelBilgileri.Acente == 'A') {

                        control1 = true
                        this.baslik_mesaji = this.$t('This-Ticket') + ' ' + this.Bilet.GenelBilgileri.AcenteKodu + ' ' + this.$t('received-from-the-agency')

                    } else if (this.acentabiletimi === false) {
                        control1 = true
                        this.Bilet.GenelBilgileri.AcenteKodu = ''
                        this.baslik_mesaji = ''
                        this.Bilet.GenelBilgileri.Acente = ''
                        
                    } else if (this.acentabiletimi === true && (this.Bilet.GenelBilgileri.AcenteKodu == '' || this.Bilet
                            .GenelBilgileri.AcenteKodu == null)) {
                        control1 = false
                        this.baslik_mesaji = ''
                        this.text1 = this.$t('Please-choose-your-agency...')
                        this.snackbar = true
                        this.Bilet.GenelBilgileri.AcenteKodu = ''
                        this.Bilet.GenelBilgileri.Acente = ''
                        this.biletislemCounter = 0;
                    }
                } else {
                    this.text1 = this.$t('Please-select-the-flight-type...')
                    this.snackbar = true
                    control1 = false
                    this.biletislemCounter = 0;
                }
            } else {
                this.text1 = this.$t('Please-select-the-airline-code...')
                this.snackbar = true
                control1 = false
                this.biletislemCounter = 0;
            }
        } else {
            this.text1 = this.$t('Please-enter-the-ticket-number-completely...')
            this.snackbar = true
            control1 = false
            this.biletislemCounter = 0;
        }

        if (control1 === true) {

            // işlem yapmak için üyelik durumuna bakıyoruz

            var islemok = false

            var credentials = JSON.parse(window.localStorage.getItem('credentials'));
            var params = {
                MusteriID: credentials.MusteriID,
                HareketTip: 'Bilet',
                HareketSayisi: 1
            }

            this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', params, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                if (response.body.UyelikStatus == true) {

                    if (response.body.KontorStatus == true) {

                        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
                        var paramssorgu = {
                            SirketKodu: credentials.SirketKodu,
                            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                            HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                            Formno: this.Bilet.GenelBilgileri.Formno,
                            UcusTipi: this.Bilet.GenelBilgileri.UcusTipi
                        }
                        this.$http.post(auth.API_URL + 'api/Ticket/TicketControl', paramssorgu, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {

                            if (response.body == 'Bos') {
                                this.yenidialog = false
                                this.biletnodisabled = true
                                this.kaydetbuton = true
                                this.bekletme = true;
                            } else {
                                this.text1 = 'Bilet numarası işlem yapmak için uygun değildir.'
                                this.snackbar = true
                                this.bekletme = false;
                                this.biletislemCounter = 0;
                            }
                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable/TicketControl'
                                this.snackbar = true
                                this.biletislemCounter = 0;
                            } else {
                                this.text1 = response.body.StatusText
                                this.snackbar = true
                                this.biletislemCounter = 0;
                            }
                        })

                    } else {
                        this.islemok = false
                        this.text1 = this.$t('not-process-need-purchase-continue-process')
                        this.snackbar = true
                        this.biletislemCounter = 0;
                    }

                } else {
                    this.text1 = this.$t('membership-expired-need-renew-membership-process')
                    this.snackbar = true
                    this.biletislemCounter = 0;
                    islemok = false
                }

            }, (response) => {

                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-ProductCustomerInfo'
                    this.snackbar = true
                    this.biletislemCounter = 0;
                    islemok = false
                } else {
                    this.text1 = 'Service Unavailable-ProductCustomerInfo'
                    this.snackbar = true
                    this.biletislemCounter = 0;
                }
            })

        }
    } else {

        var control2 = false;

        if (this.Bilet.GenelBilgileri.BiletNo != null && this.Bilet.GenelBilgileri.BiletNo != '' && this.Bilet
            .GenelBilgileri.ArkmanUsers != '' && this.Bilet.GenelBilgileri.ArkmanUsers != null) {

            if (this.Bilet.GenelBilgileri.HavaYoluKodu != null && this.Bilet.GenelBilgileri.HavaYoluKodu != '') {

                if (this.Bilet.GenelBilgileri.UcusTipi != null && this.Bilet.GenelBilgileri.UcusTipi != '') {

                    if (this.Bilet.GenelBilgileri.AcenteKodu != '' && this.Bilet.GenelBilgileri.AcenteKodu != null && this
                        .Bilet
                        .GenelBilgileri.Acente == 'A') {
                        control2 = true
                        this.baslik_mesaji = '(Bu bilet acentadan alınmıştır)'

                    } else if (this.acentabiletimi === false) {
                        control2 = true
                        this.Bilet.GenelBilgileri.AcenteKodu = ''
                        this.baslik_mesaji = ''
                        this.Bilet.GenelBilgileri.Acente = ''
                    } else if (this.acentabiletimi === true && (this.Bilet.GenelBilgileri.AcenteKodu == '' || this.Bilet
                            .GenelBilgileri.AcenteKodu == null)) {
                        control2 = false
                        this.baslik_mesaji = ''
                        this.text1 = this.$t('Please-Select-a-Agency')
                        this.snackbar = true
                        this.Bilet.GenelBilgileri.AcenteKodu = ''
                        this.Bilet.GenelBilgileri.Acente = ''
                        this.biletislemCounter = 0;
                    }
                } else {
                    this.text1 = this.$t('Please-Select-Flight-Type')
                    this.snackbar = true
                    control2 = false
                    this.biletislemCounter = 0;
                }
            } else {
                this.text1 = this.$t('Please-Select-Airline-Code')
                this.snackbar = true
                control2 = false
                this.biletislemCounter = 0;

            }
        } else {
            this.text1 = this.$t('Please-enter-the-ticket-numbers-completely...')
            this.snackbar = true
            control2 = false
            this.biletislemCounter = 0;
        }

        if (control2 === true) {
            var credentials = JSON.parse(window.localStorage.getItem('credentials'));

            var islemok = false

            var kacbilet = this.Bilet.GenelBilgileri.ArkmanUsers - this.Bilet.GenelBilgileri.BiletNo + 1

            var paramsPackageCustomerInfos = {
                MusteriID: credentials.MusteriID,
                HareketTip: 'Bilet',
                HareketSayisi: kacbilet
            }

            this.$http.post(auth.API_URL + 'api/Register/PackageCustomerInfos', paramsPackageCustomerInfos, {
                headers: {
                    'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
            }).then((response) => {

                if (response.body.UyelikStatus == true) {

                    if (response.body.KontorStatus == true) {

                        var paramssorgu1 = {
                            SirketKodu: credentials.SirketKodu,
                            BiletNo: this.Bilet.GenelBilgileri.BiletNo,
                            BiletNoSon: this.Bilet.GenelBilgileri.ArkmanUsers,
                            HavayoluKodu: this.Bilet.GenelBilgileri.HavaYoluKodu,
                            Formno: this.Bilet.GenelBilgileri.Formno,
                            UcusTipi: this.Bilet.GenelBilgileri.UcusTipi
                        }
                        this.$http.post(auth.API_URL + 'api/Ticket/TicketControlGroup', paramssorgu1, {
                            headers: {
                                'Authorization': 'Bearer ' + auth.getAuthHeader()
                            }
                        }).then((response) => {

                            if (response.body.ResponseInfo.Status == true) {
                                var i = 1;
                                var yenikayit = []
                                response.body.BiletList.forEach(element => {
                                    var NewObject = {};
                                    NewObject['Label'] = i + '. Yolcu Adı Soyadı';
                                    NewObject['BiletNo'] = element.BiletNo;
                                    NewObject['vmodelname'] = 'vmodel' + i;
                                    yenikayit.push(NewObject)
                                    i = i + 1;
                                });

                                this.objeler = yenikayit
                                this.biletcoklumu = true;
                                this.cokluyolcudialog = true
                            } else {
                                this.biletcoklumu = false;
                                this.text1 = response.body.ResponseInfo.ResponseMessage;
                                this.snackbar = true
                                this.biletislemCounter = 0;
                            }

                        }, (response) => {
                            if (response.status === 0) {
                                this.text1 = 'Service Unavailable'
                                this.snackbar = true
                                this.biletislemCounter = 0;
                            } else {
                                this.text1 = response.body.StatusText
                                this.snackbar = true
                                this.biletislemCounter = 0;
                            }
                        })

                    } else {
                        this.islemok = false
                        this.text1 = this.$t('not-process-need-purchase-continue-process')
                        this.snackbar = true
                        this.biletislemCounter = 0;
                    }

                } else {
                    this.text1 = this.$t('membership-expired-need-renew-membership-process')
                    this.snackbar = true
                    islemok = false
                    this.biletislemCounter = 0;
                }

            }, (response) => {

                if (response.status === 0) {
                    this.text1 = 'Service Unavailable-ProductCustomerInfo'
                    this.snackbar = true
                    this.biletislemCounter = 0;
                    islemok = false
                } else {
                    this.text1 = 'Service Unavailable-ProductCustomerInfo'
                    this.snackbar = true
                    this.biletislemCounter = 0;
                }
            })

        }
    }
    }
}

function taksitgetirservis() {

    if (this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu != null) {
        this.bankapositems.forEach(element => {
            if (element.PosKodu == this.Bilet.OdemeBilgileri.BankaBilgileri.ServisPosKod.PosKodu) {
                this.taksitsayiservis = element.Taksitler
            }
        });
    }
}

function taksitgetirtahsilat(v) {

    var tumliste = []
    tumliste = this.bankapositems

    tumliste.forEach(element => {

        if (element.PosKodu == v) {

            this.taksitsayitahsilat = []
            this.taksitsayitahsilat = element.Taksitler
        }

    });
}

function taksitgetir() {

    if (this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu != null) {
        this.bankapositems.forEach(element => {
            if (element.PosKodu == this.Bilet.OdemeBilgileri.BankaBilgileri.PosKod.PosKodu) {
                this.taksitsayi = element.Taksitler
            }
        });
    }
}


function servisgetir() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    this.servisclass.Cari.Kod = this.Bilet.GenelBilgileri.MusteriKodu.Kod
    this.servisclass.SirketKodu = credentials.SirketKodu
    this.servisclass.Hat = this.Bilet.GenelBilgileri.UcusTipi
    this.servisclass.Parkurlar.Parkur1 = this.Bilet.GenelBilgileri.Parkurlar.Parkur1
    this.servisclass.Parkurlar.Parkur2 = this.Bilet.GenelBilgileri.Parkurlar.Parkur2
    this.servisclass.Parkurlar.Parkur3 = this.Bilet.GenelBilgileri.Parkurlar.Parkur3
    this.servisclass.Parkurlar.Parkur4 = this.Bilet.GenelBilgileri.Parkurlar.Parkur4
    this.servisclass.Parkurlar.Parkur5 = this.Bilet.GenelBilgileri.Parkurlar.Parkur5
    this.servisclass.DefaultKontrol = false

    var params1 = this.servisclass

    this.$http.post(auth.API_URL + 'api/TicketDefinitons/ServiceCodeList', params1, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.servisitems = response.body

    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
        }
    })
    this.servisdialog = true
}

function serviscodeControl() {

    if (this.val != null && this.val != '') {

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        var params1 = {
            CompanyCode: credentials.SirketKodu,
            Type: 307,
            ID: escape(this.val),
        }

        this.$http.post(auth.API_URL + 'api/Definitions/GeneralTypeGet', params1, {
            headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
        }).then((response) => {
            if (response.body.length == 1) {
                this.val = response.body[0].ID
                this.kodmesajı = null
            } else {
                this.kodmesajı = this.$t('Incorrect-code-entry')
                this.val = null
            }
        }, (response) => {
            if (response.status === 0) {
                this.text1 = 'Service Unavailable-analizkodu'
                this.snackbar = true
                this.progress = false
            } else {
                this.text1 = 'Service Unavailable-analizkodu'
                this.snackbar = true
                this.progress = false
            }
        })
    } else {
        this.kodmesajı = null
    }
}

function beforeMount() {
    if (this.$route.query.isl != "get") {
        this.analizCompShow = true
    }
}

function sablondetaygetir(value) {
    this.Sablon.ProfilID = null
    this.sablonobjeler = []

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
        CompanyCode: credentials.SirketKodu,
        TemplateID: this.Sablon.TemplateID
    }

    this.$http.post(auth.API_URL + 'api/Extra/ProfileTemplateDataList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.sablonobjeler = []

        this.tabletumveriler = []
        this.tabloalanisimleri = []
        var ID = {
            text: 'ID',
            value: 'ID',
        }
        this.tabloalanisimleri.push(ID)

        var Sablon = {
            text: 'Şablon ID',
            value: 'SablonID',
        }
        this.tabloalanisimleri.push(Sablon)

        //alan adlarını alalım
        response.body[0].Veriler.forEach(element => {

            var kayit = {
                text: element.AlanAdi,
                value: element.AlanID,
            }
            this.tabloalanisimleri.push(kayit)
        });

        //   this.headers = this.tabloalanisimleri
        var tumveriler = []

        //alanların içeriğini bulalım
        response.body.forEach(element => {

            var i;
            var NewObject = {};
            NewObject['ID'] = element.ID;
            NewObject['SablonID'] = element.SablonID

            for (i = 0; i < element.Veriler.length; i++) {
                NewObject[element.Veriler[i].AlanID] = element.Veriler[i].Veri;
            }
            tumveriler.push(NewObject)

        });
        this.tabletumveriler = tumveriler

        this.itemsprofil = tumveriler

        if (value != null && value != '') {
            this.Sablon.ProfilID = value
            this.Getirdeger(this.Sablon.ProfilID)
        }

    }, (response) => {

        if (response.status === 0) {

            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.detaykont = false
            this.progress = false

        } else {

            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.detaykont = false
            this.progress = false
        }
    })
}

function getDateNow() {

    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
        dd = '0' + dd
    }

    if (mm < 10) {
        mm = '0' + mm
    }

    today = yyyy + '-' + mm + '-' + dd + 'T00:00:00'
    return today
}
</script>

<style>
.v-input__icon {
    width: 11px !important;
    min-width: 11px !important;
}
</style>
